<template>
    <div class="fastFoodDetail" v-scanPayCode="payCode">
        <div class="desk-box">
            <div class="panel">
                <div class="panel-body">
                    <div class="bnt-edit" @click="this.modiRiseShow=true,this.RiseKey=new Date().getTime()"><i class="iconfont icon-pencil-create"></i></div>
                    <div class="tr-li">
                        <div class="td-5" >
                            <i class="iconfont icon-zhuotai" @click="this.choiceDeskShow=true"></i>
                            <key-board-input class="deskName" :keyOptions="{isNumber:true,isKeyDownEnter:true}" isKeyEnterClose isBlurClose v-model="DeskName"/>
                        </div>
                        <div class="td-5" style="padding-left:20px;">
                           <div class="lable-txts">牌号:</div>
                           <div class="from-input fontBold">{{this.headingInfo.brandNumber}}</div>
                        </div>
                    </div>
                    <div class="tr-li">
                        <div class="td-5">
                            <div class="lable-txt">用餐渠道:</div>
                            <div class="channe-bnt from-input">
                                <span :class="{selected:item.OrderChannel_AutoID == Channellike}" 
                                    v-for="item in orderChannel" :key="item" @click="channeClick(item)">{{item.OrderChannel_Name}}</span>
                            </div>
                        </div>
                        <div class="td-5" style="padding-left:20px;">
                            <div class="lable-txtr">人数:</div>
                            <div class="from-input fontBold">{{this.headingInfo.DinersNum}}</div>
                        </div>
                    </div>
                    <div class="tr-li">
                        <div class="remak-5">
                            <div class="lable-txt">订单备注:</div>
                            <div class="from-input fontBold">{{this.headingInfo.orderRemark}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <order-menu-box class="panel panel-table flex-column-box" ref="orderMenu"/>
            <div class="prepaidclass" v-show="this.prepaidshow==true">
                <div class="pre-title">
                    <span class="pre-span">已付明细(合计{{this.paymentHistory.length}}笔,共<span style="color:red;font-size:18px;font-weight:600">￥{{Number(amountPaid).toFixed(2)}}</span>)</span>
                    <span class="pre-x" @click="this.prepaidshow=false">×</span>
                </div>
                <div style="height:250px;overflow-y:scroll;">
                    <div class="prepa-deta" v-for="(pay,index) in paymentHistory" :key="index">
                        <div class="dete-div">
                            <span class="span-pay">{{pay.Payment_Name}}</span>
                            <span class="span-Money">￥{{pay.Payment_Money}}</span>
                            <span class="span-delete" @click="deleteClick(index,pay)">
                                <i class="iconfont icon-shanchu"></i>
                            </span>
                        </div>
                        <div class="div-Oper">
                            <span>{{pay.Operator_Name}}</span>
                            <span class="span-time">{{pay.Time}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer orderFooter">
                <div class="float-left txt">
                    <div style="height:40%;">
                        <span class="money">
                            合计:{{ orderTotal.total.totalMoney }}
                        </span>
                        <span class="moneys">
                            <span class="my">应收:<span class="mytow">￥</span></span>
                            <span class="m">{{orderTotal.total.money}}</span>
                        </span><br/>
                    </div>
                    <div>
                        <span class="money">
                            共{{orderTotal.total.number}}份<span style="font-size:12px;color:#487BB1;left:8px;position:relative;">优惠:{{orderTotal.total.discountMoney}}</span>
                        </span>
                        <span class="moneys" style="left:10px;">
                            <span class="yf" @click="this.prepaidshow=true">已付</span>
                            <span class="yy">￥</span>
                            <span class="amount">{{Number(amountPaid).toFixed(2)}}</span>
                        </span><br/>
                    </div>
                </div>
                <div class="float-right" @mousedown="(e)=>{e.preventDefault()}">
                    <div class="bnt-fangxiang" @click="$refs.orderMenu.pageUp()"><i class="iconfont icon-fangxiangquan-top"></i></div>
                    <div class="bnt-fangxiang" @click="$refs.orderMenu.pageDown()"><i class="iconfont icon-fangxiangquan-bottom"></i></div>
                </div>
            </div>
        </div>
        <div class="operate-button">
            <div class="scroll scrollnot">
                <div class="button-group" v-if="QKOrderMain">
                    <button class="btn" v-for="(item,ProjectItem_Index) in QKOrderMain" :key="ProjectItem_Index" v-show="item.Is_Show"  @click="MiddleMenuClick(item)">
                        <div v-if="item.ProjectItem_Key=='Plus'"><b class="iconfont icon-jia"></b></div>
                        <div v-else-if="item.ProjectItem_Key=='Minus'"><b class="iconfont icon-jian"></b></div>
                        <div v-else>
                            {{item.ProjectItem_Name}}
                        </div>
                        <div v-if="item.ProjectItem_Key=='GetTemporaryStorage' && $cacheData.lockersCache.getLockersList().length>0">
                            <b class="b-Temporary">{{$cacheData.lockersCache.getLockersList().length}}</b>
                        </div>
                        <span class="shortKey" v-if="item.ProjectItem_ShortcutKey">{{item.ProjectItem_ShortcutKey}}</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="menu-box">
            <food-menu-box class="div-box flex-column-box" ref="foodMenu"/>
        </div>
        <modal-list @modalShow="modalShow" @modalClose="modalClose">
            <!-- 收到抹零 -->
            <modal-load :isShow="popShow" :isUnload="true">
                <number-modal :isShow="popShow" title="修改应付金额" :value="totalOrderMoney.unPaidMoney" @close="popShow=false" @confirm="popupReturn"  />
            </modal-load>
            <!-- 菜品要求操作 -->
            <modal-load :isShow="demandShow" :isUnload="true">
                <demand-model  :isShow="demandShow" v-on:closeModel="demandShow=false,BindPosFoods=''" :BindPosFoods="BindPosFoods" :allfoodSubCategorys="allfoodSubCategorys" :orderMenuList="orderMenuList" :foodtype="foodtype"  @confirm="confirm" @BindPosconfirm="BindPosconfirm" :masKindsList="masKindsList" :disRadioOrder="disRadioOrder" >
                </demand-model>
            </modal-load>
            <!-- 全单菜品要求操作 -->
            <modal-load :isShow="demandFullShow" :isUnload="true">
                <demand-full-model  :isShow="demandFullShow" v-on:closeModel="demandFullShow=false" @confirmall="confirmall" :orderMenuList="orderMenuList" :masKindsList="masKindsList" v-if="masKindsList!=null"></demand-full-model>
            </modal-load>
            <!-- 数量 -->
            <modal-load :isShow="adjusquantityShow" :isUnload="true">
                <adjust-quantity-model  :isShow="adjusquantityShow" @closeModel="adjusquantityShow=false,BindPosFoods=''"
                    :modifyPrice="modifyPrice" 
                    :orderMenuList="orderMenuList" 
                    :disRadioOrder="disRadioOrder"
                    :BindPosFoods="BindPosFoods"
                    @quantityReturn="quantityReturn" ></adjust-quantity-model>
            </modal-load>
            <!--辅助单位-->
            <modal-load :isShow="assSizeShow">
                <assist-Size-model  :isShow="assSizeShow" v-on:closeModel="assSizeShow=false" :assistSizeInfo="assistSizeInfo" :orderNumber="orderNumber" @assSizeConfirm="assSizeConfirm" ></assist-Size-model>
            </modal-load>
            <!-- 改价 -->
            <modal-load :isShow="changePriceShow">
                <fast-num-price-model  :isShow="changePriceShow" :isPrice="true" v-on:closeModel="changePriceShow=false,this.checkUser={}" :isCheckOut="false" :disRadioOrder="disRadioOrder" :orderInfo="orderInfo" @changepriceClick="changepriceClick" ></fast-num-price-model>
            </modal-load>
            <!--其他功能-->
            <modal-load :isShow="subShow">
                <sub-Item-Model  :isShow="subShow" v-on:closeModel="subShow=false" :otherFuncList="otherFuncList" :orderInfo="orderInfo" @subItemReturn="subItemReturn" ></sub-Item-Model>
            </modal-load>
            <!--菜品换单位-->
            <modal-load :isShow="unitShow">
                <change-Unit-Model  :isShow="unitShow" v-on:closeModel="unitShow=false" :multipleSizeFoods="theMultipleSizeFoods" @onPlaceFoods="onPlaceFoods" ></change-Unit-Model>
            </modal-load>
            <!-- 提取暂存 -->
            <modal-load :isShow="lockersShow">
                <lockers-model  :isShow="lockersShow" v-on:closeModel="lockersShow=false" @lockersConfirm="lockersConfirm" ></lockers-model>
            </modal-load>
            <!-- 赠送操作 -->
            <modal-load :isShow="giveShow" :isUnload="true">
                <give-return-model  :isShow="giveShow" :isReturn="false" v-on:closeModel="giveShow=false,this.checkUser={}" 
                :disRadioOrder="disRadioOrder" :recordFunctionCheck="recordFunctionCheck" :foodOperationRecord="foodOperationRecord" @GiveFoodFreeClick="GiveFoodFreeClick"
                :checkUser="checkUser"></give-return-model>
            </modal-load>
            <!--Ar支付-->
            <modal-load :isShow="arShow" isUnload>
                <ar-account-Model  :isShow="arShow" v-on:closeModel="arShow=false" 
                    :member="member"
                    :unPaidMoney="unPaidMoney" 
                    :MantissaMoney="MantissaMoney" 
                    :Channellike="Channellike" 
                    :headingInfo="headingInfo" 
                    :choicePayType="choicePayType"
                    :EatAutoID="EatAutoID"
                    :Timestamps="Timestamps"
                    :RoomAutoID="RoomAutoID" :DeskName="DeskName"
                    :orderMenuList="orderMenuList"
                    @submiConfirm="submiConfirm"
                    @subMultipleConfirm="subMultipleConfirm">
                </ar-account-Model>
            </modal-load>
            <!--正品卡券核销-->
            <modal-load :isShow="zpCouponShow" :isUnload="true">
                <zp-couponspay-model
                    :isShow="zpCouponShow" 
                    v-on:closeModel="zpCouponShow=false"
                    :member="member"
                    :MantissaMoney="MantissaMoney" 
                    :Channellike="Channellike" 
                    :unPaidMoney="unPaidMoney"
                    :RoomAutoID="RoomAutoID"
                    :headingInfo="headingInfo" 
                    :DeskName="DeskName"
                    :choicePayType="choicePayType"
                    :orderMenuList="orderMenuList"
                    :EatAutoID="EatAutoID"
                    :Timestamps="Timestamps"
                    @setTimestamps="(time)=>Timestamps=time"
                    @submiConfirm="submiConfirm"
                    @subMultipleConfirm="subMultipleConfirm">
                </zp-couponspay-model>
            </modal-load>
            <!--翼码卡券核销-->
            <modal-load :isShow="ymCouponShow" :isUnload="true">
                <yi-ma-coupons-pay-model 
                    :isShow="ymCouponShow" 
                    v-on:closeModel="ymCouponShow=false"
                    :member="member"
                    :MantissaMoney="MantissaMoney" 
                    :Channellike="Channellike" 
                    :unPaidMoney="unPaidMoney"
                    :RoomAutoID="RoomAutoID"
                    :headingInfo="headingInfo" 
                    :DeskName="DeskName"
                    :choicePayType="choicePayType"
                    :orderMenuList="orderMenuList"
                    :EatAutoID="EatAutoID"
                    :Timestamps="Timestamps"
                    @setTimestamps="(time)=>Timestamps=time"
                    @submiConfirm="submiConfirm"
                    @subMultipleConfirm="subMultipleConfirm"
                />
            </modal-load>
            <!-- 套餐 -->
            <modal-load :isShow="setMealShow" isUnload>
                <set-Meal-model  :isShow="setMealShow" :isDemand="true" 
                    :posFoodData="getPosFoodData" 
                    @closeModel="setMealShow=false" 
                    :tcChangeType="tcChangeType"
                    :disRadioOrder="disRadioOrder" :orderNumber="orderNumber" :posFoodSetMealInfos="posFoodSetMealInfos"  
                    @setMealClick="setMealClick" > </set-Meal-model>
            </modal-load>
            <!--修改抬头-->
            <modal-load :isShow="modiRiseShow">
                <modi-Rise-model  :key="RiseKey" :isShow="modiRiseShow"  :headingInfo="headingInfo" :orderMenuList="orderMenuList"  
                    :memberInfo="meberInfo"
                    v-on:closeModel="modiRiseShow=false" @setDeskclose="setDeskclose"></modi-Rise-model>
            </modal-load>
            <!-- 商品券 或 现金券 选择 -->
            <modal-load :isShow="paymentCouponsShow" :isUnload="true">
                <payment-coupons-model  :isShow="paymentCouponsShow" 
                :data="payCouponsData" 
                :unPaidMoney="unPaidMoney" 
                :orderMenuList="orderMenuList" 
                :choicePayType="choicePayType" 
                :paymentHistory="paymentHistory"
                v-on:closeModel="paymentCouponsShow=false,this.choicePayType=[]"
                @payCouponsConfirm="payCouponsConfirm">
            </payment-coupons-model>
            </modal-load>
            <!-- 扫码付 -->
            <modal-load :isShow="scanCodePay" :isUnload="true">
                <scanCode-Pay-model :isShow="scanCodePay" ref="scanPayModel"
                    :member="member"
                    :orderMenuList="orderMenuList" 
                    :payTypeSSPay="choicePayType"
                    :unPaidMoney="unPaidMoney" 
                    :Channellike="Channellike"
                    :headingInfo="headingInfo"
                    :MantissaMoney="MantissaMoney"
                    :paymentHistory="paymentHistory"
                    :rechargeMoney="0"
                    :EatAutoIDs="EatAutoID"
                    :Timestamps="Timestamps"
                    :RoomAutoID="RoomAutoID" :DeskName="DeskName"
                    @paymentHistoryDelete="paymentHistoryDelete"
                    @scanPaySuccessConfirm="scanPaySuccessConfirm"
                    @ThePaymentResultClic="ThePaymentResultClic"
                    @ThePaymentResultTime="ThePaymentResultTime"
                    v-on:closeModel="scanCodePay=false,this.choicePayType=[]">
                </scanCode-Pay-model>
            </modal-load>
            <!-- 银石预付卡支付 -->
            <modal-load :isShow="yinShiYFPayShow" :isUnload="true">
                <fast-yin-shi-yu-fu-card-Pay-model :isShow="yinShiYFPayShow" 
                    :member="member"
                    :orderMenuList="orderMenuList" 
                    :payTypeSSPay="choicePayType"
                    :unPaidMoney="unPaidMoney" 
                    :Channellike="Channellike"
                    :headingInfo="headingInfo"
                    :MantissaMoney="MantissaMoney"
                    :paymentHistory="paymentHistory"
                    :rechargeMoney="0"
                    :EatAutoIDs="EatAutoID"
                    :Timestamps="Timestamps"
                    :RoomAutoID="RoomAutoID" :DeskName="DeskName"
                    @paymentHistoryDelete="paymentHistoryDelete"
                    @scanPaySuccessConfirm="scanPaySuccessConfirm"
                    @ThePaymentResultClic="ThePaymentResultClic"
                    @ThePaymentResultTime="ThePaymentResultTime"
                    v-on:closeModel="yinShiYFPayShow=false,this.choicePayType=[]"/>
            </modal-load>
            <!-- 银时智能pos 扫码付  -->
            <modal-load :isShow="yinShiPayShow" :isUnload="true">
                <fast-yin-shi-scanCode-Pay-model  :isShow="yinShiPayShow" 
                    :member="member"
                    :orderMenuList="orderMenuList" 
                    :payTypeSSPay="choicePayType"
                    :unPaidMoney="unPaidMoney" 
                    :Channellike="Channellike"
                    :headingInfo="headingInfo"
                    :MantissaMoney="MantissaMoney"
                    :paymentHistory="paymentHistory"
                    :EatAutoIDs="EatAutoID"
                    :Timestamps="Timestamps"
                    :RoomAutoID="RoomAutoID" :DeskName="DeskName"
                    @paymentHistoryDelete="paymentHistoryDelete"
                    @scanPaySuccessConfirm="scanPaySuccessConfirm"
                    @ThePaymentResultClic="ThePaymentResultClic"
                    @ThePaymentResultTime="ThePaymentResultTime"
                    v-on:closeModel="yinShiPayShow=false,this.choicePayType=[]" />
            </modal-load>
            <!--会员支付-->
            <modal-load :isShow="memberPayShow" isUnload>
                <member-payment-model  ref="com"
                    :isShow="memberPayShow" :snackPaidMoney="unPaidMoney" :payType="payType" :choicePayType="choicePayType" :orderMenuList="orderMenuList" 
                    :member="member"
                    :MantissaMoney="MantissaMoney" :paymentHistory="paymentHistory" :EatAutoIDs="EatAutoID" :Timestamps="Timestamps"
                    :headingInfo="headingInfo" :Channellike="Channellike" :RoomAutoID="RoomAutoID" :DeskName="DeskName" :totalMoney="totalMoney" :discountMoneuy="discountMoneuy"
                    @memberCardBack="memberCardBack" @memberCloseModel="memberCloseModel" @paySuccessConfirm="paySuccessConfirm" @ThePaymentResultClic="ThePaymentResultClic"
                    @payMultipleConfirm="payMultipleConfirm" @updatePay="updatePay">
                </member-payment-model>
            </modal-load>
            <!--微生活会员支付-->
            <modal-load :isShow="wlivePayShow" isUnload>
                <wlive-member-payment-model 
                    :isShow="wlivePayShow" :snackPaidMoney="unPaidMoney" :payType="payType" :choicePayType="choicePayType" :orderMenuList="orderMenuList" 
                    :MantissaMoney="MantissaMoney" :paymentHistory="paymentHistory" :EatAutoIDs="EatAutoID" :Timestamps="Timestamps"
                    :headingInfo="headingInfo" :Channellike="Channellike" :RoomAutoID="RoomAutoID" :DeskName="DeskName" :totalMoney="totalMoney" :discountMoneuy="discountMoneuy"
                    @memberCardBack="memberCardBack" @memberCloseModel="memberCloseModel" @paySuccessConfirm="paySuccessConfirm" @ThePaymentResultClic="ThePaymentResultClic"
                    @discountSchemeClic="discountSchemeClic"
                    @updatePay="updatePay">
                </wlive-member-payment-model>
            </modal-load>
            <!--新享会支付-->
            <modal-load :isShow="newEnjoyShow" isUnload>
                <new-enjoy-show-model 
                    :isShow="newEnjoyShow" :snackPaidMoney="unPaidMoney" :payType="payType" :choicePayType="choicePayType" :orderMenuList="orderMenuList" 
                    :MantissaMoney="MantissaMoney" :paymentHistory="paymentHistory" :EatAutoIDs="EatAutoID" :Timestamps="Timestamps"
                    :headingInfo="headingInfo" :Channellike="Channellike" :RoomAutoID="RoomAutoID" :DeskName="DeskName" :totalMoney="totalMoney" :discountMoneuy="discountMoneuy"
                    @memberCardBack="memberCardBack" @memberCloseModel="memberCloseModel" @paySuccessConfirm="paySuccessConfirm" @ThePaymentResultClic="ThePaymentResultClic">
                </new-enjoy-show-model>
            </modal-load>
            <!--海鼎卡-->
            <teleport to="#modal-root" v-if="hdShow">
                <card-abutting-model 
                    :isShow="hdShow" :snackPaidMoney="unPaidMoney" :payType="payType" :choicePayType="choicePayType" :orderMenuList="orderMenuList" 
                    :MantissaMoney="MantissaMoney" :paymentHistory="paymentHistory" :EatAutoIDs="EatAutoID" :Timestamps="Timestamps"
                    :headingInfo="headingInfo" :Channellike="Channellike" :RoomAutoID="RoomAutoID" :DeskName="DeskName" :totalMoney="totalMoney" :discountMoneuy="discountMoneuy"
                    @memberCardBack="memberCardBack" @memberCloseModel="memberCloseModel" @paySuccessConfirm="paySuccessConfirm" @ThePaymentResultClic="ThePaymentResultClic"
                    @discountSchemeClic="discountSchemeClic" @CancelDiscountConfirm="cancelDiscount" @payMultipleConfirm="payMultipleConfirm">
                </card-abutting-model>
            </teleport>
            <!-- 折扣方案 -->
            <modal-load :isShow="discountShow" :isUnload="true">
                <discount-model :isShow="discountShow"  
                    v-on:closeModel="discountShow=false" 
                    :orderMenuList="orderMenuList" :checkUser="checkUser" :discountSchemeList="discountScheme" :recordFunctionCheck="recordFunctionCheck" 
                    :paymentHistory="paymentHistory" :disRadioOrder="disRadioOrder"
                    :Running_ReadCardToDiscount_YN="Running_ReadCardToDiscount_YN"
                    @discountSchemeClic="discountSchemeClic" @CancelDiscountConfirm="CancelDiscountConfirm">
                </discount-model>
            </modal-load>
            <!--选择桌号-->
            <modal-load :isShow="choiceDeskShow">
                <choice-Desk-Model  :isShow="choiceDeskShow" v-on:closeModel="choiceDeskShow=false" @deskclose="deskclose">
                </choice-Desk-Model>
            </modal-load>
            <!--付款弹窗-->
            <modal-load :isShow="paymentShow" isUnload>
                <paymentlayer-model  :isShow="paymentShow" 
                    :unPaidMoney="unPaidMoney" 
                    :choicePayType="choicePayType"
                    :totalOrderMoney="totalOrderMoney"
                    :key="payMoneyKey"
                    v-on:closeModel="paymentShow=false,this.choicePayType=[]"
                    @cashConfirm="cashConfirm">
                </paymentlayer-model>
            </modal-load>
            <!--权限验证:disRadioOrder="disRadioOrder"-->
            <modal-load :isShow="checkShow" :isUnload="true">
                <check-user-button-model :isShow="checkShow" v-on:closeModel="checkShow=false" 
                    :checkBtnlist="checkBtnlist" 
                    :orderType="1"
                @checkbtnReturn="checkbtnReturn"></check-user-button-model>
            </modal-load>
            
            <!-- 卡券核销 -->
            <modal-load :isShow="couponVerifyShow" isUnload>
                <coupon-verify-model :isShow="couponVerifyShow"  @close="couponVerifyShow=false"
                    :headingInfo="headingInfo"
                    :DeskName="DeskName" :DeskAutoID="headingInfo?.DeskAutoID"
                    :RoomAutoID="RoomAutoID"
                    :allfoodSubCategorys="allfoodSubCategorys" @confirm="couponsReturn" />
            </modal-load>
            <!--KLCOUPON 昆仑卡券核销-->
            <modal-load :isShow="klCouponShow" :isUnload="true">
                <kunlun-couponspay-model
                    :isShow="klCouponShow" 
                    v-on:closeModel="klCouponShow=false"
                    :orderInfo="orderInfo" 
                    :RoomAutoID="RoomAutoID"
                    @KunLunCouponsReturn="couponsReturn">
                </kunlun-couponspay-model>
            </modal-load>
            <!-- 昆仑会员支付 -->
            <modal-load :isShow="kunlunPayShow" isUnload>
                <fast-kun-lun-member-pay-model 
                    :isShow="kunlunPayShow" 
                    :payType="payType" 
                    :snackPaidMoney="unPaidMoney" :choicePayType="choicePayType" :orderMenuList="orderMenuList" 
                    :MantissaMoney="MantissaMoney" :paymentHistory="paymentHistory" :EatAutoIDs="EatAutoID" :Timestamps="Timestamps"
                    :headingInfo="headingInfo" :Channellike="Channellike" :RoomAutoID="RoomAutoID" :DeskName="DeskName" :totalMoney="totalMoney" :discountMoneuy="discountMoneuy"
                    @memberCardBack="memberCardBack" @close="kunlunPayShow=false" @paySuccessConfirm="paySuccessConfirm" @ThePaymentResultClic="ThePaymentResultClic" 
                    @payMultipleConfirm="kunlunMultipleConfirm"
                />
            </modal-load>
            <!-- 科码会员支付 -->
            <modal-load :isShow="keMaPayShow" isUnload>
                <fast-ke-ma-member-pay-model 
                    :isShow="keMaPayShow" 
                    :payType="payType" 
                    :snackPaidMoney="unPaidMoney" :choicePayType="choicePayType" :orderMenuList="orderMenuList" 
                    :MantissaMoney="MantissaMoney" :paymentHistory="paymentHistory" :EatAutoIDs="EatAutoID" :Timestamps="Timestamps"
                    :headingInfo="headingInfo" :Channellike="Channellike" :RoomAutoID="RoomAutoID" :DeskName="DeskName" :totalMoney="totalMoney" :discountMoneuy="discountMoneuy"
                    @memberCardBack="memberCardBack" @close="keMaPayShow=false" @paySuccessConfirm="paySuccessConfirm" @ThePaymentResultClic="ThePaymentResultClic" 
                    @payMultipleConfirm="payMultipleConfirm"
                    @ThePaymentResultTime="ThePaymentResultTime"
                />
            </modal-load>
            <!--大拈会员支付-->
            <modal-load :isShow="daNianPayShow" isUnload>
                <fast-da-nian-pay-model 
                    :isShow="daNianPayShow" :snackPaidMoney="unPaidMoney" :payType="payType" :choicePayType="choicePayType" :orderMenuList="orderMenuList" 
                    :MantissaMoney="MantissaMoney" :paymentHistory="paymentHistory" :EatAutoIDs="EatAutoID" :Timestamps="Timestamps"
                    :discountSchemeList="discountScheme" 
                    :headingInfo="headingInfo" :Channellike="Channellike" :RoomAutoID="RoomAutoID" :DeskName="DeskName" :totalMoney="totalMoney" :discountMoneuy="discountMoneuy"
                    @memberCardBack="memberCardBack" @close="daNianPayShow=false" @paySuccessConfirm="paySuccessConfirm" @ThePaymentResultClic="ThePaymentResultClic"
                    @discountSchemeClic="discountSchemeClic" @payMultipleConfirm="payMultipleConfirm" />
            </modal-load>
            <!--G9会员卡支付-->
            <modal-load :isShow="gNinePayShow" isUnload>
                <fast-g-payment-model
                    :isShow="gNinePayShow" 
                    :snackPaidMoney="unPaidMoney" :payType="payType" :choicePayType="choicePayType" :orderMenuList="orderMenuList" 
                    :MantissaMoney="MantissaMoney" :paymentHistory="paymentHistory" :EatAutoIDs="EatAutoID" :Timestamps="Timestamps"
                    :headingInfo="headingInfo" :Channellike="Channellike" :RoomAutoID="RoomAutoID" :DeskName="DeskName" :totalMoney="totalMoney" :discountMoneuy="discountMoneuy"
                    @memberCardBack="memberCardBack" @close="gNinePayShow=false" @paySuccessConfirm="paySuccessConfirm" @ThePaymentResultClic="ThePaymentResultClic"
                    @discountSchemeClic="discountSchemeClic" @payMultipleConfirm="payMultipleConfirm"/>
            </modal-load>
            <!-- 西软XMS储值支付  -->
            <modal-load :isShow="westStoredShow" isUnload>
                <fast-west-stored-model 
                    :isShow="westStoredShow" 
                    :snackPaidMoney="unPaidMoney" :payType="payType" :choicePayType="choicePayType" :orderMenuList="orderMenuList" 
                    :MantissaMoney="MantissaMoney" :paymentHistory="paymentHistory" :EatAutoIDs="EatAutoID" :Timestamps="Timestamps"
                    :headingInfo="headingInfo" :Channellike="Channellike" :RoomAutoID="RoomAutoID" :DeskName="DeskName" :totalMoney="totalMoney" :discountMoneuy="discountMoneuy"
                    @memberCardBack="memberCardBack" @close="westStoredShow=false" @paySuccessConfirm="paySuccessConfirm" @ThePaymentResultClic="ThePaymentResultClic"
                    @discountSchemeClic="discountSchemeClic" @payMultipleConfirm="payMultipleConfirm"/>
            </modal-load>
            <!-- 通用会员支付 -->
            <modal-load :isShow="defaultPayShow" isUnload>
                <default-member-pay-model 
                    :isShow="defaultPayShow" 
                    :payType="payType" 
                    :snackPaidMoney="unPaidMoney" :choicePayType="choicePayType" :orderMenuList="orderMenuList" 
                    :MantissaMoney="MantissaMoney" :paymentHistory="paymentHistory" :EatAutoIDs="EatAutoID" :Timestamps="Timestamps"
                    :headingInfo="headingInfo" :Channellike="Channellike" :RoomAutoID="RoomAutoID" :DeskName="DeskName" :totalMoney="totalMoney" :discountMoneuy="discountMoneuy"
                    @memberCardBack="memberCardBack" @close="defaultPayShow=false" @paySuccessConfirm="paySuccessConfirm" @ThePaymentResultClic="ThePaymentResultClic" 
                    @discountSchemeClic="discountSchemeClic" @payMultipleConfirm="payMultipleConfirm"
                />
            </modal-load>
            <!--西软卡券核销-->
            <modal-load :isShow="westStoredCouponShow" isUnload>
                <fast-west-soft-couponspay-model
                    :isShow="westStoredCouponShow" 
                    @closeModel="westStoredCouponShow=false"
                    :member="member"
                    :MantissaMoney="MantissaMoney" 
                    :Channellike="Channellike" 
                    :unPaidMoney="unPaidMoney"
                    :RoomAutoID="RoomAutoID"
                    :headingInfo="headingInfo" 
                    :DeskName="DeskName"
                    :choicePayType="choicePayType"
                    :orderMenuList="orderMenuList"
                    :EatAutoID="EatAutoID"
                    :Timestamps="Timestamps"
                    @setTimestamps="(time)=>Timestamps=time"
                    @submiConfirm="submiConfirm"
                    @subMultipleConfirm="subMultipleConfirm"
                />
            </modal-load>
            <!-- 组合菜品 -->
            <combo-food-model :isShow="isComboFoodShow" 
                :data="comboFoodInfo" 
                :editInfo="editComboFoodInfo"
                :posFoodData="getPosFoodData" 
                @close="isComboFoodShow=false"
                @confirm="comboConfirm"/>
            
            <!-- 取餐叫号 -->
            <modal-load :isShow="callCheckShow" isUnload>
                <call-check-num-model 
                    :isShow="callCheckShow" @close="callCheckShow=false" />
            </modal-load>
            <!-- BankPos操作 -->
            <modal-load :isShow="bankPosShow">
                <bank-pos-model :isShow="bankPosShow" @close="bankPosShow=false;"/>
            </modal-load>
            <!-- 扫码订单核销 -->
            <modal-load :isShow="scanOrderShow" isUnload>
                <scan-code-order-model :isShow="scanOrderShow" @close="scanOrderShow=false"/>
            </modal-load>
            <!--华侨城二消券核销-->
            <modal-load :isShow="hqCouponShow" :isUnload="true">
                <hqcex-couponspay-model
                    :isShow="hqCouponShow" 
                    @close="hqCouponShow=false"
                    :member="member"
                    :MantissaMoney="MantissaMoney" 
                    :Channellike="Channellike" 
                    :unPaidMoney="unPaidMoney"
                    :RoomAutoID="RoomAutoID"
                    :headingInfo="headingInfo" 
                    :DeskName="DeskName"
                    :choicePayType="choicePayType"
                    :orderMenuList="orderMenuList"
                    :EatAutoID="EatAutoID"
                    :Timestamps="Timestamps"
                    @setTimestamps="(time)=>Timestamps=time"
                    @submiConfirm="submiConfirm"
                    @subMultipleConfirm="subMultipleConfirm"/>
            </modal-load>
            <!-- 光明爱护网折扣 -->
            <modal-load :isShow="aiHuShow" :isUnload="true">
                <guang-ming-ai-hu-model
                    :isShow="aiHuShow" 
                    :orderMenuList="orderMenuList" 
                    @discountConfirm="aiHuDiscountConfirm"
                    @close="aiHuShow=false"
                />
            </modal-load>
            <!-- 商旅会员折扣权益核销 -->
            <modal-load :isShow="shangLvZKShow" :isUnload="true">
                <shang-lv-discount-model
                    :isShow="shangLvZKShow" 
                    :orderMenuList="orderMenuList" 
                    @discountConfirm="discountSchemeClic"
                    @close="shangLvZKShow=false"
                />
            </modal-load>
            <!-- 免单 支付 -->
            <modal-load :isShow="freeShippingShow" isUnload>
                <fast-free-shipping-model :isShow="freeShippingShow"
                    :unPaidMoney="unPaidMoney" 
                    :choicePayType="choicePayType"
                    :totalOrderMoney="totalOrderMoney"
                    @cashConfirm="cashConfirm"
                    @close="payHide('freeShippingShow')"/>
            </modal-load>
            <!-- 由由ai 识别菜品添加 -->
            <modal-load :isShow="aiAddItemShow" :isUnload="true">
                <ai-add-item-confirm-model :isShow="aiAddItemShow"
                    :data="aiAddItemData"
                    :orderNumber="orderNumber"
                    :wgNum="wgNum"
                    @close="aiAddItemShow=false;aiSearchText=null;"
                    @confirm="aiAddItemConfirm"/>
            </modal-load>
        </modal-list>
        <analog-key-board ref="keyBoard"></analog-key-board>
    </div>
</template>
<script>

import { newGuid,NumberConversion,submitting } from '/src/common' 

import DemandModel from '../diningDetail/demandModel/demandModel.vue'
import adjustQuantityModel from '../diningDetail/adjustQuantityModel/adjustQuantityModel.vue'
import assistSizeModel from '../diningDetail/assistSizeModel/assistSizeModel.vue'
import subItemModel from '../diningDetail/subItemModel/subItemModel.vue'
import fastNumPriceModel from './fastNumPriceModel/fastNumPriceModel.vue'
import changeUnitModel from '../diningDetail/changeUnitModel/changeUnitModel.vue'
import DemandFullModel from '../diningDetail/demandFullModel/demandFullModel.vue'
import lockersModel from '../diningDetail/lockersModel/lockersModel.vue'
import modiRiseModel from './modiRiseModel/modiRiseModel.vue'
import setMealModel from '../diningDetail/setMealModel/setMealModel.vue'
import giveReturnModel from './giveReturnModel/giveReturnModel.vue'
import arAccountModel from './arAccountModel/arAccountModel.vue'
import scanCodePayModel from './scanCodePayModel/scanCodePayModel.vue'
import MemberPaymentModel from './memberPaymentModel/memberPaymentModel.vue'
import discountModel from './discountModel/discountModel.vue'
import choiceDeskModel from './choiceDeskModel/choiceDeskModel.vue'
import paymentlayerModel from './paymentlayerModel/paymentlayerModel.vue'
import wliveMemberPaymentModel from './wliveMemberPaymentModel/wliveMemberPaymentModel.vue'
import paymentCouponsModel from './paymentCouponsModel/paymentCouponsModel.vue'
import newEnjoyShowModel from './newEnjoyShowModel/newEnjoyShowModel.vue'
import cardAbuttingModel from './cardAbuttingModel/cardAbuttingModel.vue'
import checkUserButtonModel from '../../checkUserRightModel/checkUserButtonModel.vue'
import zpCouponspayModel from './zpCouponspayModel/zpCouponspayModel.vue'
import yiMaCouponsPayModel from './yiMaCouponsPayModel/yiMaCouponsPayModel.vue'
import kunlunCouponspayModel from './kunlunCouponspayModel/kunlunCouponspayModel.vue'
import fastKunLunMemberPayModel from './fastKunLunMemberPayModel/fastKunLunMemberPayModel.vue'
import comboFoodModel from '../diningDetail/comboFoodModel/comboFoodModel.vue'
import orderMenuBox from './orderMenuBox.vue'
import foodMenuBox from './foodMenuBox.vue'
import fastDaNianPayModel from './fastDaNianPayModel/fastDaNianPayModel.vue'
import fastGPaymentModel from './fastGPaymentModel/fastGPaymentModel.vue'
import callCheckNumModel from './callCheckNumModel/callCheckNumModel.vue'
import fastYinShiScanCodePayModel from './fastYinShiScanCodePayModel/fastYinShiScanCodePayModel.vue'
import couponVerifyModel from './couponVerifyModel/couponVerifyModel.vue'
import bankPosModel from '../diningDetail/bankPosModel/bankPosModel.vue'
import scanCodeOrderModel from './scanCodeOrderModel/scanCodeOrderModel.vue'
import fastYinShiYuFuCardPayModel from './fastYinShiYuFuCardPayModel/fastYinShiYuFuCardPayModel.vue'
import fastWestStoredModel from './fastWestStoredModel/fastWestStoredModel.vue'
import fastWestSoftCouponspayModel from './fastWestSoftCouponspayModel/fastWestSoftCouponspayModel.vue'
import fastFreeShippingModel from './fastFreeShippingModel/fastFreeShippingModel.vue'
import hqcexCouponspayModel from './hqcexCouponspayModel/hqcexCouponspayModel.vue'
import aiAddItemConfirmModel from './aiAddItemConfirmModel/aiAddItemConfirmModel.vue'
import guangMingAiHuModel from './guangMingAiHuModel/guangMingAiHuModel.vue'
import fastKeMaMemberPayModel from './fastKeMaMemberPayModel/fastKeMaMemberPayModel.vue'
import shangLvDiscountModel from './shangLvDiscountModel/shangLvDiscountModel.vue'
import defaultMemberPayModel from './defaultMemberPayModel/defaultMemberPayModel.vue'


/**全局初始化数据 */
let _data={
    MergeSameFoodInOrder:false,/**点单时,相同菜品自动合并一行 */
    FastFoodMantissaAdjustKind:0,/**快餐尾数调整方式*/
    RunFastFoodMustChooseDeskNo:false,/**快餐业态,下单必选桌号 */
    RunFastFoodWithSignCard:false,/**快餐业态启用牌号功能 */
    Running_DtFoodCard_YN:false,/**是否启用读卡点菜功能*/
    Running_ReadCardToDiscount_YN:false,//是否开启读卡全单打折， true:开启 false:未开启
};


export default {
    name:"fastFoodDetail",
    components:{
        DemandModel,
        adjustQuantityModel,
        assistSizeModel,
        subItemModel,
        fastNumPriceModel,
        changeUnitModel,
        DemandFullModel,
        lockersModel,
        modiRiseModel,
        setMealModel,
        giveReturnModel,
        arAccountModel,
        scanCodePayModel,
        MemberPaymentModel,
        discountModel,
        choiceDeskModel,
        paymentlayerModel,
        wliveMemberPaymentModel,
        paymentCouponsModel,
        newEnjoyShowModel,
        cardAbuttingModel,
        checkUserButtonModel,
        zpCouponspayModel,
        yiMaCouponsPayModel,
        kunlunCouponspayModel,
        fastKunLunMemberPayModel,
        comboFoodModel,
        orderMenuBox,
        foodMenuBox,
        fastDaNianPayModel,
        fastGPaymentModel,
        callCheckNumModel,
        fastYinShiScanCodePayModel,
        couponVerifyModel,
        bankPosModel,
        scanCodeOrderModel,
        fastYinShiYuFuCardPayModel,
        fastWestStoredModel,
        fastWestSoftCouponspayModel,
        fastFreeShippingModel,
        hqcexCouponspayModel,
        aiAddItemConfirmModel,
        guangMingAiHuModel,
        fastKeMaMemberPayModel,
        shangLvDiscountModel,
        defaultMemberPayModel
    },
    data() {
        let globalSysSetting= this.$cacheData?.globalVariable?.GlobalSysSetting;
        if(globalSysSetting){
            _data.MergeSameFoodInOrder = globalSysSetting.MergeSameFoodInOrder;
            _data.FastFoodMantissaAdjustKind = globalSysSetting.FastFoodMantissaAdjustKind,
            _data.RunFastFoodMustChooseDeskNo = globalSysSetting.RunFastFoodMustChooseDeskNo,
            _data.RunFastFoodWithSignCard = globalSysSetting.RunFastFoodWithSignCard,
            _data.Running_DtFoodCard_YN=globalSysSetting.Running_DtFoodCard_YN;
            _data.Running_ReadCardToDiscount_YN=globalSysSetting.Running_ReadCardToDiscount_YN
        }
        return {
            /**记录 ai 识别菜品添加 是否完成  */
            isAiAddItem:false,
            aiAddItemData:null,
            /**由由ai 识别菜品添加 弹层 */
            aiAddItemShow:false,
            demandShow:false,
            adjusquantityShow:false,
            assSizeShow:false,
            subShow:false,
            changePriceShow:false,
            unitShow:false,
            demandFullShow:false,
            lockersShow:false,
            modiRiseShow:false,
            setMealShow:false,
            giveShow:false,
            arShow:false,
            scanCodePay:false,
            //银石预付卡支付 弹层
            yinShiYFPayShow:false,
            //银时智能pos支付 弹层
            yinShiPayShow:false,
            memberPayShow:false,
            cardPriceShow:false,
            discountShow:false,
            choiceDeskShow:false,
            paymentShow:false,
            wlivePayShow:false,
            paymentCouponsShow:false,
            newEnjoyShow:false,
            hdShow:false,
            zpCouponShow:false,/**正品卡券弹层 */
            ymCouponShow:false,/**翼码卡券弹层 */
            klCouponShow:false,/**昆仑卡券弹层 */
            hqCouponShow:false,//华侨城二消券核销 弹层
            aiHuShow:false,//光明爱护网折扣 弹层
            shangLvZKShow:false,//商旅会员折扣权益核销 弹层
            /**昆仑会员卡弹层 */
            kunlunPayShow:false,
            /**科码会员支付 */
            keMaPayShow:false,
            daNianPayShow:false,//大拈会员支付
            gNinePayShow:false,//G9 会员支付
            westStoredShow:false,//西软XMS储值支付
            westStoredCouponShow:false,//西软卡券核销
            defaultPayShow:false,//通用会员支付 弹层
            /**免单 */
            freeShippingShow:false,
            RiseKey:'',
            payMoneyKey:'',
            /**点菜界面竖排自定义按钮 */
            QKOrderMain:[],
            /**大类数据 */
            foodMainCategory:[],
            //菜品数据 
            posFoodData:{},
             /**辅助菜品 */
            assistSizeInfo:Object,
            /**套餐菜品操作默认0 选择套餐,1.未下单套餐退菜 */
            tcChangeType:0,
            /**对应套餐数据 */
            posFoodSetMealInfos:[],
            money:'',
            checOutShow:'height:calc(100% - 100px - 5px)',
            isCheckOutclass:'panel-body',
            disRadioclass:-1, //是否选中
            foodSetmealsclass:-1, //套餐里的菜品选中
            foodtype:0,
            disRadioOrder:'',  //选中的菜品
            discountScheme:'', //折扣方案
            masKindsList:'', //菜品口味
             /**菜品组合信息 */
            comboFoodList:[],
            /**要修改的组合菜品 信息 */
            editComboFoodInfo:null,
            /**菜品组合 弹层 */
            isComboFoodShow:false,
            //选中的菜品 组合数据
            comboFoodInfo:null,
            //取餐叫号弹层
            callCheckShow:false,
            //卡券核销弹层
            couponVerifyShow:false,
            /***商品券 或 现金券 显示数据 */
            payCouponsData:{},
            /**用户数据 */
            userInfo:'',
            /**订单数据 */
            orderInfo:{},
            /**订单菜单集合 */
            orderMenuList:[],
            Temporaryorder:[],
            /**临时存放订单菜品的集合 */
            TemporderMenuList:[],
            /**返回的全单菜品做法口味选择 */
            masKinds:[],
            /**支付类型 */
            PayKinds:[],
            payType:[],
            /**选中的支付id */
            ispayid:0,//
            /**选中的支付类型 */
            choicePayType:[],
            /**聚合支付类型 */
            payTypeSSPay:[],
            /**菜品检索 */
            varietySelect:'',
            //记录上一次检索 不记录则按菜品检索
            oldVarietySelect:"",
            /**用户姓名 */
            Login_Name:'',
            /**多规格菜品 */
            multipleSizeFoods:[],
            theMultipleSizeFoods:'',
            /**其他功能按钮 */
            otherFuncList:'',
            readyShowType:0,
            /**是否启用了会员价 */
            carPriceType:false,//是否开启会员价
            /**套餐内菜品选择 */
            choicefoodOrder:'',
            /**桌台 */
            DeskName:'',
            /**餐厅数据 */
            PosRooms:[],
            /**餐厅ID */
            RoomAutoID:'',
            /**会员信息 */
            cardMemberList:'',
            /**绑定做法菜品 */
            BindPosFoods:'',
            /**权限验证临时保存ID和操作员 */
            tempUserId:'',
            tempOperatorName:'',
            prepaidshow:false,
            orderChannel:[], /**用餐渠道 */
            ChanneList:[],
            Channellike:'',/**选择的渠道 */
            DefaultChannelID:'',
            // totalMoney:0,/**合计金额 */
            // unPaidMoney:0,/**未付金额 */
            // MantissaMoney:0, /***尾数调整金额 */
            // discountMoneuy:0,/**折扣的优惠金额 */
            //countNumber:0,/**总份数 */
            headingInfo:{
                DeskName:'',
                DeskAutoID:'',
                RoomAutoID:'',
                DinersNum:1,
                orderChannelName:'',
                OrderChannel_AutoID:'',
                brandNumber:'',
                orderRemark:''
            }, /**修改台头返回 */
            eatCheckIndex:'',/**结账单号 */
            paymentHistory:[], /**支付记录保存 */
            payinvoicing:'', /**结账 */
            EatAutoID:'', /**订单ID，当单据重新处理时需要传入 */
            Timestamps:'',/**订单单时间戳 */
            meberInfo:null,/**会员信息 */
            isAbnormal:false,/**是否是异常单穿透过来的 */
            Rpt_Date:"",
            /**结账界面横排自定义功能按钮 */
            userCheckOutMenu:[],
            foodOperationRecord:[],/**菜品操作记录 */
            IsMultipleCardPay:false, /**是否触发多卡支付 */
            mallMethod:[], //全单口味做法
            aloneMethod:[], //单独口味做法
            MethodNumList:[],//同步临时保存的口味做法数量
            orderNumber:'',//点单界面数量
            wgNum:0,//称重
            recordFunctionCheck:'', //记录选择的功能按钮
            merCouponFood:[],//使用的商品券和支付记录直接的对应关系记录.退款冲销使用
            /**权限弹框 */
            checkShow:false,
            checkBtnlist:'',
            checkUser:{},
            Running_ReadCardToDiscount_YN:_data.Running_ReadCardToDiscount_YN,
            //ai检索 多个
            aiSearchText:[],
            //是否启用ai识别点菜
            isAiEnable:false,
            /**BankPos操作*/
            bankPosShow:false,
            /**扫码订单核销 */
            scanOrderShow:false,
            /**手动调整应付金额 弹层 */
            popShow:false,
            /**手动调整 金额 0 */
            Mantissa_Money:0
        }
    },
    computed:{
        sysSetting(){
            return this.$cacheData?.globalVariable?.GlobalSysSetting||{};
        },
        /**全部小类 只有id与名称 */
        allfoodSubCategorys(){
            let all=[];//全部小类
            this.getPosFoodData?.forEach(category=> {
                category.FoodSubCategorys?.forEach(sub=>{
                    let _SubCategory={SubCategory_Name:sub.SubCategory_Name,SubCategory_ID:sub.SubCategory_ID};//只记录分类名称
                    all.push(_SubCategory);
                })
            });
            return all;
        },
        //全部菜品
        foodAll(){
            let all=[];
            this.getPosFoodData?.forEach(category=>{
                category?.FoodSubCategorys?.forEach(sub=>{
                    sub?.PosFoods?.forEach(it=>{
                        it.SubCategory_Code=sub.SubCategory_Code;
                        all.push(it);
                    })
                })
            })
            return all;
        },
        getPosFoodData(){
            return this.posFoodData.data||[];
        },
        //判断是否有弹出层出现
        isModalShow(){
            if(this.demandShow || this.demandFullShow || this.demandFullShow || this.assSizeShow 
                || this.changePriceShow || this.subShow || this.unitShow || this.lockersShow 
                || this.giveShow || this.arShow || this.setMealShow || this.modiRiseShow 
                || this.paymentCouponsShow || this.scanCodePay || this.memberPayShow || this.wlivePayShow 
                || this.discountShow || this.choiceDeskShow || this.paymentShow || this.adjusquantityShow
                || this.newEnjoyShow || this.hdShow || this.isComboFoodShow || this.kunlunPayShow ||this.daNianPayShow || this.gNinePayShow || this.keMaPayShow
                || this.callCheckShow || this.yinShiPayShow || this.couponVerifyShow || this.bankPosShow || this.scanOrderShow
                || this.yinShiYFPayShow || this.westStoredShow || this.westStoredCouponShow || this.hqCouponShow || this.aiHuShow || this.shangLvZKShow
                || this.aiAddItemShow || this.freeShippingShow || this.defaultPayShow
            ){
                return true;
            }
            return false;
        },
        /**判断 支付弹层是否显示 */
        isPayMoadlShow(){
            if(this.arShow || this.scanCodePay || this.memberPayShow || this.newEnjoyShow 
                || this.wlivePayShow || this.hdShow || this.paymentCouponsShow ||  this.paymentShow || this.yinShiPayShow
                || this.yinShiYFPayShow || this.freeShippingShow || this.hqCouponShow
            ){
                return true;
            }
            return false;
        },
        /**已付金额 */
        amountPaid(){
            let totalMoney=0;
            this.paymentHistory?.forEach(pay=>{
                totalMoney = Number(pay?.Payment_Money).compute(totalMoney);
            })
            return Number(totalMoney.toFixed(4));
        },
        //合计订单金额
        totalOrderMoney(){
            let total={
                totalMoney:0,//结账总金额
                unPaidMoney:0,//应收金额
                MantissaMoney:0,//位数调整金额
                countNumber:0,//菜品份数
                discountMoneuy:0,//优惠金额
                sumMoney:0,//消费金额
            };
            let sumMoney=0;//销售总金额
            if(this.orderMenuList?.length>0){
                this.orderMenuList.forEach(order=>{
                    if(order.isPromotion2){//第二份折扣
                        total.totalMoney =Number(total.totalMoney).compute(order.zkPromotionPrice * Number(order.Eat_Number));
                    }else{
                        total.totalMoney =Number(total.totalMoney).compute(order.Eat_CheckPrice * Number(order.Eat_Number));
                    }
                    
                    sumMoney=Number(sumMoney).compute(Number(order.Eat_SalePrice||0) * Number(order.Eat_Number||0));
                    total.countNumber =Number(total.countNumber).compute(Number(order.Eat_Number||0));
                    if(order?.FoodSetmeals){
                        order.FoodSetmeals.forEach(food=>{
                            total.totalMoney = Number(total.totalMoney).compute(food.FoodSetmeal_Price * Number(food.FoodSetmeal_Number));
                            sumMoney=Number(sumMoney).compute(food.FoodSetmeal_Price * Number(food.FoodSetmeal_Number));
                        })
                    }
                    
                })
                
                total.totalMoney = Number(total.totalMoney.toFixed(2))
                total.countNumber=Number(total.countNumber.toFixed(4));
                if(this.$refs.orderMenu?.fullReductionMoney>0){//计算满减
                    total.totalMoney=Number(Number(total.totalMoney).compute(-this.$refs.orderMenu?.fullReductionMoney).toFixed(2));
                }
                sumMoney=Number(sumMoney.toFixed(2));
                total.discountMoneuy= Number(Number(sumMoney).compute(-total.totalMoney).toFixed(2));//优惠金额
            }
            total.sumMoney=sumMoney;
            if(this.Mantissa_Money>0){//手动调整过了 有尾数调整金额
                total.unPaidMoney=Number(total.totalMoney).compute(-this.Mantissa_Money);
            }else{
                //计算尾数调整
                total.unPaidMoney=this.$global.mantissaAdjust(_data.FastFoodMantissaAdjustKind,total.totalMoney);
            }
            //尾数调整金额 = 应收 - 结账总金额
            total.MantissaMoney=Number(Number(total.unPaidMoney).compute(-total.totalMoney).toFixed(4));

            //应收-已支付金额
            total.unPaidMoney=Number(Number(total.unPaidMoney).compute(-this.amountPaid).toFixed(2));

            if(total.unPaidMoney<=0){
                total.unPaidMoney=0
            }
            //this.money = total.unPaidMoney;

            return total;
        },
        /**订单信息 + 金额合计 显示用*/
        orderTotal(){
            return {
                showType:1,
                bill:JSON.parse(JSON.stringify(this.orderMenuList)),//订单菜品信息 
                total:{
                    totalMoney:Number(this.totalOrderMoney.totalMoney).compute(this.totalOrderMoney.discountMoneuy).toFixed(2),//合计金额
                    number:this.totalOrderMoney.countNumber,//多少份
                    discountMoney:Number(this.totalOrderMoney.discountMoneuy).compute(this.totalOrderMoney.MantissaMoney * -1).toFixed(2),//优惠
                    money:this.totalOrderMoney.unPaidMoney.toFixed(2)//应收
                }
            }
        },
        /**合计金额 */
        totalMoney(){
            return this.totalOrderMoney.totalMoney;
        },
        /**未付金额 */
        unPaidMoney(){
            return this.totalOrderMoney.unPaidMoney;
        },
        /***尾数调整金额 */
        MantissaMoney(){
            return this.totalOrderMoney.MantissaMoney;
        }, 
        /**折扣的优惠金额 */
        discountMoneuy(){
            return this.totalOrderMoney.discountMoneuy;
        },
        /**总份数 */
        countNumber(){
            return this.totalOrderMoney.countNumber;
        },
        /**会员信息 支付预览用 */
        member(){
            let _meberInfo=null;
            if(this.meberInfo && this.meberInfo!=''){
                _meberInfo={
                    Member_Sys:this.meberInfo?.Member_Sys, //会员系统类型 2：正品CRM3.0，4：微生活
                    DynamicType:this.meberInfo.DynamicType, //查询码类型 5i会员类型：1手机会员、2卡会员
                    Card_AutoID:this.meberInfo.Bestech_Card_AutoID, //卡主键
                    Card_No:this.meberInfo.Card_No, //卡号
                    Member_Name:this.meberInfo.MemberName, //姓名
                    MemberCard_Kind:this.meberInfo.Bestech_Card_KindName, //会员等级
                    Mobile:this.meberInfo.Mobile,//会员手机号
                    NotJoinPointProgram:false,//不参与线上积分
                    Invoice_Money:0, //本次消费开票金额
                    Invoice_No:'',//发票号码
                }
            }
            return _meberInfo;
        },
        //改价权限
        modifyPrice(){
            let modifyPrice=null;
            this.QKOrderMain?.some(it=>{
                if(it.ProjectItem_Key=='ModifyPrice'){
                    modifyPrice=it;
                }else if(it.ProjectItem_Key== "OtherFunc"){
                    let item= it.SysProjectSubItems?.find(item=>item.ProjectSubItem_Key=='ModifyPrice');
                    if(item){
                        modifyPrice=item;
                    }
                }
                return modifyPrice!=null;
            })
            return modifyPrice;
        }
    },
    created(){
       document.addEventListener("keydown",this.keydown)
    },
    /**当前位置的组件将要离开时触发 */
    beforeRouteLeave(to, from, next) {
        if(to.params?.isForced){//强制离开
            next();
            return ;
        }
        if(this.orderMenuList.length>0){
            this.$confirm('存在点单的菜品,确定离开快餐页面吗?', '提示', {
                type: 'warning',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                callback: (name) => {
                    if(name=='confirm'){
                        next();
                    }else{
                        this.$emit("navIndex",0);
                    }
                }
            })
        }else{
            next();//执行离开
        }
    },
    mounted(){
        //显示 账单
        this.$webBrowser.openAuxiliaryScreen({bill:[],showType:1});

        this.$emit("navIndex",0);
        this.userInfo=this.$auth.getUserInfo(); //获取用户id
        this.Login_Name=this.userInfo.Login_Name; //用户姓名
        
        this.$cacheData.lockersCache.getLockersList(480)
        this.$cacheData.UserRooms().then((d)=>{
            this.PosRooms = d;
            
            this.thefirstcanteenID();
        }).catch(e=>{
            console.log('e:'+e)
            this.$alert('未找到桌台数据', "提示", {confirmButtonText: "确定"});
        })
        this.$cacheData.DeskPosconfigure().then((d)=>{
            _data.Running_DtFoodCard_YN=d.Running_DtFoodCard_YN;
        }).catch(()=>{
            //this.$alert("基本配置获取失败："+e.message, "提示", {confirmButtonText: "确定"});
        })
        //菜品数据结构
        this.$cacheData.PosFoods().then((d)=>{
           this.posFoodData=d;
           this.abnormalOrderFoodPrice();
        }).catch(e=>{
            console.log('e:'+e)
            this.$alert('未找到菜品数据', "提示", {confirmButtonText: "确定"});
        })
        /* 获取支付方式 */
        this.$cacheData.PayType().then((data)=>{
            this.PayKinds = data
            /**取出聚合支付 **/
            data.forEach(item=>{
                item.PayTypes.forEach(pay=>{
                    //快餐排除G9付款方式和预付金押金付款
                    if(pay.INTERFACE_TYPE!='9026001' && pay.INTERFACE_TYPE!='11'){
                        this.payType.push(pay);
                    }
                    if(pay.INTERFACE_TYPE==801010301){
                        this.payTypeSSPay = pay;
                    }
                })
            })
        }).catch(e=>{
            this.$alert("支付方式获取失败："+e.message, "提示", {confirmButtonText: "确定"});
        })
        
        /**折扣列表*/
        this.$cacheData.DiscountScheme().then((d)=>{
            this.discountScheme = d;
        }).catch((e)=>{
            this.$alert("折扣数据获取失败："+e.message, "提示", {confirmButtonText: "确定"});
        })
        /**菜品口味 */
        this.$cacheData.MasKinds().then((d)=>{
            this.masKindsList = d;
        }).catch(e=>{
            this.$alert("菜品口味数据获取失败："+e.message, "提示", {confirmButtonText: "确定"});
        })

        /**菜品组合信息 */
        this.$cacheData.ComboFood().then((d)=>{
            this.comboFoodList = d;
        }).catch(e=>{
            this.$alert("菜品口味数据获取失败："+e.message, "提示", {confirmButtonText: "确定"});
        })

        /**自定义功能按钮 */
        let SysProjects=this.$cacheData.SysProjects.get();
        if(SysProjects && SysProjects.length>0){
            SysProjects.forEach(element=> {
                if(element.Project_Key=='Order'){
                    element.SysProjectGroups.forEach(project=>{
                        /**点菜界面竖排自定义功能按钮 */
                        if(project.Group_Key=='QKOrderMain-Middle'){
                            project.SysProjectItems.forEach((item)=>{
                                let Menu=this.QKOrderMain[item.ProjectItem_Key];
                                if(Menu==null ||Menu=='undefined'){
                                    if(project.OtherFunc_YN==false){
                                        if(project.OtherFunc_Key!=item.ProjectItem_Key){
                                            this.QKOrderMain.push(item);
                                        }
                                    }else{
                                        this.QKOrderMain.push(item);
                                    }
                                }
                            })
                        }
                        /**结账界面横排自定义功能按钮 */
                        if(project.Group_Key=='CheckOut-Bottom'){
                            project.SysProjectItems.forEach(item=>{
                                let Menu=this.userCheckOutMenu[item.ProjectItem_Key];
                                if(Menu==null ||Menu=='undefined' ){
                                    this.userCheckOutMenu.push(item);
                                }
                            })
                        }
                    })
                }
            });
        }

        this.DefaultChannelID = this.userInfo?.Default_ChannelID
        /**默认渠道 */
        this.orderChannel=[]
        this.$cacheData.OrderChannel().then((d)=>{
            this.ChanneList=[]
            d.map(order=>{
                order.OrderChannelList.map(item=>{
                    this.ChanneList.push(item)
                })
            })
            this.OrderChannelUpdate()
        }).catch(()=>{
            this.$alert('暂无订单渠道', "提示", {confirmButtonText: "确定"});
        })
         if(this.$route.params.data){
            this.Rpt_Date=this.$route.params.Rpt_Date;
            this.isAbnormal=Boolean(this.$route.params.isAbnormal);
            this.abnormalOrder(JSON.parse(this.$route.params.data))
        }
        if(_data.RunFastFoodMustChooseDeskNo==true){
            this.choiceDeskShow=true
        }
        
        //监听 ai识别结果
        this.$webBrowser.on("openYoyoAi",(data)=>{
            console.log("isAiEnable:",this.isAiEnable,"openYoyoAi",data);
            if(data && (data.status==0 || data.state==0)){
                if(this.isAiEnable && data.data){
                    try {
                        let itemList=JSON.parse(data.data);
                        if(itemList.length>0){
                            this.aiSearchText=itemList.map(it=>it.itemCode);
                        }
                    } catch (error) {
                        console.log("openYoyoAi 解析data报错",error)
                    }
                }
            }
        });
        
        //是否开启AI识别 Running_AI_Recognition
        if(this.sysSetting.Running_AI_Recognition){
            console.log("读取AI识别功能配置")
            this.$webBrowser.getAiConfig().then(d=>{//AI识别功能
                console.log("getAiConfig",d)
                if(d && d.isEnable==true){
                    console.log("openYoyoAi")
                    //开启识别
                    this.$webBrowser.openYoyoAi().then(d=>{
                        if(d && (d.status==0 || d.state==0)){
                            this.isAiEnable=true;
                            console.log("开启AI识别");
                        }else{
                            this.$message.error("AI识别开启失败:"+d?.message);
                        }
                    })
                }
            })
        }
        if(this.userInfo.Is_AIRegistered){//该设备是否注册了AI识别点餐功能
            //监听 食方ai识别结果
            this.$webBrowser.on("openSFAi",(data)=>{
                console.log("openSFAi",data);
                if(data && (data.status==0 || data.state==0)){
                    if(data.data){
                        let itemList=data.data;
                        if(typeof(data.data)=="string"){
                            try {
                                itemList=JSON.parse(data.data);
                            } catch (error) {
                                console.log("openSFAi 解析data报错",error);
                                return ;
                            }
                        }
                        if(itemList.length>0){
                            this.SFAIAddFood(itemList);
                        }
                    }
                }
            });
        }

        //注册快捷键
        this.$shortcutKey.setFun((e,KeyBoard)=>{
            //是否锁屏了
            if(this.$global.isLockScreen || this.isModalShow)return; 
            this.QKOrderMain.find(it=>{
                if(it.ProjectItem_ShortcutKey==KeyBoard){
                    this.MiddleMenuClick(it);
                    return true;
                }else if(it.ProjectItem_Key== "OtherFunc"){
                    let item=it.SysProjectSubItems?.find(item=>item.ProjectSubItem_ShortcutKey==KeyBoard);
                    if(item){
                        this.subItemReturn(item);
                        return true;
                    }
                }
                return false;
            })
            if(e.key=="+" || e.code=="NumpadAdd"){
                this.$msgbox.close();
                this.clickNumAdd();
            }else if(e.key=="-" || e.code=="NumpadSubtract"){
                this.$msgbox.close();
                this.clickNumReduce();
            }
        });
    },
    watch:{
        isPayMoadlShow(newVal){
            this.$webBrowser.openAuxiliaryScreen({
                isPPay:newVal // 副屏显示请支付
            })
        },
        //订单信息 变化了
        orderTotal(){
            //副屏显示
            this.$webBrowser.openAuxiliaryScreen(this.orderTotal);
        },
        DeskName(newVal,oldVal){
            if(newVal && (newVal.indexOf('+')>=0  || newVal.indexOf('-')>=0 )){
                this.DeskName=oldVal;
            }
        },
        //修改抬头 弹层显示时 修改同步桌号信息
        modiRiseShow(newVal){
            if(newVal){
                if(this.headingInfo){
                    this.headingInfo.DeskName=this.DeskName;
                }
            }
        },
        /**合计 应收总金额 变化了 */
        totalMoney(){
            this.Mantissa_Money=0;
        }
    },
    methods:{
        /**异常订单  从档案菜品中还原点单菜品信息 */
        abnormalOrderFoodPrice(){
            if(this.isAbnormal && this.orderMenuList?.length>0 && this.foodAll?.length>0){
                this.orderMenuList.forEach(order=>{
                    let item=null;
                    this.foodAll?.some(it=>{
                        if(it.Food_ID==order.EAT_XFBMID){
                            item=it;
                            return true;
                        }else if(it.MultipleSizeFoods?.length>0){
                            return it.MultipleSizeFoods.some(food=>{
                                if(food.Food_ID==order.EAT_XFBMID){
                                    item=food;
                                    return true;
                                }
                            })
                        }
                    })
                    if(item){//从档案菜品中 还原点单菜品的会员价
                        order.Eat_VipPrice = item.Food_VipPrice;
                        order.Is_Seasonal = item.Is_Seasonal;//是否时价菜
                        order.RemainNum = item.RemainNum;
                        order.Is_Limited = item.Is_Limited;
                        order.Promotion_Price = item.Promotion_Price;
                        if(order.FoodDiscount_Dimension=='促' && (order.ConsumeOperations||[]).length==0){
                            order.Eat_CheckPrice=item.Promotion_Price;
                            order.ConsumeOperations=[{OperateType:5}]
                        }
                    }
                })
            }
        },
        /**异常订单跳转 */
        abnormalOrder(data){
            /**抬头 */
            this.DeskName = data.Eat_DeskName
            this.headingInfo.DeskName = data.Eat_DeskName
            this.headingInfo.DeskAutoID = data.Eat_DeskID
            this.headingInfo.RoomAutoID = data.Eat_RoomID
            this.headingInfo.DinersNum = data.Eat_ManNum
            this.headingInfo.OrderChannel_AutoID = data.CHANNEL_ID
            this.headingInfo.brandNumber = 0
            this.headingInfo.orderRemark =data.Order_Remark
            this.orderChannel=[]
            this.DefaultChannelID = this.headingInfo?.OrderChannel_AutoID;
            this.Channellike =  this.headingInfo?.OrderChannel_AutoID;
            this.eatCheckIndex = data.Eat_CheckIndex
            this.OrderChannelUpdate()
            /**订单数据 */
            data?.Order_ConsumeList.forEach(order=>{
                if(order?.ConsumeOperations){
                    this.discountMoneuy += order?.Eat_SaleMoney - order?.Eat_CheckMoney
                }
                let _item ={
                    Eat_ConsumeID:order?.Eat_ConsumeID,
                    SubCategory_ID:order?.SubCategory_ID,
                    SubCategory_Code:order?.SubCategory_Code,
                    EAT_XFBMID:order?.EAT_XFBMID,
                    EAT_XFCode:order?.EAT_XFCode,
                    EAT_XFName:order?.EAT_XFName,
                    Eat_Number:order?.Eat_Number,
                    Eat_CheckPrice:order?.Eat_CheckPrice,
                    FoodDiscount_Dimension:order?.FoodDiscount_Dimension,
                    FoodProperty_Dimension:order?.FoodProperty_Dimension,
                    ModiPrice:0,
                    Eat_SalePrice:order?.Eat_SalePrice,
                    Eat_VipPrice:order?.Eat_SalePrice,//默认销售价
                    Eat_MasName:order?.Eat_MasName,
                    Food_Status:-1,
                    Food_Type:order?.Food_Type,
                    Food_AssSize:order?.Food_AssSize,
                    AssSizeNumber:'',
                    Eat_XFSize:order?.Eat_XFSize,
                    FoodModifys:null,
                    FoodSetmeals:order?.Eat_TcItemList?.map(it=>{
                        return {
                            SubCategory_ID:it.SubCategory_ID,
                            FoodSetmeal_ID:it.EAT_XFBMID,
                            FoodSetmeal_Code:it.EAT_XFCode,
                            FoodSetmeal_Name:it.EAT_XFName,
                            FoodSetmeal_Number:it.Eat_Number,
                            FoodSetmeal_Price:it.Eat_CheckPrice,
                            FoodSetmeal_Size:it.Eat_XFSize,
                            FoodSaleMoney:it.Eat_SaleMoney,
                            FoodModifys:null,
                            Eat_MasName:it.Eat_MasName,
                            ModiPrice:0,
                            Food_Status:-1,
                            Eat_ConsumeID:it.Eat_ConsumeID
                        }
                    }),
                    Is_Special:order?.Is_Special,//是否是推荐菜
                    Is_Discounted:order?.Is_Discounted,
                    Is_Seasonal:order?.Is_Seasonal, /**没有,是否时价菜 */
                    RemainNum:order?.RemainNum, /**没有 */
                    Is_Limited:order?.Is_Limited, /**没有 */
                    Is_ChangedNum:order?.Is_ChangedNum,
                    Is_ChargeForService:order?.Is_ChargeForService,
                    OnlySupportIntNum:order?.OnlySupportIntNum,//是否数量取整
                    Is_SetMeal:false, //是否是套餐菜品
                    Is_Gift:order?.Is_Gift,//是否赠送
                    Exchanged_Number:0,
                    ConsumeOperations: order?.ConsumeOperations||[],//没有菜品的操作记录
                    is_discount:order?.FoodDiscount_Dimension=='折',//折扣
                    Eat_TcAutoID_Batch:order.Eat_TcAutoID_Batch,
                    Eat_TcName:order.Eat_TcName,
                    Eat_TcIndex:order.Eat_TcIndex,
                };

                if(_item.Food_Type==2 || _item.Food_Type==3){//套餐菜品
                    _item.Is_SetMeal=true;
                }else{
                    _item.FoodSetmeals=null;
                }

                if(_item.FoodDiscount_Dimension=="减"){//满减菜品 还原
                    _item.Eat_CheckPrice=_item.Eat_SalePrice;
                    _item.FoodDiscount_Dimension="";
                    _item.ConsumeOperations=null;
                }else if(_item.FoodDiscount_Dimension=="二"){//第二份折扣 还原
                    _item.Eat_CheckPrice=_item.Eat_SalePrice;
                    _item.FoodDiscount_Dimension="";
                     _item.ConsumeOperations=null;
                }
        
                if(order?.Food_AssSize){
                    _item.Eat_Number= order?.Number
                    _item.AssSizeNumber=order?.AssSizeNumber
                }
                if(order?.Mas_ParentID){
                    _item = Object.assign(_item,{Mas_ParentID:order?.Mas_ParentID})
                }
                if(_item.ConsumeOperations?.some(it=>it.OperateType==4)){//有会员折扣
                    _item.Eat_VipPrice=_item.Eat_CheckPrice;//有执行过会员价
                    if(!this.carPriceType){//标记有菜品执行过会员价 按钮好取消会员价
                        this.carPriceType=true;
                        this.QKOrderMain.some(item=>{
                            if(item.ProjectItem_Key=='MemberPrice'){
                                item.ProjectItem_Name='取消会员价'
                                return true;
                            }
                        })
                    }
                }
                this.orderMenuList.push(_item);
                this.radioClick(this.orderMenuList.length-1,_item);
            })
            data?.Order_PaymentDetailList.forEach(pay=>{
                let item={
                    Payment_ID:pay?.Payment_ID, //支付方式ID
                    Payment_Code:pay?.Payment_Code,  //支付方式编号
                    Payment_Name:pay?.Payment_Name,  //支付方式名称
                    Payment_Type:pay?.Payment_Type,  //支付方式类型
                    Payment_Money:pay?.Payment_Money, //支付方式金额
                    Payment_FactMoney:pay?.Payment_Money,  //支付实收金额
                    Qr_Code:'', //扫码付款码值
                    Card_No:"", //卡号
                    CouponInfo:null, //该支付金额核销的券信息
                    Time:this.getCurrentDateTime(pay?.Eat_PaymentTime.toString()),
                    is_pay:true, /**付款记录是否写入POS */
                    Eat_PayDetailID:pay?.Eat_PayDetailID,
                    Operator_Name:pay?.Eat_Czy /**操作员 */
                }
                this.paymentHistory.push(item);
            })
            this.money=0;
            this.EatAutoID = data?.Eat_AutoID 
            this.Timestamps = data?.Timestamps, /**没有,订单时间戳 */

            console.log("abnormalOrder",this.discountMoneuy);
            this.abnormalOrderFoodPrice();
        },
        /**点菜界面竖排自定义按钮点击 */
        MiddleMenuClick(item){
            //不需要判断菜品信息的按钮
            let arrKey=['GetTemporaryStorage','AllDelete','OtherFunc','PrintPreViewBill','ReadCardOrder','KLCOUPON','OpenCashBox','CallCheckNum','SaveCoupons','BankPos','CheckPrintSM',"POSGETINV"];
            if(this.orderMenuList.length==0 && arrKey.indexOf(item.ProjectItem_Key)<0){
                this.$message.warning("没有找到订单菜品数据,请重新尝试!");
                return
            }
            this.checkBtnlist = JSON.parse(JSON.stringify(item))
            /**如果是点击的是赠送按钮,并且是取消赠送的菜品,则跳过权限验证 */
            if(item.Permission==false){
                if(item.ProjectItem_Key=='GiveFree' && this.disRadioOrder?.ConsumeOperations.length>0){
                    this.clickGivereturn(1,item) 
                    return
                }else{
                    this.$confirm('该账户权限不足,不支持'+item.ProjectItem_Name+'功能', '提示', {
                        confirmButtonText: '去验证',
                        type: 'warning'})
                    .then(() => {
                        this.checkShow=true
                        
                    }).catch(()=>{});
                    return;
                }
            }
            switch(item.ProjectItem_Key){
                case "SaveCoupons":{//卡券核销
                    if(this.orderMenuList.length>0){
                        this.$message.warning("存在新点菜品,请先结账再使用此功能");
                        return;
                    }
                    if(this.EatAutoID){//有订单id了
                        this.$message.warning("已生成订单,请先结账再使用此功能!");
                        return;
                    }
                    this.couponVerifyShow=true;
                    break;
                }
                case 'CallCheckNum':{//取餐叫号
                    this.callCheckShow=true;
                    break
                }
                case 'SingleDel':
                    this.clickDelete(this.disRadioclass,this.disRadioOrder)  /**单删 */
                    break
                case 'Mas':
                    this.clickDemandShow() /**要求 */
                    break
                case 'Plus':
                    this.clickNumAdd() /**+ */
                    break
                case 'Minus':
                    this.clickNumReduce() /**- */
                    break
                case 'NumKeybord':
                    this.clickQuantity() /**数量 */
                    break
                case 'GiveFree': 
                    {
                        if(this.userInfo.TheLimitedGiftingMoney==0 && Object.keys(this.checkUser).length==0){
                            this.$message.warning('没有赠送权限,请去后台设置')
                            return
                        }
                        if(this.disRadioOrder?.is_taste){
                            this.$message.warning('口味做法无法赠送')
                            return
                        }
                        if(this.disRadioOrder?.ConsumeOperations){
                            let OperateType= this.disRadioOrder?.ConsumeOperations[0]?.OperateType
                            if(OperateType==1){
                                this.$message.warning('该菜品已进行过折扣,无法再进行赠送')
                            }else if(OperateType==3){
                                this.$message.warning('该菜品已进行过改价,无法再进行赠送')
                            }else if(OperateType==4){
                                this.$message.warning('该菜品已进行过会员价,无法再进行赠送')
                            }else if(OperateType==6){
                                this.$message.warning('该菜品已进行过第二份折扣,无法再进行赠送')
                            }else{
                                this.clickGivereturn(1,item) /**赠送 */
                            }
                        }else{
                            this.clickGivereturn(1,item) /**赠送 */
                        }
                        break
                    }
                case 'DiscountPlan': /**折扣 */
                    {
                        if(this.orderMenuList.length>0){
                            this.recordFunctionCheck=item
                            this.discountShow=true
                        }else{
                            this.$message.warning('请先点单菜品')
                        }
                    }
                    break;
                case 'guangmingaihuzk': { /**光明爱护网折扣 */ 
                    if(this.orderMenuList.length>0){
                        this.recordFunctionCheck=item;
                        this.aiHuShow=true;
                    }else{
                        this.$message.warning('请先点单菜品')
                    }
                    break;
                }
                case 'SLZK':{/**商旅折扣权益 */
                    if(this.orderMenuList.length>0){
                        this.recordFunctionCheck=item
                        this.shangLvZKShow=true
                    }else{
                        this.$message.warning('请先点单菜品')
                    }
                    break;
                }
                
                case 'ModifyPrice':
                        this.clickPriceChange() /**改价 */
                    break
                case 'AllMas':
                    this.clickDemandFullShow() /**全单 */
                    break
                case 'OtherFunc':
                    this.otherFuncList = item.SysProjectSubItems;
                    this.subShow = true
                    
                    break
                case 'TemporaryStorage'://暂存菜品
                    if(this.orderMenuList.length==0){
                        this.$message.warning('没有可暂存的菜品信息！')
                    }else{
                        this.$confirm('您确定暂存当前菜品?', "提示", {
                            confirmButtonText: "确定",
                            cancelButtonText:"取消",
                            callback: (name) => {
                                if(name=='confirm'){
                                    let _data=[];
                                    this.orderMenuList.map(item=>{
                                        if(item.Food_Status==-1){
                                            let json=Object.assign({},item);
                                            json.OrderComboConsumes=undefined;
                                            _data.push(json);
                                        }
                                    })
                                    if(_data.length){
                                        this.$cacheData.lockersCache.set({
                                            Eat_DeskName:this.headingInfo.DeskName,//桌台号
                                            Eat_ManNum:this.headingInfo.DinersNum,//人数
                                            Eat_WaiterName:'',//服务员
                                            OrderConsumes:_data
                                        })
                                        this.$message.success("暂存成功");
                                        this.emptydata()
                                    }else{
                                        this.$message.error('没有新菜品不需要暂存')
                                    }
                                }
                            },
                        });
                    }
                    break
                // case 'SendButNoToKit': //下单不送达厨房
                //     this.onPlaceOrder(true)
                //     break
                case 'AllDeskRefund': //整桌退菜
                    {
                        let status=0
                        this.orderMenuList.map(meu=>{
                            if(meu.Food_Status==-1){
                                status=1
                                return true
                            }
                        })
                        if(status==1){
                            this.$message.error('存在新点菜品,请先落单再使用此功能')
                            return
                        }
                        this.wholeShow = true;
                        
                    }
                    break
                case 'PrintPreViewBill': //重印上一单
                    this.printPreViewBill()
                    break
                case 'GetTemporaryStorage'://提取暂存菜品
                    {
                        let lockersCache = this.$cacheData.lockersCache.getLockersList(480)
                        if(lockersCache.length>0){
                            this.lockersShow=true;
                            
                        }else{
                            this.$message.warning('没有暂存订单信息')
                        }
                    }
                    break
                case 'DiyFood'://自定义菜品
                    this.customDishesShow=true;
                    
                    break
                case 'ChangeSize': //换单位
                    this.unitClick()
                    break
                 /**会员价 */
                case 'MemberPrice':
                    {
                        if(this.carPriceType==false){
                            this.FoodVipMoney(item);
                            setTimeout(() => {
                                this.$refs.foodMenu.searchBoxFocus();
                            },100);
                        }else{
                            this.$confirm('是否取消会员价', '提示', {
                                confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'})
                            .then(() => {
                                this.FoodVipMoney(item);
                                setTimeout(() => {
                                    this.$refs.foodMenu.searchBoxFocus();
                                },100);
                            }).catch(() => {
                            });
                        }
                    }
                    break
                /**取消 促销方案 */
                case 'NOAddPromotion':
                    {
                        if(this.orderMenuList?.length>0){
                            this.$confirm('是否确定取消促销价', '提示', {
                                confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'})
                            .then(() => {
                                this.orderMenuList?.forEach(order=>{
                                    if(order.ConsumeOperations?.some(it=>it.OperateType==5)){//是否使用了促销价
                                        order.Eat_CheckPrice=order.Eat_SalePrice;//还原成销售价
                                        order.ConsumeOperations=null;
                                    }
                                })
                            }).catch(() => {
                            });
                       
                        }
                    }
                    break
                case 'CopyMenu'://复制菜品
                    {
                        let status=0
                        this.orderMenuList.some(meu=>{
                            if(meu.Food_Status==-1){
                                status=1
                                return true
                            }
                        })
                        if(status==1){
                            this.$message.error('存在新点菜品,请先落单再使用此功能')
                            return
                        }
                        this.copyFoodShow=true;
                        
                    }
                    break
                case 'TcChangeFood'://套餐换菜
                    if(this.disRadioOrder.Eat_CheckMoney<=0){
                        this.$message.error('套餐换菜请选择套餐头');
                        return;
                    }
                    if(this.disRadioOrder.Food_Type==1){
                        this.$message.error('该功能仅适用于套餐菜品');
                        return;
                    }
                    if(this.disRadioOrder.Eat_Number<=0){
                        this.$message.error('套餐菜品数量为0,不能进行套餐换菜操作');
                        return;
                    }
                    if(this.disRadioclass==-1){
                         this.$alert('请先选择左边的菜品', '提示', {confirmButtonText: '确定',});
                         return
                    }
                    this.foodAll.some(pos=>{
                        if(pos.Food_ID==this.disRadioOrder.EAT_XFBMID){
                            this.posFoodSetMealInfos=[]
                            this.posFoodSetMealInfos.push(pos);
                            return true
                        }
                    })
                    /**菜品未下单*/
                    if(this.disRadioOrder.Food_Status==-1){
                        this.tcChangeType = 1
                        if(!this.disRadioOrder.FoodSetmeals){
                            this.$message.error('请选择对应套餐');
                            return;
                        }else{
                            this.subShow = false
                        }
                        /**即配套餐 */
                        if(this.disRadioOrder.Food_Type==3){
                            this.$message.error('即配套餐下单后才可调整');
                            return;
                        }else{
                            this.setMealShow = true
                            
                        }
                    }else{
                         /**即配套餐 */
                        if(this.disRadioOrder.Food_Type==3){
                            this.readyShowType=2
                            this.readyShow=true
                            
                            //this.$message.error('下单的即配套餐暂无改菜功能')
                        }else{
                            /**已经下单的菜品 */
                            this.cheageSetMealShow=true;
                            
                        }
                    }
                    break
                case 'AllDelete'://全删
                    {
                        let _order =[]
                        let _deleteorder=[]
                        this.orderMenuList.map(order=>{
                            if(order.Food_Status!=-1){
                                _order.push(order)
                            }
                            if(order.Food_Status==-1){
                                _deleteorder.push(order)
                            }
                        })
                        if(_deleteorder.length==0){
                            this.$message.warning('没有需要删除的菜品')
                            return
                        }
                        this.$confirm('确定删除所有菜品吗?', '提示', {
                            confirmButtonText: '确认删除',
                            cancelButtonText: '取消',
                            type: 'warning'})
                        .then(() => {
                            this.orderMenuList = [];
                        }).catch(()=>{});
                    }
                    break
                case 'OpenCashBox'://开钱箱
                    this.$webBrowser.openCashBoxBnt().then(d=>{
                        if(d?.state!=0){
                            this.$message.error('钱箱打开失败:'+(d?.message||""));
                        }
                    });
                break
                case 'ReadCardOrder'://读卡点菜
                {
                    this.readCardFood((foodids)=>{
                        this.$alert("本次读卡点菜"+foodids.length+"道菜！").then(()=>{
                            this.readCardAddFood(foodids)
                        })
                    })
                    break
                }
                case 'KLCOUPON'://昆仑卡核销
                {
                    let status=0
                    this.orderMenuList.map(meu=>{
                        if(meu.Food_Status==-1){
                            status=1
                            return true
                        }
                    })
                    if(status==1){
                        this.$message.error('存在新点菜品,请先结账再使用此功能')
                        return
                    }
                    this.klCouponShow=true;
                    
                    break;
                }
                case 'GroupUpdateXFBM'://组合修改
                {
                    if(this.disRadioOrder){
                        //是否是组合菜品
                        let foodInfo=this.disRadioOrder;
                        if(foodInfo.Food_Type==1 && foodInfo.Eat_TcAutoID_Batch && !foodInfo.Eat_TcName){
                            if(this.disRadioOrder.Is_Combo){
                                foodInfo=this.orderMenuList.find(it=>it.Eat_TcIndex==1 && it.Eat_TcAutoID_Batch== this.disRadioOrder.Eat_TcAutoID_Batch);
                            }
                            // if(!foodInfo.OrderComboConsumes[0].Kind_Name){//未找到明细分组 说明是异常单过来的
                            //     this.$message.warning("该组合为异常单过来的,无法修改!");
                            //     return;
                            // }
                            this.comboFoodInfo=this.comboFoodList?.find(it=>it.Food_ID==foodInfo.EAT_XFBMID);
                            if(this.comboFoodInfo){
                                this.editComboFoodInfo=foodInfo;
                                this.isComboFoodShow=true;
                                
                            }else{
                                this.$message.warning("未查询到该组合,无法修改!");
                            }
                        }else{
                            this.$message.warning('该功能仅适用于组合菜品');
                        }
                    }else{
                        this.$message.warning("请先选择左边组合菜品进行修改!");
                    }
                    break;
                } 
                case 'BankPos':{//BankPos操作
                    this.bankPosShow=true;//
                    break
                }
                case 'CheckPrintSM':{//扫码订单核销
                    if(this.orderMenuList.length>0){
                        this.$message.warning("存在新点菜品,请先结账再使用此功能");
                        return;
                    }
                    if(this.EatAutoID){//有订单id了
                        this.$message.warning("已生成订单,请先结账再使用此功能!");
                        return;
                    }
                    this.scanOrderShow=true;//
                    break
                }
                case 'ROUNDING':{//手工抹零
                    this.popShow=true;//
                    break
                }
                case 'POSGETINV':{//同步库存
                    this.syncPosFood();
                    break
                }
            }
        },
        /**修改抬头返回 */
        setDeskclose(headingInfo,meberInfo){
            this.headingInfo = headingInfo;
            if(this.headingInfo?.OrderChannel_AutoID){
                this.orderChannel=[];
                this.DefaultChannelID = this.headingInfo?.OrderChannel_AutoID;
                this.Channellike=this.headingInfo?.OrderChannel_AutoID;
                this.OrderChannelUpdate();
            }
            if(this.headingInfo.DinersNum==''){
                this.headingInfo.DinersNum=0;
            }
            this.meberInfo = meberInfo;
            this.DeskName = this.headingInfo?.DeskName;
            if(this.headingInfo?.RoomAutoID){
                this.RoomAutoID = this.headingInfo?.RoomAutoID;
            }
            this.modiRiseShow=false;
        },
        /**全单点击 */
        clickDemandFullShow(){
            let _status=0;
            this.orderMenuList.map(item=>{
                if(item.Food_Status==-1){
                    _status=1;
                }
            })
            if(_status==1){
                if(this.masKindsList){
                    this.demandFullShow=true
                    
                }else{
                    this.$message.warning('请先去后台配置相对应的菜品口味信息');
                }
            }else{
                this.$alert('没有新点菜品暂时无法调整', '提示', {confirmButtonText: '确定',});
            }
        },
        /**点击菜品,添加到数组中 */
        onPlaceFoods(item,callBack){
            if(this.$global.NumberkeyOff==false){
                this.orderNumber=''
            }
            let _RemainNum=0
            this.assistSizeInfo={}
            if(!item){
                this.$message({message: '请先选择菜品',type: 'warning'});
                return
            }
            if(item.Is_SoldOut && !item.Is_MultipleSize){
                this.$message({message: '该菜品已售完',type: 'warning'});
                return
            }
            if(item.Is_Limited==true){
                if(item.RemainNum==0){
                    if(item.Is_LimitedProject){
                        this.$message({message: '该菜品已售完',type: 'warning'});
                        return;
                    }
                }else{
                    this.orderMenuList.forEach(order=>{
                        if(order.EAT_XFBMID==item.Food_ID && order.Eat_Number>=1 && order.Food_Status==-1 && order.Eat_CheckPrice==item.Food_Price){
                            _RemainNum = _RemainNum+order.Eat_Number
                        }
                    })
                    if(this.isUnitWeight(item.Food_Size) && Number(this.wgNum)>0){   
                        if((_RemainNum+Number(this.wgNum))>item.RemainNum){
                            this.$message({message: '不能超过该菜品的剩余数量',type: 'warning'});
                            return
                        }
                    }
                    if(Number(this.orderNumber)>0){
                        if((_RemainNum+Number(this.orderNumber))>item.RemainNum){
                            this.$message({message: '不能超过该菜品的剩余数量',type: 'warning'});
                            return
                        }
                    }else{
                        if(_RemainNum>=item.RemainNum){
                            this.$message({message: '不能超过该菜品的剩余数量',type: 'warning'});
                            return
                        }
                    }
                    
                }
            }
            /**判断是否多规格菜品 */
            if(item.Is_MultipleSize==true){
                this.unitShow=true
                if(this.multipleSizeFoods.length==0){
                    this.multipleSizeFoods.push(item);
                }else{
                    let _SizeNum=0
                    this.multipleSizeFoods.forEach(food=>{
                        if(food.Food_ID==item.Food_ID){
                            _SizeNum=1
                        }
                    })
                    if(_SizeNum==0){
                        this.multipleSizeFoods.push(item)
                    }
                }
                this.theMultipleSizeFoods=item;
                return
            }
            this.unitShow=false
            //是否是组合菜品
            let comboFood=this.comboFoodList?.find(it=>it.Food_ID==item.Food_ID);
            if(comboFood){
                this.comboFoodInfo=comboFood;
                this.editComboFoodInfo=null;
                
                if(this.orderNumber>0){
                    this.editComboFoodInfo={
                        Eat_Number:this.orderNumber
                    };
                }else if(item.Eat_Number>0){//本身有数量
                    this.editComboFoodInfo={
                        Eat_Number:item.Eat_Number
                    };
                }
                this.isComboFoodShow=true;
                return;
            }
            

            if(this.$global.NumberPriceOff && !item.Is_SetMeal && item.Is_Seasonal && this.modifyPrice?.Permission && !this.adjusquantityShow && !this.demandShow){//不是套餐 并且可改价(时价菜可改价、有改价权限)
                let foods = JSON.parse(JSON.stringify(item));
                Object.assign(foods,{
                    EAT_XFName:item.Food_Name,
                    Eat_Number:1,//默认1
                    Eat_CheckPrice:item.Food_Price,
                    Eat_SalePrice:item.Food_Price,
                    AssSizeNumber:"",
                })
                if(this.orderNumber>0){
                    foods.Eat_Number=this.orderNumber;
                }else if(item.Eat_Number>0){//本身有数量
                    foods.Eat_Number=item.Eat_Number;
                }
                this.setItemPrice(foods,item);
                if(foods.Eat_SalePrice==foods.Eat_CheckPrice){//不能有折扣 
                    foods.originalPrice=foods.Eat_CheckPrice;
                    this.BindPosFoods=foods;
                    this.adjusquantityShow = true;
                    return ;
                }
            }
            if(!item.isChangeNumPrice){//非 强制修改数量和单价过来的
                /**判断是否是辅助单位菜品 */
                if(item.Food_AssSize){
                    if(item.Food_AssSize!='' && this.assSizeShow==false && this.BindPosFoods==''){
                        this.assSizeShow = true
                        this.assistSizeInfo = JSON.parse(JSON.stringify(item))
                        return
                    }
                }
            }
            
            //启用菜品绑定做法之后，触摸屏不自动弹出选择框
            if(!this.sysSetting.OpenFoodMasBindingWithoutPopup){
                /**判断是否是绑定做法菜品 */
                if(item.Is_BindEatMas){
                    if(!this.masKindsList){
                        this.$message.warning('该菜品有默认口味,请先去后台配置相对应的菜品口味信息');
                        return
                    }else{
                        this.demandShow=true
                        this.BindPosFoods = JSON.parse(JSON.stringify(item))
                        return
                    }
                }
            }
            let _item=''
            this.disRadioCheck = true;
            //记录 当前选中的菜品id
            this.$refs.foodMenu.choicePosFoods = item.Food_ID;
            /**是否是套餐 */
            if(item.Is_SetMeal){
                if(!item.SetMealInfo){
                    this.$message.warning('该套餐后台没有搭配对应的菜品');
                    return
                }else{
                    this.tcChangeType=0
                    this.posFoodSetMealInfos=[item];
                    if(typeof(callBack)=="function"){//套餐点击确认后 加入菜品 在回调
                        this.posFoodSetMealInfos._callBack=callBack;
                    }
                    this.setMealShow=true;
                }
            }else{
                this.orderMenuList.map((order,index)=>{
                    if(order.EAT_XFBMID==this.disRadioOrder.EAT_XFBMID && order.Food_Status==-1 && this.unitType==1){
                        this.orderMenuList.splice(index,1)
                        this.unitType=0
                    }
                })
                if(_data.MergeSameFoodInOrder==false){
                    _item = this.onPlaceFoodsChildren(item)
                    this.radioClick(this.orderMenuList.length-1,_item);
                }else{
                    let orderIndex = this.orderMenuList.findIndex(order=>
                        !(order.Eat_TcAutoID_Batch && !order.Eat_TcName) //排除组合菜品
                        && !order.isPromotion2 && !order.isFullGive && order.EAT_XFBMID==item.Food_ID 
                        && order.Food_Status==-1 && order.Eat_MasName=='' && order.Eat_CheckPrice==item.Food_Price )
                    if(orderIndex>=0){
                        let order=this.orderMenuList[orderIndex];
                        if(item.isChangeNumPrice){//强制修改数量和单价过来的
                            order.Eat_Number = this.addNum(Number(item.Number),order.Eat_Number)
                        }else{
                            if(Number(this.orderNumber)>0){
                                order.Eat_Number = this.addNum(Number(this.orderNumber),order.Eat_Number)
                            }else if(this.isUnitWeight(item.Food_Size) && Number(this.wgNum)>0){
                                order.Eat_Number = this.addNum(Number(this.wgNum),order.Eat_Number)
                            }else if(item.Eat_Number>0){//本身有数量
                                order.Eat_Number=Number(order.Eat_Number).compute(item.Eat_Number);
                            }else{
                                order.Eat_Number++
                            }
                        }
                        if(item.Food_AssSize){
                            order.AssSizeNumber +=item.AssSizeNumber
                        }
                        this.radioClick(orderIndex,order);
                   }else{
                        _item = this.onPlaceFoodsChildren(item);
                        this.radioClick(this.orderMenuList.length-1,_item);
                   }
                }
                this.orderNumber='';
                this.wgNum=0;
                if(typeof(callBack)=="function"){//加入菜品后回调
                    callBack();
                }
            }
            //选择菜品时记录一下
            this.$refs.foodMenu.setOldvarietySelect();
            if(this.isAiEnable){
                if(this.aiSearchText?.length>0){
                    this.aiSearchText=null;
                    //回传ai选择结果
                    this.$webBrowser.selectAiData({itemCode:item.Food_Code,itemName:item.Food_Name,pinyin:item.Food_PinYin,markType:1});
                }else{
                    //回传ai学习结果
                    this.$webBrowser.selectAiData({itemCode:item.Food_Code,itemName:item.Food_Name,pinyin:item.Food_PinYin,markType:2});
                }
            }
            
        },
        onPlaceFoodsChildren(item){
            let _item ={
                Eat_ConsumeID:newGuid(),
                SubCategory_ID:item.SubCategory_ID,
                SubCategory_Code:item.SubCategory_Code,
                EAT_XFBMID:item.Food_ID,
                EAT_XFCode:item.Food_Code,
                EAT_XFName:item.Food_Name,
                Eat_Number:1,
                Eat_CheckPrice:item.Food_Price,
                ModiPrice:0,
                Eat_SalePrice:item.Food_Price,
                Eat_VipPrice:item.Food_VipPrice,
                Eat_MasName:'',
                Food_Status:-1,
                Food_AssSize:item.Food_AssSize,
                AssSizeNumber:'',
                Eat_XFSize:item.Food_Size,
                FoodModifys:null,
                FoodSetmeals:null,
                Is_Special:item.Is_Special,//是否是推荐菜
                Is_Discounted:item.Is_Discounted,
                Is_Seasonal:item.Is_Seasonal,
                RemainNum:item.RemainNum,
                Is_Limited:item.Is_Limited,
                Is_ChangedNum:item.Is_ChangedNum,
                Is_ChargeForService:item.Is_ChargeForService,
                OnlySupportIntNum:item.OnlySupportIntNum,//是否数量取整
                Is_SetMeal:item.Is_SetMeal,
                Promotion_Price:0,
                Exchanged_Number:0,
                ConsumeOperations:[]
            };
            
            if(item.isChangeNumPrice){//强制修改数量和单价过来的
                _item.Eat_Number= item.Number
                if(item.Food_AssSize){//辅助单位
                    _item.AssSizeNumber=item.AssSizeNumber
                }
                if(item.Operations){//有修改单价记录
                    _item.ConsumeOperations=[item.Operations];
                }
                
            }else{
                this.setItemPrice(_item,item);
            }
            this.orderMenuList.push(_item);
            return _item
        },
        /**菜品价格数量取值计算 */
        setItemPrice(_item,item){
            //促销价
            if(item?.Is_Promotion && item?.Promotion_Price>=0){
                _item.Eat_CheckPrice = item?.Promotion_Price
                _item.Promotion_Price = item?.Promotion_Price
                _item.ConsumeOperations=[{OperateType:5}]
            }
            if(item.Food_AssSize){
                _item.Eat_Number= item.Number||1;
                _item.AssSizeNumber=item.AssSizeNumber||1;
            }

            if(item.OnlySupportIntNum && Number(this.orderNumber)>0){
                this.orderNumber= parseInt(this.orderNumber);//取整
            }

            if(Number(this.orderNumber)>0){//快捷 键盘 数量
                _item.Eat_Number = Number(this.orderNumber);
            }else if(this.isUnitWeight(item.Food_Size) && Number(this.wgNum)>0){//称重数量
                _item.Eat_Number = Number(this.wgNum)
            }else if(item.Eat_Number>0){//菜品本身有数量
                _item.Eat_Number=item.Eat_Number;
            }
        },
        /**删除 */
        clickDelete(index,item){
            if(item.Food_Status==0){
                this.$alert('', '提示', {confirmButtonText: '确定',});
            }else{
                if(this.disRadioclass>-1){
                    if(this.foodtype==1){
                        this.$alert('套餐下的菜品不允许单独删除', '提示', {confirmButtonText: '确定',});
                        return
                    }
                    if(this.disRadioOrder?.Is_Combo){
                        this.$alert('组合菜品下的菜品不允许单独删除', '提示', {confirmButtonText: '确定',});
                        return
                    }
                    if(this.disRadioOrder.Food_Status!=-1){
                        this.$alert('该菜品已下单暂时无法调整', '提示', {confirmButtonText: '确定',});
                    }
                    else{
                        if(item?.is_taste){//口味加价做法菜品
                            this.orderMenuList.forEach((order,i)=>{
                                /**找到选择口味对应的菜品 */
                                if(order.Eat_ConsumeID==item.Eat_ConsumeID && order?.FoodModifys){
                                    /**找到对应的口味删除 */
                                    order?.FoodModifys.map((food,j)=>{
                                        if(food.Mas_AutoID==item.Mas_AutoID){
                                            order?.FoodModifys.splice(j--,1)
                                        }
                                    })
                                    let data = this.optFlavorsMap(order?.FoodModifys,order)
                                    order.Eat_MasName = data._MasName
                                }
                                if(order.Eat_ConsumeID==item.Eat_ConsumeID && order.Mas_AutoID==item.Mas_AutoID){
                                    this.orderMenuList.splice(i,1)
                                    i--
                                }
                            })
                            this.orderMenuList.forEach(order=>{
                                /**如果是套餐的话 */
                                if(order.FoodSetmeals){
                                    order.FoodSetmeals.forEach(food=>{
                                        if(food.Eat_ConsumeID==item.Eat_ConsumeID){
                                            if(food.FoodModifys){
                                                food.FoodModifys.forEach((mo,j)=>{
                                                    if(mo.Mas_AutoID==item.Mas_AutoID){
                                                        food?.FoodModifys.splice(j--,1)
                                                    }
                                                })
                                                let data = this.optFlavorsMap(food?.FoodModifys,order)
                                                food.Eat_MasName = data._MasName
                                            }
                                        }
                                    })
                                }
                                
                            })
                            /**删除对应储存的口味要求和做法 */
                            if(this.aloneMethod){
                                this.aloneMethod.forEach((alon,i)=>{
                                    if(alon.disRadioOrder.Eat_ConsumeID==item.Eat_ConsumeID){
                                        if(alon?.optFlavors){
                                            alon.optFlavors.forEach((opt,j)=>{
                                                if(opt.Mas_AutoID==item.Mas_AutoID){
                                                    alon.optFlavors.splice(j,1)
                                                    j--
                                                }
                                            })
                                        }
                                    }
                                })
                            }
                            if(this.mallMethod){
                                this.mallMethod.forEach(me=>{
                                    if(me.order.Eat_ConsumeID==item.Eat_ConsumeID){
                                        if(me.optFlavors){
                                            me.optFlavors.forEach((opt,j)=>{
                                                if(opt.Mas_AutoID==item.Mas_AutoID){
                                                    me.optFlavors.splice(j,1)
                                                    j--
                                                }
                                            })
                                        }
                                    }
                                })
                            }
                        }else{//非口味加价做法菜品
                            let arr=[]
                            this.orderMenuList.forEach(order=>{
                                //过滤 要删除的菜品 
                                if(order.Eat_ConsumeID!=item.Eat_ConsumeID){
                                    //要删除组合菜品下的菜品
                                    if(item.OrderComboConsumes?.some(it=>it.Eat_ConsumeID==order.Eat_ConsumeID)){
                                        return;
                                    }
                                    arr.push(order)
                                }
                            })
                            if(item?.FoodSetmeals){
                                 for(let i=0; i<arr.length; i++){
                                    item.FoodSetmeals.forEach(food=>{
                                        if(food.Eat_ConsumeID==arr[i]?.Eat_ConsumeID){
                                            arr.splice(i,1)
                                            i--;
                                        }
                                    })
                                }
                            }
                            this.orderMenuList = arr
                        }
                        if(item?.Is_Gift){
                            if(this.foodOperationRecord.length>0){
                                this.foodOperationRecord.forEach((food,index)=>{
                                    if(food.foodType==1 && food.Eat_ConsumeID==item.Eat_ConsumeID){
                                       this.foodOperationRecord.splice(index,1)
                                       this.discountMoneuy = this.discountMoneuy -item.Eat_CheckPrice
                                    }
                                })
                            }                             
                        }
                        if(!item?.is_taste){
                            this.discountMoneuy = this.discountMoneuy - ((Number(item?.Eat_SalePrice) - Number(item.Eat_CheckPrice)) * item.Eat_Number)
                            if(this.discountMoneuy<0){
                                this.discountMoneuy =0
                            }
                        }
                        this.clickEndConsume(index-1);
                    }
                    
                }else{
                    this.$message.warning('请先选择已点菜的菜品')
                }
            }
        },
        /**点击最后一条明细数据 */
        clickEndConsume(index){
            if(index==undefined || index==null){
                index=this.orderMenuList.length-1;
            }else if(this.orderMenuList.length<=index){
                index=this.orderMenuList.length-1;
            }
            if(index<0){
                index=0;
            }
            if(index>=0){
                for(let i=index;i>=0;i--){
                    if(this.orderMenuList[i] && !this.orderMenuList[i].Is_Combo){
                        index=i;
                        this.radioClick(index,this.orderMenuList[index]);
                        break;
                    }
                }
            }
            
        },
        /**菜单选择菜品 */
        radioClick(index,item){
            if(item){
                this.foodSetmealsclass=-1
                this.disRadioOrder =item
                this.foodtype = 0
                this.choicefoodOrder=''
                this.disRadioclass=-1;
                this.disRadioclass=index;
            }else{
                this.disRadioOrder={}
                this.disRadioclass=-1
            }
            this.$nextTick(()=>{
                this.$refs.orderMenu?.scrollRow();
            })
        },
        /**菜单要求 */
        clickDemandShow(){
            if(this.disRadioclass>-1){
                if(this.disRadioOrder.Food_Status==-1){
                    if(!this.masKindsList){
                         this.$message.warning('请先去后台配置相对应的菜品口味信息');
                    }else{
                        this.demandShow=true
                        
                    }
                }else{
                    this.$alert('该菜品已下单暂时无法调整', '提示', {confirmButtonText: '确定',});
                }
            }else{
                this.$alert('请先选择左边的菜品', '提示', {confirmButtonText: '确定',});
            }
        },
        /**订单口味数量同步 */
        orderFoodSyn(order,type){
            if(order?.is_taste){
                if(order.Eat_ConsumeID==this.disRadioOrder.Eat_ConsumeID){
                    if(order?.Price_Kind==0){
                        if(type==1){
                            order.Eat_Number++
                        }else{
                            order.Eat_Number = this.accSub(1,order.Eat_Number);
                        }
                    }
                }
            }
        },
        /**增加数量 */
        clickNumAdd(index,item,adType){
            if(this.foodtype==1){
                this.$alert('套餐菜品不允许单独改量', '提示', {confirmButtonText: '确定',});
                return
            }
            if(this.disRadioOrder?.Is_Combo){
                this.$alert('组合菜品下的菜品不允许单独改量', '提示', {confirmButtonText: '确定',});
                return
            }
            if(!this.disRadioOrder?.is_taste){
                if(this.disRadioOrder?.ConsumeOperations){
                    let OperateType= this.disRadioOrder?.ConsumeOperations[0]?.OperateType
                    if(OperateType==1){
                        this.$message.warning('折扣菜品,无法增加数量')
                        return
                    }else if(OperateType==2){
                        this.$message.warning('菜品赠送,无法增加数量')
                        return
                    }else if(OperateType==3){
                        this.$message.warning('菜品改价,无法增加数量')
                        return
                    }else if(OperateType==4){
                        this.$message.warning('会员价菜品,无法增加数量')
                        return
                    }
                }
            }
            
            if(this.disRadioOrder?.isFullGive){//满赠
                this.$message.warning('满赠活动赠送菜,无法增加数量');
                return;
            }
            if(this.disRadioOrder?.Is_Gift==true){
                this.$message.warning('菜品赠送,无法增加数量')
                return
            }
            if(index!=null){
                if(item.Food_Status==0){
                    this.$message.warning('该菜品已下单暂时无法调整')
                }else{
                    /**判断是否是辅助单位菜品 */
                    if(this.orderMenuList[index].Food_AssSize){
                        if(adType==null){
                            this.adjusquantityShow=true;
                            return
                        }
                    }
                    this.orderMenuList[index].Eat_Number++;
                    if(this.orderMenuList[index].FoodModifys){
                        this.orderMenuList[index].FoodModifys.map(item=>{
                            if(item.Price_Kind==0){
                                item.Mas_Num=this.addNum(1,item.Mas_Num)
                            }
                        })
                    }
                }
            }else{
                if(this.disRadioclass>-1){
                    if(this.disRadioOrder.Food_Status!=-1){
                        this.$alert('该菜品已下单暂时无法调整', '提示', {confirmButtonText: '确定',});
                    }else{
                        /**判断是否是辅助单位菜品 */
                        if(this.orderMenuList[this.disRadioclass].Food_AssSize){
                            if(adType==null){
                                this.adjusquantityShow=true;
                                return
                            }
                        }
                        let EatNumber= this.orderMenuList[this.disRadioclass].Eat_Number
                        let _EATXFBMID = this.orderMenuList[this.disRadioclass].EAT_XFBMID
                        let Limited = '',RemainNum=0
                        this.orderMenuList.map(order=>{
                            if(order.EAT_XFBMID==_EATXFBMID && !order?.is_taste){
                                if(order.Is_Limited==true){
                                    RemainNum += order.Eat_Number
                                    if(order.RemainNum!=0){
                                        if(RemainNum>=order.RemainNum){
                                            Limited='已超过菜品的最大剩余数量'
                                        }
                                    }
                                }
                            }
                        })
                        if(Limited!=''){    
                            this.$message.error(Limited);
                            return
                        }
                        this.FoodModifysNumberAdd(EatNumber)
                    }
                }else{
                    this.$alert('请先选择左边的菜品', '提示', {confirmButtonText: '确定',});
                }
            }
        },
        /**口味要求同步增加数量 */
        FoodModifysNumberAdd(EatNumber){
            /**选择的口味 */
            this.orderMenuList = JSON.parse(JSON.stringify(this.orderMenuList))
            if(this.disRadioOrder?.is_taste){//加价口味做法的菜
                if(this.disRadioOrder.Price_Kind==1 || this.disRadioOrder.Price_Kind==0){//按次加价 或 按量
                    this.orderMenuList[this.disRadioclass].Eat_Number=this.addNum(1,this.orderMenuList[this.disRadioclass].Eat_Number)
                    this.orderMenuList.forEach(order=>{
                        if(order.Eat_ConsumeID==this.disRadioOrder.Eat_ConsumeID && !order?.is_taste){
                            if(order.FoodModifys){
                                order.FoodModifys.map(item=>{
                                    if(item.Mas_AutoID==this.disRadioOrder.Mas_AutoID){
                                        item.Mas_Num=this.addNum(1,item.Mas_Num)
                                    }
                                })
                            }
                            /**有套餐 && order?.Is_SetMealCountAvgPrice==false*/
                            if(order.FoodSetmeals){
                                order.FoodSetmeals.forEach(food=>{
                                    if(food.FoodModifys){
                                        food.FoodModifys.map(item=>{
                                            if(item.Mas_AutoID==this.disRadioOrder.Mas_AutoID && food.Eat_ConsumeID==this.disRadioOrder.Eat_ConsumeID){
                                                item.Mas_Num=this.addNum(1,item.Mas_Num)
                                            }
                                        })
                                    }
                                })
                            }
                        }else{
                            if(order.FoodSetmeals){
                                order.FoodSetmeals.forEach(food=>{
                                    if(food.Eat_ConsumeID==this.disRadioOrder.Eat_ConsumeID){
                                        if(food.FoodModifys){
                                            food.FoodModifys.map(item=>{
                                                if(item.Mas_AutoID==this.disRadioOrder.Mas_AutoID){
                                                    item.Mas_Num=this.addNum(1,item.Mas_Num)
                                                }
                                            })
                                        }
                                    }
                                })
                            }
                        }
                    })
                }
            }else{
                /**普通菜品数量调整 */
                if(this.foodtype==0){
                    this.orderMenuList.forEach(order=>{
                        if(order.Eat_ConsumeID==this.disRadioOrder.Eat_ConsumeID){
                            if(order?.Price_Kind!=1 && order.Price_Kind!=2){
                                order.Eat_Number=this.addNum(1,order.Eat_Number)
                            }
                            if(order?.FoodModifys){
                                order.FoodModifys.forEach(item=>{
                                    if(item.Price_Kind==0){
                                        item.Mas_Num=this.addNum(1,item.Mas_Num)
                                    }
                                })
                            }
                            /**有套餐 */
                            if(order?.FoodSetmeals && order?.Is_SetMealCountAvgPrice==false){
                                order.FoodSetmeals.filter(it=>!it.Is_FixedNum).forEach(food=>{
                                    let num=1
                                    if(food.FoodSetmeal_Number>1 && food.FoodSetmeal_Number>= EatNumber){
                                        num = food.FoodSetmeal_Number / EatNumber
                                        food.FoodSetmeal_Number = Number(Number(Number(food.FoodSetmeal_Number)+Number(num)).toFixed(2))
                                    }else{
                                        food.FoodSetmeal_Number=this.addNum(1,food.FoodSetmeal_Number)
                                    }
                                    if(food.FoodModifys){
                                        let orNumber=0
                                        this.orderMenuList.forEach(or=>{
                                            if(or.Eat_ConsumeID==food.Eat_ConsumeID){
                                                if(or.Price_Kind==0 && or.Eat_Number<=food.FoodSetmeal_Number){
                                                    or.Eat_Number = food.FoodSetmeal_Number
                                                    orNumber = or.Eat_Number
                                                }else{
                                                    if(or.Price_Kind==0){
                                                        or.Eat_Number= or.Eat_Number + num
                                                        orNumber = or.Eat_Number
                                                    }
                                                }
                                            }
                                        })
                                        food.FoodModifys.forEach(mod=>{
                                            if(mod.Price_Kind==0){
                                                mod.Mas_Num =orNumber
                                            }
                                        })
                                    }
                                })
                            }
                        }
                    })
                }else if(this.foodtype==1){
                    this.orderMenuList.forEach(order=>{
                        if(order.Eat_ConsumeID==this.choicefoodOrder.Eat_ConsumeID){
                            if(order?.is_taste){
                                if(order.Price_Kind==0){
                                    order.Eat_Number=this.addNum(1,order.Eat_Number)
                                    if(order.FoodModifys){
                                        order.FoodModifys.forEach(item=>{
                                            if(item.Price_Kind==0){
                                                item.Mas_Num=this.addNum(1,item.Mas_Num)
                                            }
                                        })
                                    }
                                }
                            }else{
                                order.Eat_Number++
                                if(order.FoodModifys){
                                    order.FoodModifys.map(item=>{
                                        if(item.Price_Kind==0){
                                            item.Mas_Num=this.addNum(1,item.Mas_Num)
                                        }
                                    })
                                }
                            }
                            if(order.FoodSetmeals && order?.Is_SetMealCountAvgPrice==false){
                                order.FoodSetmeals.filter(it=>!it.Is_FixedNum).forEach(food=>{
                                    if(food.FoodSetmeal_Number>1  && food.FoodSetmeal_Number>= order.Eat_Number){
                                        let num = food.FoodSetmeal_Number / (order.Eat_Number-1)
                                        food.FoodSetmeal_Number = Number(food.FoodSetmeal_Number)+ Number(num)
                                    }else{
                                        food.FoodSetmeal_Number=this.addNum(1,food.FoodSetmeal_Number)
                                    }
                                    if(food.FoodModifys){
                                        food.FoodModifys.forEach(item=>{
                                            if(item.Price_Kind==0){
                                                if(Number(food.FoodSetmeal_Number)>(Number(order.Eat_Number) -1)){
                                                    let masNum = Number(food.FoodSetmeal_Number) / Number(order.Eat_Number)
                                                    item.Mas_Num = Number(item.Mas_Num) + masNum
                                                }else{
                                                    item.Mas_Num=this.addNum(1,item.Mas_Num)
                                                }
                                                this.orderMenuList.forEach(or=>{
                                                    if(or.Eat_ConsumeID==food.Eat_ConsumeID && or?.is_taste==true){
                                                        or.Eat_Number = item.Mas_Num
                                                    }
                                                })
                                            }
                                        })
                                    }
                                })
                            }
                        }
                    })
                }
            }
        },
         /**减少数量 */
        clickNumReduce(index,item,adType){
            if(this.foodtype==1){
                this.$alert('套餐菜品不允许单独改量', '提示', {confirmButtonText: '确定',});
                return
            }
            if(this.disRadioOrder?.Is_Combo){
                this.$alert('组合菜品下的菜品不允许单独改量', '提示', {confirmButtonText: '确定',});
                return
            }
            if(!this.disRadioOrder?.is_taste){
                if(this.disRadioOrder?.ConsumeOperations){
                    let OperateType= this.disRadioOrder?.ConsumeOperations[0]?.OperateType
                    if(OperateType==1){
                        this.$message.warning('折扣菜品,无法增加数量')
                        return
                    }else if(OperateType==2){
                        this.$message.warning('菜品赠送,无法增加数量')
                        return
                    }else if(OperateType==3){
                        this.$message.warning('菜品改价,无法增加数量')
                        return
                    }else if(OperateType==4){
                        this.$message.warning('会员价菜品,无法增加数量')
                        return
                    }
                }
            }
            if(this.disRadioOrder?.isFullGive){//满赠
                this.$message.warning('满赠活动赠送菜,无法调整数量');
                return;
            }
            if(this.disRadioOrder?.Is_Gift==true){
                this.$alert('赠送菜品无法调整数量', '提示', {confirmButtonText: '确定',});
                return
            }
            if(index!=null){
                if(item.Food_Status==0){
                    this.$alert('该菜品已下单暂时无法调整', '提示', {confirmButtonText: '确定',});
                }else{
                    if(this.orderMenuList[index].Eat_Number>1){
                        /**判断是否是辅助单位菜品 */
                        if(this.orderMenuList[index].Food_AssSize){
                            if(adType==null){
                                this.adjusquantityShow=true;
                                return
                            }
                        }
                        this.orderMenuList[index].Eat_Number=this.accSub(1,this.orderMenuList[index].Eat_Number);
                        if(this.orderMenuList[index].FoodModifys){
                            this.orderMenuList[index].FoodModifys.map(item=>{
                                if(item.Price_Kind==0){
                                    item.Mas_Num=this.accSub(1,item.Mas_Num);
                                }
                            })
                        }
                    }
                }
            }else{
                if(this.disRadioclass>-1){
                    if(this.disRadioOrder.Food_Status!=-1){
                            this.$alert('该菜品已下单暂时无法调整', '提示', {confirmButtonText: '确定',});
                    }else{
                        this.orderMenuList = JSON.parse(JSON.stringify(this.orderMenuList))
                        if(this.orderMenuList[this.disRadioclass].Eat_Number>1){
                            /**判断是否是辅助单位菜品 */
                            if(this.orderMenuList[this.disRadioclass].Food_AssSize){
                                if(adType==null){
                                    this.adjusquantityShow=true;
                                    return
                                }
                            }
                            let EatNumber= this.orderMenuList[this.disRadioclass].Eat_Number
                            /**选择的口味 */
                            if(this.disRadioOrder?.is_taste){
                                if(this.disRadioOrder.Price_Kind==1 || this.disRadioOrder.Price_Kind==0){//按次加价 或 按量
                                    this.orderMenuList[this.disRadioclass].Eat_Number=this.accSub(1,this.orderMenuList[this.disRadioclass].Eat_Number);
                                    this.orderMenuList.map(order=>{
                                        if(order.FoodModifys){
                                            order.FoodModifys.map(item=>{
                                                if(item.Mas_AutoID==this.disRadioOrder.Mas_AutoID && order.Eat_ConsumeID==this.disRadioOrder.Eat_ConsumeID){
                                                    item.Mas_Num=this.accSub(1,item.Mas_Num);
                                                }
                                            })
                                        }
                                        if(order.FoodSetmeals){
                                            order.FoodSetmeals.map(food=>{
                                                if(food.FoodModifys){
                                                    food.FoodModifys.map(item=>{
                                                        if(item.Mas_AutoID==this.disRadioOrder.Mas_AutoID && food.Eat_ConsumeID==this.disRadioOrder.Eat_ConsumeID){
                                                            item.Mas_Num=this.accSub(1,item.Mas_Num);
                                                        }
                                                    })
                                                }
                                            })
                                        }
                                    })
                                }
                            }else{
                                /**选的普通菜品 */
                                if(this.foodtype==0){
                                    this.orderMenuList.forEach(order=>{
                                        /**普通菜品调整 */
                                        if(order.Eat_ConsumeID==this.disRadioOrder.Eat_ConsumeID){
                                            if(order.Price_Kind!=1 && order.Price_Kind!=2){
                                                if(order.Eat_Number>1){
                                                    order.Eat_Number=this.accSub(1,order.Eat_Number);
                                                }
                                            }
                                            /**有口味 */
                                            if(order.FoodModifys){
                                                order.FoodModifys.forEach(item=>{
                                                    if(item.Price_Kind==0){
                                                        if(item.Mas_Num>1){
                                                            item.Mas_Num=this.accSub(1,item.Mas_Num);
                                                        }
                                                    }
                                                })
                                            }
                                            /**有套餐 */
                                            if(order.FoodSetmeals && order?.Is_SetMealCountAvgPrice==false){
                                                order.FoodSetmeals.filter(it=>!it.Is_FixedNum).forEach(food=>{
                                                    let num=1
                                                    if(food.FoodSetmeal_Number>1 && food.FoodSetmeal_Number>= EatNumber){
                                                        num = food.FoodSetmeal_Number / EatNumber
                                                        food.FoodSetmeal_Number = this.accSub(num,food.FoodSetmeal_Number)
                                                    }else{
                                                       food.FoodSetmeal_Number = this.accSub(num,food.FoodSetmeal_Number)
                                                    }
                                                    if(food.FoodModifys){
                                                        let orNumber=0
                                                        this.orderMenuList.forEach(or=>{
                                                            if(or.Eat_ConsumeID==food.Eat_ConsumeID){
                                                                if(or.Price_Kind==0 && or.Eat_Number<=food.FoodSetmeal_Number){
                                                                    or.Eat_Number = food.FoodSetmeal_Number
                                                                    orNumber = or.Eat_Number
                                                                }else{
                                                                    if(or.Price_Kind==0){
                                                                        or.Eat_Number = this.accSub(num,or.Eat_Number)
                                                                        orNumber = or.Eat_Number
                                                                    }
                                                                }
                                                            }
                                                        })
                                                        food.FoodModifys.forEach(item=>{
                                                            if(item.Price_Kind==0){
                                                                item.Mas_Num =orNumber
                                                            }
                                                        })
                                                    }
                                                })
                                            }
                                        }
                                    })
                                }else if(this.foodtype==1){/**选的套餐菜品 */
                                    this.orderMenuList.forEach(order=>{
                                        if(order.Eat_ConsumeID==this.choicefoodOrder.Eat_ConsumeID){
                                            if(Number(order.Eat_Number)>1){
                                                if(order?.is_taste){
                                                    if(order.Price_Kind==0){
                                                        order.Eat_Number =this.accSub(1,order.Eat_Number)
                                                    }
                                                }else{
                                                    order.Eat_Number =this.accSub(1,order.Eat_Number)
                                                }
                                                if(order.FoodModifys){
                                                    order.FoodModifys.forEach(item=>{
                                                        if(item.Price_Kind==0){
                                                            item.Mas_Num=this.accSub(1,item.Mas_Num)
                                                        }
                                                    })
                                                }
                                                if(order.FoodSetmeals && order?.Is_SetMealCountAvgPrice==false){
                                                    order.FoodSetmeals.filter(it=>!it.Is_FixedNum).forEach(food=>{
                                                        if(food.FoodSetmeal_Number>=EatNumber){
                                                            let num = food.FoodSetmeal_Number / EatNumber
                                                            food.FoodSetmeal_Number = this.accSub(num,food.FoodSetmeal_Number)
                                                        }else{
                                                            food.FoodSetmeal_Number = this.accSub(1,food.FoodSetmeal_Number)
                                                        }
                                                        if(food.FoodModifys){
                                                            let _orNumbers=0
                                                            this.orderMenuList.forEach((or,index)=>{
                                                                if(or.Eat_ConsumeID==food.Eat_ConsumeID){
                                                                    if(or.Price_Kind==0){
                                                                        _orNumbers = or.Eat_Number
                                                                    }
                                                                }
                                                            })
                                                            food.FoodModifys.forEach(item=>{
                                                                if(item.Price_Kind==0){
                                                                    item.Mas_Num =food.FoodSetmeal_Number
                                                                    this.orderMenuList.map(or=>{
                                                                        if(or.Eat_ConsumeID==food.Eat_ConsumeID && or?.is_taste==true){
                                                                            or.Eat_Number = item.Mas_Num
                                                                        }
                                                                    })
                                                                }
                                                            })
                                                        }
                                                    })
                                                }
                                            }
                                        }
                                    })
                                }
                            }
                        }   
                    }
                }else{
                    this.$alert('请先选择左边的菜品', '提示', {confirmButtonText: '确定',});
                }
            }
        },
        /**单选菜品口味返回 */
        confirm(optFlavors,disRadioOrder,temporderMenuList){
            this.demandShow =false;
            this.synOrderMethodsNum(1)
            /**把之前添加的口味先删除 */
            for(let i=0; i<this.orderMenuList.length; i++){
                if(this.orderMenuList[i].Food_Status==-1){
                    this.orderMenuList[i].Eat_MasName=null
                    this.orderMenuList[i].FoodModifys=[]
                    //如果套餐不为空
                    if(this.orderMenuList[i].FoodSetmeals){
                        for (let j = 0; j < this.orderMenuList[i].FoodSetmeals.length; j++) {
                            this.orderMenuList[i].FoodSetmeals[j].FoodModifys=[]
                            this.orderMenuList[i].FoodSetmeals[j].Eat_MasName=null
                        }
                    }
                    if(this.orderMenuList[i]?.is_taste){
                        this.orderMenuList.splice(i, 1);
                        i--;
                    }
                }
            }
            if(this.foodSetmealsclass!=-1){
                this.disRadioOrder = Object.assign(this.disRadioOrder,{foodSetmealsclass:this.foodSetmealsclass})
            }
            let _opt={disRadioOrder:this.disRadioOrder,optFlavors:optFlavors}
            if(this.aloneMethod.length>0){
                if(this.aloneMethod.findIndex(alone=>alone.disRadioOrder.Eat_ConsumeID===this.disRadioOrder.Eat_ConsumeID)==-1){
                    this.aloneMethod.push(_opt)
                }
                this.aloneMethod.some(alone=>{
                    if(alone.disRadioOrder.Eat_ConsumeID==this.disRadioOrder.Eat_ConsumeID){
                        alone.optFlavors = optFlavors;
                        alone.disRadioOrder=this.disRadioOrder;
                    }
                })
            }else{
                this.aloneMethod.push(_opt)
            }
            /**有同步的菜品 */
            if(temporderMenuList){
                this.temporderMethod(temporderMenuList,optFlavors)
            }
            //单独口味添加方法
            this.aloneAddMethods()
            //再去执行全单口味
            this.mallMethodMethods()
            this.synOrderMethodsNum(2)
        },
        aloneAddMethods(){
            if(this.aloneMethod.length==0){
                return
            }
            this.aloneMethod.map(am=>{
                this.synchMethods(am.optFlavors,'',am.disRadioOrder)
                this.TemporderMenuList=[]
            })
        },
        /**同步菜品口味要求做法 */
        temporderMethod(temporderMenuList,optFlavors){
            temporderMenuList.forEach(tm=>{
                if(tm.Eat_ConsumeID==this.disRadioOrder.Eat_ConsumeID){
                    tm.is_type=0
                }
                //需要添加的菜
                if(tm.is_type==1){
                    let _opt={disRadioOrder:tm,optFlavors:optFlavors}
                    if(this.aloneMethod.findIndex(alone=>alone.disRadioOrder.Eat_ConsumeID===tm.Eat_ConsumeID)==-1){
                        this.aloneMethod.push(_opt)
                    }else{
                        this.aloneMethod.forEach(alone=>{
                            if(alone.disRadioOrder.Eat_ConsumeID==tm.Eat_ConsumeID && tm.is_type==1){
                                optFlavors.forEach(fm=>{
                                    let optype=0
                                    alone.optFlavors.forEach(op=>{
                                        if(op.Mas_AutoID==fm.Mas_AutoID){
                                            optype=1
                                        }
                                    })
                                    if(optype==0){
                                        alone.optFlavors.push(fm)
                                    }
                                })
                            }
                        })
                    }
                }
            })
        },
        /**同步订单口味要求的数量 */
        synOrderMethodsNum(type){
            if(type==1){//记录之前的口味数量
                this.MethodNumList=[]
                this.orderMenuList.forEach(order=>{
                    //记录加价口味做法 自定义的不记录
                    if(order?.is_taste && order.Mas_AutoID!=this.sysSetting?.DiyEatMas?.MAS_AUTOID){
                        let _metNum={
                            Eat_ConsumeID:order.Eat_ConsumeID,
                            Mas_Num:order.Eat_Number,
                            Mas_AutoID:order.Mas_AutoID,
                            IsAllRequired:order.IsAllRequired
                        };
                        this.MethodNumList.push(_metNum)
                    }
                })
            }else if(type==2){//还原之前的口味数量
                this.orderMenuList.forEach(order=>{
                    if(order.is_taste){//口味做法的菜
                        let met=this.MethodNumList.find(it=>it.Eat_ConsumeID==order.Eat_ConsumeID && order.Mas_AutoID==it.Mas_AutoID && order.IsAllRequired==it.IsAllRequired);
                        if(met){
                            order.Eat_Number=met.Mas_Num;
                        }
                    }else{//菜品
                        let met=this.MethodNumList.find(it=>it.Eat_ConsumeID==order.Eat_ConsumeID);
                        if(met){
                            order.FoodModifys?.forEach(food=>{
                                if(food.Mas_AutoID==met.Mas_AutoID && food.IsAllRequired==met.IsAllRequired){
                                    food.Mas_Num=met.Mas_Num;
                                }
                            })
                        }
                        //套餐
                        order.FoodSetmeals?.forEach(set=>{
                            met=this.MethodNumList.find(it=>it.Eat_ConsumeID==set.Eat_ConsumeID);
                            if(met){
                                set.FoodModifys?.forEach(food=>{
                                    if(food.Mas_AutoID==met.Mas_AutoID && food.IsAllRequired==met.IsAllRequired){
                                        food.Mas_Num=met.Mas_Num;
                                    }
                                })
                            }
                        })
                    }
                })
            }
        },
        /**绑定菜品口味做法返回 */
        BindPosconfirm(optFlavors){
            this.BindPosFoods.Is_BindEatMas=false;
            this.onPlaceFoods(this.BindPosFoods,()=>{
                this.confirm(optFlavors,this.disRadioOrder,'')
            })
            this.demandShow =false;
            this.BindPosFoods=''
            
        },
        /**提取暂存返回 */
        lockersConfirm(loakersDetailed){
            loakersDetailed?.OrderConsumes?.forEach(loak=>{
                this.orderMenuList.push(loak);
                if(!loak.is_taste){
                    if(loak.FoodModifys?.length>0){//记录口味
                        this.aloneMethod.push({disRadioOrder:loak,optFlavors:loak.FoodModifys});
                    }
                    loak?.FoodSetmeals?.forEach(it=>{//套餐
                        if(it.FoodModifys?.length>0){//记录口味
                            this.aloneMethod.push({disRadioOrder:it,optFlavors:it.FoodModifys});
                        }
                    })
                }
            })

            this.orderMenuList.forEach(order=>{
                loakersDetailed?.OrderConsumes?.forEach(loak=>{
                    if(order.Eat_ConsumeID==loak.Eat_ConsumeID){
                        let _price = Number(order.Eat_SalePrice).toFixed(2) - Number(order.Eat_CheckPrice).toFixed(2)
                        this.discountMoneuy +=_price  * order.Eat_Number
                    }
                })
            })
            this.$message.success("提取暂存成功");
            this.lockersShow = false
        },
        synchMethods(optFlavors,temporderMenuList,disRadioOrder){
            /**同步菜品 */
            this.orderMenuList.forEach((order,index)=>{
                if(!order?.is_taste){
                    let data = this.optFlavorsMap(optFlavors,disRadioOrder)
                    disRadioOrder.Eat_MasName = data._MasName
                    disRadioOrder.FoodModifys = data._foodModifys
                    //disRadioOrder.FoodSetmeal_Price = data._Price
                    disRadioOrder.FoodModifys.map(mod=>{
                        if(mod.Price_Kind==0 && disRadioOrder?.FoodSetmeal_Number){
                            mod.Mas_Num = disRadioOrder.FoodSetmeal_Number
                        }
                    })
                    let tasteMenu = this.tasteMenu(optFlavors,order,disRadioOrder,0)
                    if(tasteMenu.length>0){
                        tasteMenu.forEach(item=>{
                            if(item.Eat_ConsumeID==order.Eat_ConsumeID && !order.is_taste){
                                index++
                                let data = this.optFlavorsMap(optFlavors,order)
                                order.Eat_MasName = data._MasName;
                                order.FoodModifys=data._foodModifys;
                                order.ModiPrice =  data._Price
                                this.orderMenuList.splice(index,0,item)
                            }else{
                                order.FoodSetmeals?.forEach(food=>{
                                    if(item.Eat_ConsumeID==food.Eat_ConsumeID && !order?.is_taste) {
                                        food.Eat_MasName = data._MasName;
                                        food.FoodModifys=data._foodModifys;
                                        food.ModiPrice =  data._Price
                                        index++
                                        this.orderMenuList.splice(index,0,item)
                                    }
                                }); 
                            }
                        })
                    }else{
                        if(disRadioOrder.Eat_ConsumeID==order.Eat_ConsumeID && !order.is_taste){
                            index++
                            let data = this.optFlavorsMap(optFlavors,order)
                            order.Eat_MasName = data._MasName;
                            order.FoodModifys=data._foodModifys;
                            order.ModiPrice =  data._Price
                        }
                        if(!order.is_taste){
                            order.FoodSetmeals?.forEach(food=>{
                                if(food.Eat_ConsumeID==disRadioOrder.Eat_ConsumeID){
                                    food.Eat_MasName = data._MasName;
                                    food.FoodModifys=data._foodModifys;
                                    food.ModiPrice =  data._Price
                                }
                            })  
                        }
                    }
                }
            })
            //}
        },
        /**下单前口味添加到菜单 */
        tasteMenu(optFlavors,item,disRadioOrder,IsAllRequired){
            let _item=[]
            if(optFlavors){
                optFlavors.forEach(num=>{
                    if(num.Is_AddMoney==true){
                        /**把口味添加到菜单 */
                        let param={
                            Eat_ConsumeID:item.Eat_ConsumeID,
                            Mas_AutoID:num.Mas_AutoID,
                            EAT_XFBMID:item.EAT_XFBMID,
                            EAT_XFCode:item.EAT_XFCode,
                            Eat_XFSize:({0:item.Eat_XFSize,1:"次",2:"位"})[num.Price_Kind],
                            EAT_XFName:num.Mas_Name+'@'+num.Mas_Price,
                            Eat_Number:num.Mas_Num||1,
                            Eat_CheckPrice:num.Mas_Price,
                            Eat_SalePrice:num.Mas_Price,
                            ModiPrice:0,
                            Food_Status:-1,
                            Is_Discounted:item.Is_Discounted,
                            Is_Seasonal:item.Is_Seasonal,
                            RemainNum:item.RemainNum,
                            Is_Limited:item.Is_Limited,
                            Is_ChangedNum:item.Is_ChangedNum,
                            Is_ChargeForService:item.Is_ChargeForService,
                            Is_SetMeal:item.Is_SetMeal,
                            is_taste:true,
                            IsAllRequired:IsAllRequired,
                            Price_Kind:num.Price_Kind
                        }
                        if(num.Price_Kind==0){
                            param.Eat_Number=item.Eat_Number
                        }else if(num.Price_Kind==2){//2：按位加价
                            param.Eat_Number=this.headingInfo?.DinersNum||1;
                        }
                        if(disRadioOrder && disRadioOrder!=''){
                            if(disRadioOrder.FoodSetmeal_ID){
                                if(num.Price_Kind==0 && disRadioOrder?.FoodSetmeal_Number){//套餐明细菜品
                                    param.Eat_Number=disRadioOrder.FoodSetmeal_Number;
                                    param.Eat_XFSize=disRadioOrder.FoodSetmeal_Size;
                                }
                               
                                param.EAT_XFBMID=disRadioOrder.FoodSetmeal_ID;
                                param.EAT_XFCode=disRadioOrder.FoodSetmeal_Code;
                            }
                            if(disRadioOrder.Eat_ConsumeID){//有菜品明细
                                param.Eat_ConsumeID = disRadioOrder.Eat_ConsumeID ;
                            }
                            
                        }
                        _item.push(param);
                    }
                })
            }
            return _item;
        },
        /**口味变动放到临时订单集合 */
        tempoptFlavorAdd(item,optFlavorsList,type,temptype){
            if(temptype==true){
                if(item){
                    this.TemporderMenuList.push(item);
                }
            }
            if(optFlavorsList.length>0 && optFlavorsList != undefined){
                optFlavorsList.map(op=>{
                    this.TemporderMenuList.push(op)
                })
            }
            if(type==true){
                this.orderMenuList=this.TemporderMenuList
            }
        },
        /**套餐口味变动 */
        optFlavorsMap(optFlavors,item){
            let data =''
            let _foodModifys=[]
            let _MasName ='';
            let _Price = 0
            if(optFlavors){
                optFlavors.map(num=>{
                    _MasName += num.Mas_Name+'/';
                    let json={
                        Mas_AutoID:num.Mas_AutoID,
                        Mas_Code:num.Mas_Code,
                        Mas_Name:num.Mas_Name,
                        Mas_Num:1,
                        Mas_Price:num.Mas_Price,
                        Price_Kind:num.Price_Kind,
                        Is_AddMoney:num.Is_AddMoney,
                        IsAllRequired:0
                    }
                    //加价的做法口味
                    if(num.Is_AddMoney){
                        if(num.Price_Kind==0){//按量加价
                            json.Mas_Num=item.Eat_Number;
                        }else if(num.Price_Kind==1){//按次加价
                            json.Mas_Num=num.Mas_Num||1;
                        }else if(num.Price_Kind==2){//按位加价
                            json.Mas_Num=this.headingInfo?.DinersNum||1;//人数是多少，加价数量就是多少
                        }
                    }
                    _foodModifys.push(json);
                })
            }
            data ={_MasName:_MasName,_foodModifys:_foodModifys,_Price:_Price}
            return data
        },
        /**减法函数 */
        accSub(arg1,arg2){ 
             var r1,r2,m,n;
            try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0}
            try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0}
            m=Math.pow(10,Math.max(r1,r2));
            //动态控制精度长度
            n=(r1>=r2)?r1:r2;
            return Number(((arg2*m-arg1*m)/m).toFixed(n));
        },
        /**全选菜品口味 */
        confirmall(optFlavors){
            this.TemporderMenuList=[]
            this.demandFullShow=false;
            this.synOrderMethodsNum(1)
            /**把之前添加的口味先删除 */
            for(let i=0; i<this.orderMenuList.length; i++){
                if(this.orderMenuList[i].Food_Status==-1){
                    this.orderMenuList[i].Eat_MasName=null
                    this.orderMenuList[i].FoodModifys=[]
                    //如果套餐不为空
                    if(this.orderMenuList[i].FoodSetmeals){
                        for (let j = 0; j < this.orderMenuList[i].FoodSetmeals.length; j++) {
                            this.orderMenuList[i].FoodSetmeals[j].FoodModifys=[]
                            this.orderMenuList[i].FoodSetmeals[j].Eat_MasName=null
                        }
                    }
                    if(this.orderMenuList[i]?.is_taste){
                        this.orderMenuList.splice(i, 1);
                        i--;
                    }
                }
            }
            this.orderMenuList.map(order=>{
                let _order ={order:order,optFlavors:JSON.parse(JSON.stringify(optFlavors))} 
                this.mallMethod.push(_order)
            })
            //单独口味添加方法
            this.aloneAddMethods()
            //全单添加方法
            this.mallMethodMethods()
            this.synOrderMethodsNum(2)
        },
        //全单口味添加方法
        mallMethodMethods(){
            if(this.mallMethod.length==0){
                return
            }
            this.orderMenuList.map((item,index)=>{
                let _type=0
                let _optFlavors=[]
                /**全单口味里面已有的菜品做法才会同步 */
                this.mallMethod.map(mall=>{
                    if(mall.order.Eat_ConsumeID==item.Eat_ConsumeID){
                        _type=1
                        _optFlavors = mall.optFlavors
                    }
                })
                if(item.Food_Status==-1 && !item.is_taste){
                    let _foodModifys=[]
                    let _Eat_MasName =''
                    if(item.Eat_MasName){
                        _Eat_MasName = item.Eat_MasName
                    }
                    if(_type==1){
                       _optFlavors.forEach(num=>{
                            _Eat_MasName += num.Mas_Name+'/';
                            let json={
                                Mas_AutoID:num.Mas_AutoID,
                                Mas_Code:num.Mas_Code,
                                Mas_Name:num.Mas_Name,
                                Mas_Num:1,
                                Mas_Price:num.Mas_Price,
                                Price_Kind:num.Price_Kind,
                                Is_AddMoney:num.Is_AddMoney,
                                IsAllRequired:1
                            }
                            //加价的做法口味
                            if(num.Is_AddMoney){
                                if(num.Price_Kind==0){//按量加价
                                    json.Mas_Num=item.Eat_Number;
                                }else if(num.Price_Kind==1){//按次加价
                                    json.Mas_Num=num.Mas_Num||1;
                                }else if(num.Price_Kind==2){//按位加价
                                    json.Mas_Num=this.headingInfo?.DinersNum||1;//人数是多少，加价数量就是多少
                                }
                            }
                            _foodModifys.push(json);
                        })
                        this.tempoptFlavorAdd(item,this.tasteMenu(_optFlavors,item,'',1),true,true)
                    }else{
                        this.tempoptFlavorAdd(item,'',true,true)
                    }
                    if(item.FoodSetmeals!=null){
                        item.FoodSetmeals.forEach(food=>{
                            if(!food.Eat_MasName){
                                food.Eat_MasName=''
                            }
                            food.Eat_MasName += _Eat_MasName
                            if(food.FoodModifys){
                                _foodModifys.forEach(fm=>{
                                    food.FoodModifys.push(Object.assign({},fm))
                                })
                            }else{
                                food.FoodModifys =JSON.parse(JSON.stringify(_foodModifys));
                            }
                            food.FoodModifys?.forEach(mod=>{
                                if(mod.Price_Kind==0 && food?.FoodSetmeal_Number){
                                    mod.Mas_Num = food.FoodSetmeal_Number
                                }
                            })

                            let _food = {
                                Eat_ConsumeID:food.Eat_ConsumeID,
                                SubCategory_ID:item.SubCategory_ID,
                                EAT_XFBMID:item.EAT_XFBMID,
                                EAT_XFCode:item.EAT_XFCode,
                                EAT_XFName:food.FoodSetmeal_Name,
                                Eat_Number:food.FoodSetmeal_Number,
                                Eat_CheckPrice:item.Eat_CheckPrice,
                                Eat_SalePrice:item.Eat_SalePrice,
                                Eat_MasName:item.Eat_MasName,
                                Food_Status:item.Food_Status,
                                Is_SetMeal:true,
                                FoodSetmeal_ID:food.FoodSetmeal_ID,
                                FoodSetmeal_Code:food.FoodSetmeal_Code,
                                FoodSetmeal_Number:food.FoodSetmeal_Number,
                                FoodSetmeal_Price:food.FoodSetmeal_Price,
                                FoodModifys:food.FoodModifys,
                                is_type:0,
                                Food_Speed:food.Food_Speed
                            }
                            this.tempoptFlavorAdd('',this.tasteMenu(_optFlavors,_food,'',1),true,true)
                        })
                    }

                    
                    item.Eat_MasName = _Eat_MasName;
                    if(item.FoodModifys){
                        _foodModifys.map(fm=>{
                            item.FoodModifys.push(fm)
                        })
                    }else{
                        item.FoodModifys =JSON.parse(JSON.stringify(_foodModifys));
                    }
                }
                else{
                    this.TemporderMenuList.push(item);
                }
            })
            this.TemporderMenuList=[]
        },
        /**数量*/
        clickQuantity(){
            if(this.foodtype==1){
                this.$alert('套餐菜品不允许单独改量', '提示', {confirmButtonText: '确定',});
                return
            }
            if(this.disRadioOrder?.Is_Combo){
                this.$alert('组合菜品下的菜品不允许单独改量', '提示', {confirmButtonText: '确定',});
                return
            }
            if(this.disRadioclass>-1){
                if(this.disRadioOrder?.isFullGive){//满赠
                    this.$message.warning('满赠活动赠送菜,无法调整数量');
                    return;
                }
                if(this.disRadioOrder?.Is_Gift==true){
                    this.$alert('赠送的菜品无法调整数量', '提示', {confirmButtonText: '确定',});
                }else{
                    this.adjusquantityShow = true;
                }
            }
        },
        /**数量返回 */
        quantityReturn(number,assNumber,price,operations){
            if(this.BindPosFoods?.Food_ID){//单点菜品弹出的
                let item=Object.assign({isChangeNumPrice:true},this.BindPosFoods, {
                    Number:number,//修改的数量
                    AssSizeNumber:Number(assNumber),
                    Food_Price:price,//修改的价格
                    Operations:operations,//改价操作
                });
                this.BindPosFoods="";
                this.onPlaceFoods(item);
                this.adjusquantityShow = false;
                return;
            }
            this.adjusquantityShow = false;
            /**选择的口味 */
            if(this.disRadioOrder?.is_taste){
                if(this.disRadioOrder.Price_Kind==1 || this.disRadioOrder.Price_Kind==0){//按次加价 或 按量
                    this.orderMenuList[this.disRadioclass].Eat_Number= number
                    this.orderMenuList.forEach(order=>{
                        if(order.Eat_ConsumeID==this.disRadioOrder.Eat_ConsumeID && !order?.is_taste){
                            if(order.FoodModifys){
                                order.FoodModifys.forEach(item=>{
                                    if(item.Mas_AutoID==this.disRadioOrder.Mas_AutoID){
                                        item.Mas_Num=number
                                    }
                                })
                            }
                            /**有套餐 */
                            if(order.FoodSetmeals){
                                order.FoodSetmeals.forEach(food=>{
                                    if(food.FoodModifys){
                                        food.FoodModifys.forEach(item=>{
                                            if(item.Mas_AutoID==this.disRadioOrder.Mas_AutoID){
                                                item.Mas_Num=number
                                            }
                                        })
                                    }
                                })
                            }
                        }else{
                            if(order.FoodSetmeals){
                                order.FoodSetmeals.forEach(food=>{
                                    if(food.Eat_ConsumeID==this.disRadioOrder.Eat_ConsumeID){
                                        if(food.FoodModifys){
                                            food.FoodModifys.forEach(item=>{
                                                if(item.Mas_AutoID==this.disRadioOrder.Mas_AutoID){
                                                    item.Mas_Num=number
                                                }
                                            })
                                        }
                                    }
                                })
                            }
                        }
                    })
                }
            }else{
                /**普通菜品数量调整 */
                if(this.foodtype==0){
                    this.orderMenuList.forEach(order=>{
                        if(order.Eat_ConsumeID==this.disRadioOrder.Eat_ConsumeID){
                            /**有套餐 */
                            if(order.FoodSetmeals && order?.Is_SetMealCountAvgPrice==false){
                                order.FoodSetmeals.filter(it=>!it.Is_FixedNum).forEach(food=>{
                                    if(order.Eat_Number>1){
                                        food.FoodSetmeal_Number = food.FoodSetmeal_Number / order.Eat_Number
                                        food.FoodSetmeal_Number = Number(Number(Number(food.FoodSetmeal_Number) * number).toFixed(2))
                                    }else{
                                        food.FoodSetmeal_Number= Number(Number(Number(food.FoodSetmeal_Number) * number).toFixed(2))
                                    }
                                    if(food.FoodModifys){
                                        food.FoodModifys.forEach(item=>{
                                            if(item.Price_Kind==0){
                                                item.Mas_Num=food.FoodSetmeal_Number
                                            }
                                        })
                                        this.orderMenuList.forEach(or=>{
                                            if(or.Eat_ConsumeID==food.Eat_ConsumeID){
                                                if(or.Price_Kind==0){
                                                    or.Eat_Number=food.FoodSetmeal_Number
                                                }
                                            }
                                        })
                                    }
                                })
                            }
                            if(order.Price_Kind!=1){
                                order.Eat_Number=number;
                            }
                            if(order.FoodModifys){
                                order.FoodModifys.forEach(item=>{
                                    if(item.Price_Kind==0){
                                        item.Mas_Num=number
                                    }
                                })
                            }
                        }
                    })
                }else if(this.foodtype==1){
                    this.orderMenuList.forEach(order=>{
                        if(order.Eat_ConsumeID==this.choicefoodOrder.Eat_ConsumeID){
                            if(order?.is_taste){
                                if(order.Price_Kind==0){
                                    order.Eat_Number++
                                    if(order.FoodModifys){
                                        order.FoodModifys.forEach(item=>{
                                            if(item.Price_Kind==0){
                                                item.Mas_Num=number
                                            }
                                        })
                                    }
                                }
                            }else{
                                order.Eat_Number=number
                                if(order.FoodModifys){
                                    order.FoodModifys.forEach(item=>{
                                        if(item.Price_Kind==0){
                                            item.Mas_Num=number
                                        }
                                    })
                                }
                            }
                            if(order.FoodSetmeals && order?.Is_SetMealCountAvgPrice==false){
                                order.FoodSetmeals.forEach(food=>{
                                    food.FoodSetmeal_Number=number
                                    if(food.FoodModifys){
                                        food.FoodModifys.forEach(item=>{
                                            if(item.Price_Kind==0){
                                                item.Mas_Num=number
                                            }
                                        })
                                    }
                                })
                            }
                        }else{
                           if(order?.is_taste){
                                if(order.Eat_ConsumeID==this.disRadioOrder.Eat_ConsumeID){
                                    if(order?.Price_Kind==0){
                                        order.Eat_Number = number
                                    }
                                }
                            }
                        }
                    })
                }
            }
            if(this.orderMenuList[this.disRadioclass].Food_AssSize){
                this.orderMenuList[this.disRadioclass].AssSizeNumber = Number(assNumber);
            }
            if(price && operations){//改价
                let order=this.disRadioOrder;
                order.ConsumeOperations=[operations];
                order.Eat_CheckPrice = Number(price);
                order.Eat_SalePrice=Number(price);
            }
        },
        /**辅助单位选择返回 */
        assSizeConfirm(assSizeInfo,priceNum,assSizeNum){
            assSizeInfo = Object.assign(assSizeInfo, {Number:priceNum,AssSizeNumber:Number(assSizeNum)})
            this.onPlaceFoods(assSizeInfo)
            this.assSizeShow=false
        },
        /**改价*/
        clickPriceChange(){
            if(this.disRadioclass>-1){
                if(this.foodtype==1){
                    this.$message.warning('套餐菜品不允许改价', '提示', {confirmButtonText: '确定',});
                    return;
                }
                if(this.disRadioOrder.Eat_CheckMoney<=0){
                    this.$message.warning("该菜品无法调整");
                    return;
                }
                if(this.disRadioOrder?.is_taste){
                    this.$message.warning("口味无法调整");
                    return;
                }
                if(this.disRadioOrder.Food_Type==4){
                    this.$message.warning("口味无法调整");
                    return;
                }
                if(this.disRadioOrder?.Eat_TcItemList || this.disRadioOrder?.FoodSetmeals){
                    this.$message.warning("套餐菜品无法进行改价操作");
                    return
                }
                if(this.disRadioOrder.Is_Seasonal==false){
                    this.$message.warning("该菜品不是时价菜,不能改价");
                    return
                }
                if(this.disRadioOrder?.ConsumeOperations){
                    let OperateType= this.disRadioOrder?.ConsumeOperations[0]?.OperateType
                    if(OperateType==1){
                        this.$message.warning('该菜品已进行过折扣,无法再进行改价')
                    }else if(OperateType==2){
                        this.$message.warning('该菜品已进行过赠送,无法再进行改价')
                    }else if(OperateType==4){
                        this.$message.warning('该菜品已进行过会员价,无法再进行改价')
                    }else if(OperateType==5){
                        this.$message.warning('该菜品已设置促销价,无法再进行改价')
                    }else if(OperateType==6){
                        this.$message.warning('该菜品已进行过第二份折扣,无法再进行改价')
                    }else{
                        this.changePriceShow=true 
                    }
                }else{
                    this.changePriceShow=true 
                    
                }
            }else{
                this.$alert('请先选择左边的菜品', '提示', {confirmButtonText: '确定',});
            }
        },
        /**改价返回 */
        changepriceClick(price,reasontype,reasontContent){
            if(this.disRadioOrder){
                this.changePriceShow = false;
                let order=this.disRadioOrder;
                let _Operations={
                    OperateType:3,
                    OperateReason:reasontContent,
                    Operator:this.userInfo?.Login_Name,
                    Project_AutoID:'',
                    Project_Name:'',
                    Project_Kind:0,
                    Project_Rate:0,
                    Old_Price:order.Eat_SalePrice
                }
                if(!Object.keys(this.checkUser).length==0){
                    _Operations.Operator=this.checkUser.Login_Name; //获取用户id
                }
                if(order.ConsumeOperations?.length>0 && order.ConsumeOperations[0].OperateType==3){//有修改过价格 延用之前的原价
                    _Operations.Old_Price=order.ConsumeOperations[0].Old_Price
                }
                order.ConsumeOperations=[_Operations];
                order.Eat_CheckPrice = Number(price);
                order.Eat_SalePrice=Number(price);
                this.checkUser={}
            }
        },
        /**菜品换单位 */
        unitClick(){
            if(this.disRadioOrder?.is_taste){
                this.$alert('口味无法调整', '提示', {confirmButtonText: '确定',});
                return
            }
            if(this.disRadioclass>-1){
                let _foodtype=0
                this.multipleSizeFoods.map(food=>{
                    if(food.Food_ID==this.disRadioOrder.EAT_XFBMID){
                        _foodtype=1
                        this.theMultipleSizeFoods = food
                        this.unitShow=true
                        
                        this.unitType=1
                        return true
                    }else{
                        food.MultipleSizeFoods.some(mu=>{
                            if(mu.Food_ID==this.disRadioOrder.EAT_XFBMID){
                                _foodtype=1
                                this.theMultipleSizeFoods = food
                                this.unitShow=true
                                
                                this.unitType=1
                                return true
                            }
                        })
                    }
                })
                if(_foodtype==0){
                    this.$alert('该菜品没有多单位可更换', '提示', {
                        confirmButtonText: '确定',
                    });
                }
            }else{
                this.$alert('请先选择左边的菜品', '提示', {
                    confirmButtonText: '确定',
                });
            }
        },
        /**套餐下菜品点击 */
        EatTcClick(food,index,item){
            this.disRadioOrder = food
            this.choicefoodOrder=item
            this.foodSetmealsclass=index
            this.foodtype=1
            this.orderMenuList.forEach((order,i)=>{
                if(order.FoodSetmeals){
                    order.FoodSetmeals.forEach(fd=>{
                        if(fd.Eat_ConsumeID==food.Eat_ConsumeID){
                            this.disRadioclass=i;
                        }
                    })
                }
            })
        },
        /**
         * 套餐返回
         * @param {*} callBack 菜品加入购物车 后调用
         */
        setMealClick(setMealNum,posFoodSetMeal,callBack){
            /**1.套餐换菜返回,清理掉之前的 */
            if(this.tcChangeType==1){
                this.clickDelete(this.disRadioclass,this.disRadioOrder)
            }
            this.setMealShow = false;
            let _FoodSetmeals=[];
            let _setNumber= setMealNum
            this.orderNumber = setMealNum
            let SoldError=''

            let foodList=[];//记录套餐明细 口味做法
            /**添加到订单中 */
            posFoodSetMeal.SetMealInfo.SetMealKinds.forEach(item=>{
                item.SetMealDetails.forEach(food=>{
                    if(food.Is_Selected){
                        if(food.replaceItem){
                            if(food.replaceItem.Is_SoldOut){
                                SoldError=food.replaceItem.Food_Name+'已沽清,无法加入订单中'
                            }
                        }else{
                            if(food.Is_SoldOut){
                                SoldError=food.Food_Name+'已沽清,无法加入订单中'
                            }
                        }
                        
                        if(posFoodSetMeal?.Is_SetMealCountAvgPrice){
                            _setNumber = 1
                        }
                        let Food_Number=food.Food_Number * _setNumber;
                        if(item.Is_FixedNum){//套餐头修改数量，该分类下子菜数量不变
                            Food_Number=food.Food_Number;
                        }
                        let eatConsume={
                            SetMealDetail_ID:food.SetMealDetail_ID,
                            SubCategory_ID:food.SubCategory_ID,
                            FoodSetmeal_ID:food.Food_ID,
                            FoodSetmeal_Code:food.Food_Code,
                            FoodSetmeal_Name:food.Food_Name,
                            FoodSetmeal_Number:Food_Number,
                            FoodSetmeal_Price:food.Food_TcPrice,
                            FoodSetmeal_Size:food.Food_Size,
                            Food_CostPrice:food.Food_CostPrice,
                            FoodSaleMoney:0,
                            FoodModifys:null,
                            Is_FixedNum:item.Is_FixedNum,
                            Eat_MasName:'',
                            ModiPrice:0,
                            Food_Status:-1,
                            Eat_ConsumeID:newGuid()
                        }
                        if(food.replaceItem){//有替换菜
                            Object.assign(eatConsume,{
                                ReplaceFood_ID:food.replaceItem.Food_ID,
                                ReplaceFood_Code:food.replaceItem.Food_Code,
                                ReplaceFood_Name:food.replaceItem.Food_Name,
                                FoodSetmeal_Size:food.replaceItem.Food_Size,
                                Food_CostPrice:food.replaceItem.Food_CostPrice,
                            })
                        }
                        _FoodSetmeals.push(eatConsume)

                        if(food._FoodModifys){
                            foodList.push({
                                item:eatConsume,
                                FoodModifys:food._FoodModifys
                            });
                        }
                    }
                })
            })
            if(SoldError){
                this.$message.warning(SoldError);
                return
            }
            let _item={
                SubCategory_ID:posFoodSetMeal.SubCategory_ID,
                SubCategory_Code:posFoodSetMeal.SubCategory_Code,
                EAT_XFBMID:posFoodSetMeal.Food_ID,
                EAT_XFCode:posFoodSetMeal.Food_Code,
                EAT_XFName:posFoodSetMeal.Food_Name,
                Eat_Number:setMealNum,
                Eat_CheckPrice:posFoodSetMeal.Food_Price,
                ModiPrice:0,
                Eat_SalePrice:posFoodSetMeal.Food_Price,
                Eat_VipPrice:posFoodSetMeal.Food_VipPrice,
                Eat_MasName:'',
                Food_Status:-1,
                Food_Speed:'',
                Eat_XFSize:posFoodSetMeal.Food_Size,
                FoodModifys:null,
                FoodSetmeals:_FoodSetmeals,
                Is_Special:posFoodSetMeal.Is_Special,//是否是推荐菜
                Is_Discounted:posFoodSetMeal.Is_Discounted,
                Is_Seasonal:posFoodSetMeal.Is_Seasonal,
                RemainNum:posFoodSetMeal.RemainNum,
                Is_Limited:posFoodSetMeal.Is_Limited,
                Is_ChangedNum:posFoodSetMeal.Is_ChangedNum,
                Is_ChargeForService:posFoodSetMeal.Is_ChargeForService,
                Is_SetMeal:posFoodSetMeal.Is_SetMeal,
                FoodProperty_Dimension:'套',
                Is_SetMealCountAvgPrice:false, //是否是人均计价套餐
                OnlySupportIntNum:posFoodSetMeal.OnlySupportIntNum,//是否数量取整
                Eat_ConsumeID:newGuid(),
                Exchanged_Number:0,
                ConsumeOperations:[]
            };
            if(posFoodSetMeal?.Is_SetMealCountAvgPrice){
                _item.Is_SetMealCountAvgPrice = posFoodSetMeal?.Is_SetMealCountAvgPrice
            }
            //促销价 
            if(posFoodSetMeal?.Promotion_Price>=0){
                _item.Eat_CheckPrice = posFoodSetMeal?.Promotion_Price
                _item.Promotion_Price = posFoodSetMeal?.Promotion_Price
                _item.ConsumeOperations=[{OperateType:5}]
            }
            this.orderMenuList.push(_item);

            /**给套餐明细 添加口味做法 */
            foodList?.forEach(it=>{
                let _opt={disRadioOrder:it.item,optFlavors:it.FoodModifys}
                if(this.aloneMethod.length>0){
                    if(this.aloneMethod.findIndex(alone=>alone.disRadioOrder.Eat_ConsumeID===_opt.disRadioOrder.Eat_ConsumeID)==-1){
                        this.aloneMethod.push(_opt)
                    }
                    this.aloneMethod.some(alone=>{
                        if(alone.disRadioOrder.Eat_ConsumeID==_opt.disRadioOrder.Eat_ConsumeID){
                            alone.optFlavors = it.FoodModifys;
                            alone.disRadioOrder=_opt.disRadioOrder;
                        }
                    })
                }else{
                    this.aloneMethod.push(_opt)
                }
                this.synchMethods(it.FoodModifys,'',it.item);
            })


            this.radioClick(this.orderMenuList.length-1,_item);
            this.orderNumber='';
            if(typeof(callBack)=="function"){//有回调方法的
                callBack();
            }
        },
        /**组合菜品返回
         * @param comboFoodInfo 组合数据
         */
        comboConfirm(comboFoodInfo){
            /**1.组合菜品换菜返回,清理掉之前的 */
            if(this.editComboFoodInfo && this.editComboFoodInfo.Eat_ConsumeID){
                this.foodSetmealsclass=-1
                this.disRadioOrder =this.editComboFoodInfo;
                this.foodtype = 0
                this.choicefoodOrder=''
                this.clickDelete(this.disRadioclass,this.disRadioOrder);
            }
            this.isComboFoodShow = false;
            let _setNumber= comboFoodInfo.Food_Number;

            let Eat_TcAutoID_Batch=newGuid();
            let foodList=[];//记录组合明细 口味做法
            let tcIndex=1;
            let _item=this.getPlaceFood(comboFoodInfo);
            _item.Eat_Number=_setNumber;
            _item.Eat_TcIndex=tcIndex;
            _item.Eat_TcAutoID_Batch=Eat_TcAutoID_Batch;//组id
            
            if(comboFoodInfo._FoodModifys){
                foodList.push({
                    item:_item,
                    FoodModifys:comboFoodInfo._FoodModifys
                });
            }
            this.orderMenuList.push(_item);

            /**添加到订单中 */
            comboFoodInfo.ComboKinds.forEach(kind=>{
                kind.ComboKindFoods.forEach(food=>{
                    if(food.Is_Selected){
                        let eatConsume=this.getPlaceFood(food);
                        eatConsume.Kind_Name=kind.Kind_Name;
                        eatConsume.Eat_Number=food.Food_Number;
                        eatConsume.Eat_TcIndex=++tcIndex;
                        eatConsume.Eat_TcAutoID_Batch=Eat_TcAutoID_Batch;//组id
                        this.orderMenuList.push(eatConsume);
                        if(food._FoodModifys){
                            foodList.push({
                                item:eatConsume,
                                FoodModifys:food._FoodModifys
                            });
                        }
                    }
                })
            })
            
            /**给明细 添加口味做法 */
            foodList?.forEach(it=>{
                let _opt={disRadioOrder:it.item,optFlavors:it.FoodModifys}
                if(this.aloneMethod.length>0){
                    if(this.aloneMethod.findIndex(alone=>alone.disRadioOrder.Eat_ConsumeID===_opt.disRadioOrder.Eat_ConsumeID)==-1){
                        this.aloneMethod.push(_opt)
                    }
                    this.aloneMethod.some(alone=>{
                        if(alone.disRadioOrder.Eat_ConsumeID==_opt.disRadioOrder.Eat_ConsumeID){
                            alone.optFlavors = it.FoodModifys;
                            alone.disRadioOrder=_opt.disRadioOrder;
                        }
                    })
                }else{
                    this.aloneMethod.push(_opt)
                }
                this.synchMethods(it.FoodModifys,'',it.item);
            })
            this.radioClick(this.orderMenuList.length-1,_item);
            this.orderNumber=''
        },
        /**返回一个添加单品的数据 */
        getPlaceFood(item){
            let _item ={
                Eat_ConsumeID:newGuid(),
                Food_Type:1,
                SubCategory_ID:item.SubCategory_ID,
                SubCategory_Code:item.SubCategory_Code,
                EAT_XFBMID:item.Food_ID,
                EAT_XFCode:item.Food_Code,
                EAT_XFName:item.Food_Name,
                Eat_Number:1,
                Eat_CheckPrice:item.Food_Price,
                ModiPrice:0,
                Eat_SalePrice:item.Food_Price,
                Eat_VipPrice:item.Food_VipPrice,
                Eat_MasName:'',
                Food_Status:-1,
                Food_AssSize:item.Food_AssSize,
                AssSizeNumber:'',
                Eat_XFSize:item.Food_Size,
                FoodModifys:null,
                FoodSetmeals:null,
                Is_Special:item.Is_Special,//是否是推荐菜
                Is_Discounted:item.Is_Discounted,
                Is_Seasonal:item.Is_Seasonal,
                RemainNum:item.RemainNum,
                Is_Limited:item.Is_Limited,
                Is_ChangedNum:item.Is_ChangedNum,
                Is_ChargeForService:item.Is_ChargeForService,
                OnlySupportIntNum:item.OnlySupportIntNum,//是否数量取整
                Is_SetMeal:false,
                Promotion_Price:0,
                Exchanged_Number:0,
                ConsumeOperations:[]
            };
            //促销价
            if(item?.Is_Promotion && item?.Promotion_Price>=0){
                _item.Eat_CheckPrice = item?.Promotion_Price;
                _item.Promotion_Price = item?.Promotion_Price;
                _item.ConsumeOperations=[{OperateType:5}];
            }
            if(item.Food_AssSize){
                _item.Eat_Number= item.Number||0;
                _item.AssSizeNumber=item.AssSizeNumber||0;
            }
            return _item;
        },
        /**用餐渠道点击 */
        channeClick(item){
            this.Channellike = item.OrderChannel_AutoID;
            this.headingInfo.OrderChannel_AutoID= item.OrderChannel_AutoID;
            this.headingInfo.orderChannelName = item.OrderChannel_Name;
        },
        /**赠送 */
        clickGivereturn(type,item){
            if(this.disRadioclass>-1){
                if(this.disRadioOrder.isFullGive){//满赠
                    this.$message.warning('满赠活动赠送菜,无法调整');
                    return;
                }
                if(type==1 && this.disRadioOrder.Is_Gift==true){
                    this.$confirm('是否取消'+this.disRadioOrder.EAT_XFName+'的赠送', '提示', {
                        confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'})
                    .then(() => {
                        if(this.foodOperationRecord.length>0){
                            this.foodOperationRecord.forEach((food,index)=>{
                                if(food.foodType==1 && food.Eat_ConsumeID==this.disRadioOrder.Eat_ConsumeID){
                                    this.foodOperationRecord.splice(index,1)
                                    index--
                                }
                            })
                        }
                        this.disRadioOrder.Is_Gift=false
                        this.disRadioOrder.Eat_CheckPrice = this.disRadioOrder.Eat_SalePrice
                        this.discountMoneuy = this.discountMoneuy - Number(Number(this.disRadioOrder.Eat_Number) * Number(this.disRadioOrder.Eat_SalePrice)).toFixed(2)
                        this.disRadioOrder.ConsumeOperations=[]
                    }).catch(() => {
                    });
                    return
                }
                if((this.disRadioOrder.Eat_CheckMoney<=0 && this.disRadioOrder.Eat_TcAutoID_Batch=='' && this.disRadioOrder.Eat_Number==0) || this.disRadioOrder.Is_Gift==true){
                    this.$message.warning('该菜品无法调整')
                    return;
                }
                if(this.disRadioOrder.Eat_Number<=0){
                    this.$message.warning('没有可操作剩余数量')
                    return;
                }
                //套餐主菜   或 套餐明细
                if(this.disRadioOrder.FoodSetmeals!=null || this.disRadioOrder.FoodSetmeal_ID){
                    this.$message.warning('套餐菜品无法进行赠送调整')
                    return
                }
                if(this.foodtype==1 && !this.choicefoodOrder){
                    this.$message.warning('套餐菜品无法进行赠送调整')
                    return
                }
                this.recordFunctionCheck=item
                this.giveShow=true 
            }else{
                this.$alert('请先选择左边的菜品', '提示', {
                    confirmButtonText: '确定',
                });
            }
        },
        /**赠送返回 */
        GiveFoodFreeClick(orderNum,OperateAutoID,OperateContent,userInfo){
            let _type=0
            let _givingPrice = 0;//赠送金额
            this.orderMenuList.find(item=>{
                if(item.Eat_ConsumeID==this.disRadioOrder.Eat_ConsumeID){
                    if(!item?.is_taste){
                        item.is_discount =false
                        if(Number(Number(item.Eat_Number)-Number(orderNum))==0){//全赠送
                            _givingPrice = Number(orderNum) * item.Eat_CheckPrice
                            item.ConsumeOperations=[]
                            let _Operations={
                                OperateType:2,
                                OperateReason:OperateContent,
                                Operator:userInfo.Login_Name,
                                Project_AutoID:'',Project_Name:'',Project_Kind:0,Project_Rate:0,Old_Price:item.Eat_SalePrice
                            }
                            item.ConsumeOperations.push(_Operations)
                            this.discountMoneuy += _givingPrice
                            item.Eat_CheckPrice = 0
                            item.Is_Gift = true
                        }else{//部分赠送
                            _givingPrice = Number(orderNum) * item.Eat_CheckPrice
                            this.discountMoneuy += _givingPrice
                            item.Eat_Number = this.accSub(Number(orderNum),Number(item.Eat_Number))
                            _type=1
                        }
                        return true;
                    }
                }
            })
            let _newGuid=newGuid()
            if(_type==1){//赠送
                let _item ={
                    Eat_ConsumeID:_newGuid,
                    SubCategory_ID:this.disRadioOrder.SubCategory_ID,
                    SubCategory_Code:this.disRadioOrder.SubCategory_Code,
                    EAT_XFBMID:this.disRadioOrder.EAT_XFBMID,
                    EAT_XFCode:this.disRadioOrder.EAT_XFCode,
                    EAT_XFName:this.disRadioOrder.EAT_XFName,
                    Eat_Number: Number(orderNum),
                    Eat_CheckPrice:0,
                    ModiPrice:0,
                    Eat_SalePrice:this.disRadioOrder.Eat_SalePrice,
                    Eat_MasName:'',
                    Food_Status:-1,
                    Food_AssSize:this.disRadioOrder.Food_AssSize,
                    AssSizeNumber:'',
                    Eat_XFSize:this.disRadioOrder.Eat_XFSize,
                    FoodModifys:null,
                    FoodSetmeals:null,
                    Is_Special:this.disRadioOrder.Is_Special,//是否是推荐菜
                    Is_Discounted:this.disRadioOrder.Is_Discounted,
                    Is_Seasonal:this.disRadioOrder.Is_Seasonal,
                    RemainNum:this.disRadioOrder.RemainNum,
                    Is_Limited:this.disRadioOrder.Is_Limited,
                    Is_ChangedNum:this.disRadioOrder.Is_ChangedNum,
                    Is_ChargeForService:this.disRadioOrder.Is_ChargeForService,
                    Is_SetMeal:this.disRadioOrder.Is_SetMeal,
                    OnlySupportIntNum:this.disRadioOrder.OnlySupportIntNum,//是否数量取整
                    Is_Gift:true,
                    Exchanged_Number:0,
                    ConsumeOperations:[{
                        OperateType:2,
                        OperateReason:OperateContent,
                        Operator:userInfo.Login_Name,
                        Project_AutoID:'',Project_Name:'',Project_Kind:0,Project_Rate:0,Old_Price:this.disRadioOrder.Eat_SalePrice
                    }]
                };
                this.orderMenuList.push(_item);
                this.checkUser={}
            }
            /**查询菜品的赠送操作记录 */
            if(this.foodOperationRecord.length>0){
                let foodType=0
                this.foodOperationRecord.forEach(food=>{
                    if(food.foodType==1 && this.disRadioOrder.Eat_ConsumeID==food.Eat_ConsumeID){
                        food.givinPrice= food.givinPrice + _givingPrice
                        foodType=1
                    }
                })
                if(foodType==0){
                    this.addfoodOperaRe(_givingPrice,_newGuid,_type)
                }
            }else{
                this.addfoodOperaRe(_givingPrice,_newGuid,_type)
            }
            this.orderMenuList.forEach(item=>{
                if(item.Eat_ConsumeID==this.disRadioOrder.Eat_ConsumeID){
                    if(!item?.is_taste){
                        this.disRadioOrder = item
                    }
                }
            })
            this.giveShow = false;
        },
        addfoodOperaRe(_givingPrice,_newGuid,_type){
            let _foodOperaRecord={
                foodType:1, /**赠送操作 */
                givinPrice:_givingPrice, /**赠送金额 */
                Eat_ConsumeID:this.disRadioOrder.Eat_ConsumeID, /**操作的菜品 */
            }
            if(_type==1){
                _foodOperaRecord.Eat_ConsumeID=_newGuid
            }
            this.foodOperationRecord.push(_foodOperaRecord)
        },
        /**CRM界面返回 */
        memberCloseModel(){
            
            this.memberPayShow=false,this.wlivePayShow=false,this.newEnjoyShow=false,this.hdShow=false;
            if(this.IsMultipleCardPay==false && this.paymentHistory.length==0){
                this.orderMenuList = this.Temporaryorder
                this.choicePayType=[]
                this.orderMenuList.forEach(order=>{
                    if(order.Eat_SalePrice){
                        if(order?.ConsumeOperations?.length>0){
                            if(order?.ConsumeOperations[0].OperateType==4){//会员价
                                order.Eat_CheckPrice = order.Eat_SalePrice;
                                order.ConsumeOperations=[];
                                order.is_discount=false;
                            }else if(order?.ConsumeOperations[0].Is_MemberDiscount){//会员 折扣
                                order.Eat_CheckPrice = order.Eat_SalePrice;
                                order.ConsumeOperations=[];
                                order.is_discount=false;
                            }
                        }else{
                            order.Eat_CheckPrice = order.Eat_SalePrice;
                        }
                    }
                })
                this.carPriceType=false;
                this.QKOrderMain.forEach(item=>{
                    if(item.ProjectItem_Key=='MemberPrice'){
                        item.ProjectItem_Name='会员价'
                    }
                })
            }
        },
        /**扫码返回 */
        scanPaySuccessConfirm(data){
            this.scanCodePay=false;
            this.yinShiPayShow=false;
            this.yinShiYFPayShow=false;
            this.westStoredShow=false;
            if(data?.IsMultipleCardPay){//部分支付
                if(data.Payments.length>0){
                    this.paymentHistory=this.paymentHistory.filter(it=>it.Eat_PayDetailID);//排除没有提交的支付方式
                    data.Payments.forEach(pay=>{
                        if(!this.paymentHistory.some(it=>it.Eat_PayDetailID==pay.Eat_PayDetailID)){//判断不能有重复支付记录
                            let item={
                                Payment_ID:pay.Payment_ID, //支付方式ID
                                Payment_Code:pay.Payment_Code,  //支付方式编号
                                Payment_Name:pay.Payment_Name,  //支付方式名称
                                Payment_Type:pay.Payment_Type,  //支付方式类型
                                Payment_Money:Number(pay.Payment_Money), //支付方式金额
                                Payment_FactMoney:Number(pay.Payment_Money),  //支付实收金额
                                Qr_Code:"", //扫码付款码值
                                Card_No:"", //卡号
                                CouponInfo:null, //该支付金额核销的券信息
                                Time:this.Times(),
                                is_pay:true, /**付款记录是否写入POS */
                                Eat_PayDetailID:pay.Eat_PayDetailID, //支付明细的ID
                                Operator_Name:this.userInfo?.Login_Name /**操作员 */
                            }
                            this.paymentHistory.push(item);
                        }
                    })
                    this.EatAutoID = data.Eat_AutoID;
                    this.Timestamps = data.Timestamps;
                    this.IsMultipleCardPay = data.IsMultipleCardPay;
                }
            }else{
                this.$webBrowser.openAuxiliaryScreen({
                    PayStatus:true
                })
                this.emptydata()
            }
        },
        /**昆仑会员卡 券选中 返回不支付 */
        kunlunMultipleConfirm(data){
            console.log(data);
            if(data.Payments.length>0){
                this.paymentHistory=this.paymentHistory.filter(it=>it.Eat_PayDetailID);//排除没有提交的支付方式
                data.Payments.forEach(pay=>{
                    if(!this.paymentHistory.some(it=>it.Eat_PayDetailID==pay.Eat_PayDetailID)){//判断不能有重复支付记录
                        let item={
                            Payment_ID:pay.Payment_ID, //支付方式ID
                            Payment_Code:pay.Payment_Code,  //支付方式编号
                            Payment_Name:pay.Payment_Name,  //支付方式名称
                            Payment_Type:pay.Payment_Type,  //支付方式类型
                            Payment_Money:Number(pay.Payment_Money), //支付方式金额
                            Payment_FactMoney:Number(pay.Payment_Money),  //支付实收金额
                            Qr_Code:"", //扫码付款码值
                            Card_No:"", //卡号
                            CouponInfo:null, //该支付金额核销的券信息
                            Time:this.Times(),
                            is_pay:true, /**付款记录是否写入POS */
                            Eat_PayDetailID:pay.Eat_PayDetailID, //支付明细的ID
                            Operator_Name:this.userInfo?.Login_Name /**操作员 */
                        }
                        this.paymentHistory.push(item);
                    }
                })
            }
            this.kunlunPayShow=false
            this.EatAutoID = data.Eat_AutoID;
            this.Timestamps = data.Timestamps;
            this.IsMultipleCardPay = data.IsMultipleCardPay;
        },
        /**会员读卡返回 */
        memberCardBack(data){
            let _priceType=0
            this.orderMenuList.forEach(order=>{
                if(!order?.is_taste){
                    if(data?.EatConsumeList){
                        data?.EatConsumeList.forEach(eat=>{
                            if(order.Eat_ConsumeID==eat.Eat_ConsumeID && order.EAT_XFName==eat.Eat_XFBMName){
                                //先判断线上折扣 否则 执行会员价
                                if(Number(order.Eat_CheckPrice)!=Number(eat.Eat_ZkPrice)){//线上折扣
                                    order.Eat_CheckPrice= Number(eat.Eat_ZkPrice);
                                    if(eat.Remark&&eat.Remark!=''){
                                        order.Remark=eat.Remark;
                                    }
                                    if(eat.ConsumeOperations?.length>0){//菜品操作详情 //会员折扣
                                        
                                        let _Operations=Object.assign({
                                                OperateReason:"",
                                                Project_AutoID:"",
                                            },eat.ConsumeOperations[0],{
                                                Operator:this.userInfo?.Login_Name,
                                                Old_Price:order.Eat_SalePrice
                                            })
                                        if(!(Object.keys(this.checkUser).length==0)){
                                            _Operations.Operator=this.checkUser.Login_Name; //获取用户id
                                        }
                                        order.ConsumeOperations=[_Operations];//菜品操作详情
                                    }
                                }else if(data?.Is_Have_ParPrice==1){//执行会员价
                                    if(Number(order.Eat_CheckPrice)!= Number(order.Eat_VipPrice) && Number(eat.Eat_Price) == Number(eat.Eat_ZkPrice)){
                                        order.Eat_CheckPrice = Number(order.Eat_VipPrice);
                                        _priceType=1;
                                        let _Operations={
                                            OperateType:4,
                                            OperateReason:'',
                                            Operator:this.userInfo?.Login_Name,
                                            Project_AutoID:'',
                                            Project_Name:'',
                                            Project_Kind:0,
                                            Project_Rate:0,
                                            Old_Price:order.Eat_SalePrice
                                        }
                                        if(!(Object.keys(this.checkUser).length==0)){
                                            _Operations.Operator=this.checkUser.Login_Name; //获取用户id
                                        }
                                        if(!order.ConsumeOperations){
                                            order.ConsumeOperations=[];
                                        }
                                        order.ConsumeOperations.push(_Operations);//菜品操作详情
                                        if(eat.Remark&&eat.Remark!=''){
                                            order.Remark=eat.Remark
                                        }

                                    }
                                }
                            }
                        })
                    }else{
                        if(data?.Is_Have_ParPrice==1){//执行会员价
                            //未折扣
                            if(order.Eat_CheckPrice==order.Eat_SalePrice && Number(order.Eat_CheckPrice)!= Number(order.Eat_VipPrice)){
                                order.Eat_CheckPrice = Number(order.Eat_VipPrice);
                                _priceType=1;
                                let _Operations={
                                    OperateType:4,
                                    OperateReason:'',
                                    Operator:this.userInfo?.Login_Name,
                                    Project_AutoID:'',
                                    Project_Name:'',
                                    Project_Kind:0,
                                    Project_Rate:0,
                                    Old_Price:order.Eat_SalePrice
                                }
                                if(!(Object.keys(this.checkUser).length==0)){
                                    _Operations.Operator=this.checkUser.Login_Name; //获取用户id
                                }
                                if(!order.ConsumeOperations){
                                    order.ConsumeOperations=[];
                                }
                                order.ConsumeOperations.push(_Operations);//菜品操作详情
                            }
                        }
                    }
                }
            })
            
            if(_priceType==1){
                this.carPriceType=true
                this.QKOrderMain.map(item=>{
                    if(item.ProjectItem_Key=='MemberPrice'){
                        item.ProjectItem_Name='取消会员价'
                    }
                })
            }
            this.checkUser={}
        },
        /**光明爱护网折扣返回 */
        aiHuDiscountConfirm(data,meberInfo){
            this.discountSchemeClic(data);
            if(!this.meberInfo && meberInfo){//没有绑定过会员信息 替换成爱护网绑定的会员信息
                this.meberInfo=meberInfo;
            }
            this.aiHuShow=false;
        },
        /**折扣设置返回 */
        discountSchemeClic(data){
            this.orderMenuList.forEach(order=>{
                data.ResponseBody?.forEach(food=>{
                    if(order.Eat_ConsumeID==food.Eat_ConsumeID && !order?.is_taste){
                        order.Eat_CheckPrice = Number(Number(food.Food_CheckPrice))
                        if(food?.ConsumeOperations){
                            Object.assign(order,{is_discount:true})
                            let _price = Number(Number(Number(food.Food_Price) - Number(food.Food_CheckPrice)))
                            this.discountMoneuy += _price * order.Eat_Number;
                            order.ConsumeOperations = food?.ConsumeOperations;
                        }
                        if(order.FoodSetmeals){
                            order.FoodSetmeals.forEach(orfood=>{
                                orfood.OldFoodSetmeal_Price=orfood.FoodSetmeal_Price;
                                if(food.FoodSetmeals){
                                    food.FoodSetmeals.forEach(datafood=>{
                                        if(orfood.FoodSetmeal_ID==datafood.FoodSetmeal_ID){
                                            orfood.FoodSetmeal_Price =datafood.FoodSetmeal_Price
                                        }   
                                    })
                                }
                            })
                        }
                    }
                })
            })
            this.discountShow=false
        },
        /**取消折扣 */
        CancelDiscountConfirm(){
            let issucc=false;
            this.orderMenuList.forEach(order=>{
                if(order?.ConsumeOperations){
                    if(order?.ConsumeOperations[0]?.OperateType==1){
                        issucc=true;
                        let CheckPrice = order.Eat_CheckPrice * order.Eat_Number;
                        let SalePrice = order.Eat_SalePrice * order.Eat_Number;
                        this.discountMoneuy = Number(Number(Number(this.discountMoneuy) - (Number(SalePrice) - Number(CheckPrice))).toFixed(2));
                        order.Eat_CheckPrice = order.Eat_SalePrice;
                        order.is_discount=false;
                        order.ConsumeOperations=[];
                    }
                }
                if(order.FoodSetmeals){
                    order.FoodSetmeals?.forEach(orfood=>{
                        orfood.FoodSetmeal_Price=orfood.OldFoodSetmeal_Price;
                    })
                }
            })
            if(!issucc){
                this.$message.warning('没有折扣菜品可取消')
                return
            }else{
                this.$message.success("取消折扣成功");
                this.discountShow=false
                this.checkUser={}
            }
        },
        //取消指定折扣
        cancelDiscount(){
            this.orderMenuList.forEach(order=>{
                if(order?.ConsumeOperations && order.ConsumeOperations[0]?.Member_Sys==9){//海鼎卡 折扣 取消
                    order.Eat_CheckPrice = order.Eat_SalePrice;
                    order.is_discount=false;
                    order.ConsumeOperations=[];
                }
                if(order.FoodSetmeals){
                    order.FoodSetmeals?.forEach(orfood=>{
                        orfood.FoodSetmeal_Price=orfood.OldFoodSetmeal_Price;
                    })
                }
            })
        },
        /**支付弹窗 */
        payClick(item){
            console.log(item)
            let proKey=this.checkoutPermission()
            if(proKey==false){
                this.money=''
                this.$alert('您没有结账权限，请联系后台开通结账权限！', '提示', {confirmButtonText: '确定',});
                return
            }
            if(this.orderMenuList.length>0){
                if(this.DeskName=='' && _data.RunFastFoodMustChooseDeskNo==true){
                    this.$message.warning('请先去选择桌台')
                    return
                }
                if(_data.RunFastFoodWithSignCard==true && this.headingInfo.brandNumber==''){
                    this.$message.warning('请先去填写对应牌号')
                    return
                }
                this.choicePayType = item
                if(item.INTERFACE_TYPE==5){/**Ar支付 */
                    if(this.paymentHistory.length==0){
                        this.arShow=true
                    }else{
                        let payType= this.paymentHistory.some(pay=>{
                            if(pay.Payment_Type!=5){
                                return true
                            }
                        })
                        if(payType==true){
                            this.$message.warning(item.PAY_NAME+'不能和其他支付方式混用')
                        }else{
                            this.arShow=true
                        }
                    }
                }else if(item.INTERFACE_TYPE==801010301){/**聚合支付 */
                    this.scanCodePay=true
                }else if(item.INTERFACE_TYPE=="9052001"){/**银联商务聚合支付 */
                    this.scanCodePay=true
                }else if(item.INTERFACE_TYPE=="9056001"){/**壹钱包支付 */
                    this.scanCodePay=true
                }else if(item.INTERFACE_TYPE==801010302){//银石预付卡支付
                     this.yinShiYFPayShow=true;
                }else if(item.INTERFACE_TYPE=="9046001"){//银石智能POS支付
                    this.yinShiPayShow=true;
                }else if(item.INTERFACE_TYPE==801010401){/**正品CRM支付 */
                    this.Temporaryorder = this.orderMenuList
                    this.memberPayShow = true
                }else if(item.INTERFACE_TYPE==9022001){
                    this.Temporaryorder = this.orderMenuList
                    this.newEnjoyShow = true
                }else if(item.INTERFACE_TYPE==801010501){
                    /**微生活CRM支付 */
                    this.Temporaryorder = this.orderMenuList
                    this.wlivePayShow=true
                }else if(item.INTERFACE_TYPE==9030001){ /**海鼎 */
                    this.Temporaryorder = this.orderMenuList
                    this.hdShow=true;
                }else if(item.INTERFACE_TYPE=='7' || item.INTERFACE_TYPE=='8'){
                    /**现金券or商品券 */
                    this.paymentCouponsShow=true;
                    this.payCouponsData=item;
                }else if(item.INTERFACE_TYPE==9033001){
                    this.zpCouponShow=true
                    this.Temporaryorder = this.orderMenuList;
                }else if(item.INTERFACE_TYPE==9024001){//翼码卡券核销
                    this.ymCouponShow=true
                    this.Temporaryorder = this.orderMenuList;
                }else if(item.INTERFACE_TYPE=='9036002'){/**昆仑会员支付 */
                    this.Temporaryorder = this.orderMenuList
                    this.kunlunPayShow = true;
                    
                }else if(item.INTERFACE_TYPE=='9054001'){/**科码会员支付 */
                    this.Temporaryorder = this.orderMenuList
                    this.keMaPayShow = true;
                    
                } else if(item.INTERFACE_TYPE=='9044001'){/**大拈会员支付 */
                    this.Temporaryorder = this.orderMenuList
                    this.daNianPayShow = true;
                    
                }/*else if(item.INTERFACE_TYPE=='9026001'){//G9 会员支付
                    this.Temporaryorder = this.orderMenuList
                    this.gNinePayShow = true;
                    
                }*/
                else if(item.INTERFACE_TYPE=='9017002'){//西软XMS储值支付
                    this.westStoredShow=true;
                }else if(item.INTERFACE_TYPE=='9030002'){//海鼎企微劵&储值
                    this.defaultPayShow=true;
                }else if(item.INTERFACE_TYPE=='9030003'){//商旅会员劵
                    this.defaultPayShow=true;
                }else if(item.INTERFACE_TYPE=='9055001'){//龙之梦LPS储值
                    this.defaultPayShow=true;
                }
                else if(item.INTERFACE_TYPE=='9017004'){//西软券核销
                    this.westStoredCouponShow=true;
                }else if(item.INTERFACE_TYPE=='9049001'){//华侨城二消券核销
                    this.hqCouponShow=true;
                    this.Temporaryorder = this.orderMenuList;
                }else if(item.INTERFACE_TYPE==6){//支付类型为免单时
                    let payments=this.paymentHistory?.filter(it=>it.Payment_Type==6);//已经支付过免单
                    if(payments?.length>0 && payments.filter(it=>it.Payment_Money<0).length!=payments.length/2){
                        this.$message.warning('已免单操作过,不能重复操作!')
                        return;
                    }
                    this.freeShippingShow=true;
                }else{
                    /**现金支付 */
                    this.paymentShow=true;
                    this.payMoneyKey=new Date().getTime();
                }
            }else{
                this.$message.warning('请先选择菜品!')
            }
        },
        //更新订单待支付金额
        updatePay(data,Timestamps){ 
            if(data){
                data.Payments?.forEach(pay=>{
                    if(!this.paymentHistory.some(it=>it.Eat_PayDetailID==pay?.Eat_PayDetailID)){//判断不能有重复支付记录
                        let item={
                            Payment_ID:pay.Payment_ID, //支付方式ID
                            Payment_Code:pay.Payment_Code,  //支付方式编号
                            Payment_Name:pay.Payment_Name,  //支付方式名称
                            Payment_Type:pay.Payment_Type,  //支付方式类型
                            Payment_Money:Number(pay.Payment_Money), //支付方式金额
                            Payment_FactMoney:Number(pay.Payment_Money),  //支付实收金额
                            Qr_Code:"", //扫码付款码值
                            Card_No:"", //卡号
                            CouponInfo:null, //该支付金额核销的券信息
                            Time:this.Times(),
                            is_pay:true, /**付款记录是否写入POS */
                            Eat_PayDetailID:pay?.Eat_PayDetailID, //支付明细的ID
                            Operator_Name:this.userInfo?.Login_Name /**操作员 */
                        }
                        this.paymentHistory.push(item)
                    }
                })
                this.EatAutoID = data.Eat_AutoID
            }
            if(Timestamps){
                this.Timestamps = Timestamps
            }
        },
        /**更新订单 id 和 时间戳 */
        updateOrder(data){
            if(data){
                if(data.Eat_AutoID){
                    this.EatAutoID = data.Eat_AutoID;
                    this.Timestamps = data.Timestamps;
                }else{
                    this.EatAutoID="";
                    this.Timestamps="";
                }
            }
        },
        /**会员多卡返回 
         * @param data 支付返回数据
         * @param isOnePay 是否是只提交了单个支付方式
        */
        payMultipleConfirm(data,isOnePay){
            if(data.Payments.length>0){
                if(!isOnePay){//会员支付 是提交了所有没有提交的支付方式 已及当前会员支付后的 
                    this.paymentHistory=this.paymentHistory.filter(it=>it.Eat_PayDetailID);//排除没有提交的支付方式
                }
                data.Payments.forEach(pay=>{
                    if(!this.paymentHistory.some(it=>it.Eat_PayDetailID==pay.Eat_PayDetailID)){//判断不能有重复支付记录
                        let item={
                            Payment_ID:pay.Payment_ID, //支付方式ID
                            Payment_Code:pay.Payment_Code,  //支付方式编号
                            Payment_Name:pay.Payment_Name,  //支付方式名称
                            Payment_Type:pay.Payment_Type,  //支付方式类型
                            Payment_Money:Number(pay.Payment_Money), //支付方式金额
                            Payment_FactMoney:Number(pay.Payment_Money),  //支付实收金额
                            Qr_Code:"", //扫码付款码值
                            Card_No:"", //卡号
                            CouponInfo:null, //该支付金额核销的券信息
                            Time:this.Times(),
                            is_pay:true, /**付款记录是否写入POS */
                            Eat_PayDetailID:pay.Eat_PayDetailID, //支付明细的ID
                            Operator_Name:this.userInfo?.Login_Name /**操作员 */
                        }
                        this.paymentHistory.push(item);
                    }
                })
            }
            this.keMaPayShow=false;
            this.memberPayShow=false;
            this.hdShow=false;
            this.westStoredShow=false;
            this.defaultPayShow=false;
            this.EatAutoID = data.Eat_AutoID
            this.Timestamps = data.Timestamps
            this.IsMultipleCardPay = data.IsMultipleCardPay
        },
        /**添加已付记录 */
        paymetClick(data){
            let item={
                Payment_ID:this.choicePayType.PAY_ID, //支付方式ID
                Payment_Code:this.choicePayType.PAY_CODE,  //支付方式编号
                Payment_Name:this.choicePayType.PAY_NAME,  //支付方式名称
                Payment_Type:this.choicePayType.INTERFACE_TYPE,  //支付方式类型
                Payment_Money:Number(this.money), //支付方式金额
                Payment_FactMoney:Number(this.money),  //支付实收金额
                Qr_Code:"", //扫码付款码值
                Card_No:"", //卡号
                CouponInfo:null, //该支付金额核销的券信息
                Time:this.Times(),
                is_pay:false, /**付款记录是否写入POS */
                Eat_PayDetailID:'',
                Operator_Name:this.userInfo?.Login_Name /**操作员 */
            }
            if(data){
                Object.assign(item,data);
            }
            this.paymentHistory.push(item)
        },
        /**商品券和现金券返回 */
        payCouponsConfirm(selectTicketList){
            this.paymentCouponsShow=false
            if(selectTicketList){
                let counMoney = 0
                selectTicketList.forEach(tick=>{
                    let _choice={
                        Coupon_AutoId:tick.TK_AUTOID,
                        Coupon_Code:tick.TK_CODE,
                        Coupon_Name:tick.TK_NAME,
                        Coupon_Kind:tick.KIND,
                        Coupon_Num:tick.number,
                        Coupon_CostPrice:tick.EAT_SALEPRICE,
                        TicketUseRules:tick.TicketUseRules,//POS线下券使用规则
                    }
                    let OverChargeMoney=0
                    if( Number(tick.EAT_PRICE) * tick.number >= Number(this.unPaidMoney)){
                        OverChargeMoney = Number(tick.EAT_PRICE) * tick.number - Number(this.unPaidMoney)
                    }
                    let item={
                        Payment_ID:this.choicePayType.PAY_ID, //支付方式ID
                        Payment_Code:this.choicePayType.PAY_CODE,  //支付方式编号
                        Payment_Name:this.choicePayType.PAY_NAME,  //支付方式名称
                        Payment_Type:this.choicePayType.INTERFACE_TYPE,  //支付方式类型
                        Payment_Money:Number(Number(Number(tick.EAT_PRICE) * tick.number).toFixed(2)), //支付方式金额
                        OverCharge_Money:Number(Number(OverChargeMoney).toFixed(2)),  //支付实收金额
                        Qr_Code:"", //扫码付款码值
                        Card_No:"", //卡号
                        CouponInfo:_choice, //该支付金额核销的券信息
                        Time:this.Times(),
                        is_pay:false, /**付款记录是否写入POS */
                        Operator_Name:this.userInfo?.Login_Name /**操作员 */
                    }
                    this.paymentHistory.push(item)
                    counMoney = counMoney + Number(tick.EAT_PRICE) * tick.number
                })
                this.money=0
                if(Number(this.unPaidMoney).toFixed(2)<=0){
                    this.invoicingConfirm()
                }
            }
        },
        /**退款冲销 */
        deleteClick(index,item){
            /**判断是否有结账的权限 */
            let proKey=this.checkoutPermission()
            if(proKey==false){
                this.money=''
                this.$alert('您没有退款权限，请联系后台开通对应权限！', '提示', {confirmButtonText: '确定',});
                return
            }
            if(item.Payment_Name=='新享会券'){
                this.$message.warning('已核销,无法退款冲销');
                return
            }
            if(item.is_pay==true || (item.Payment_Type==801010301 || item.Payment_Type==801010401 || item.Payment_Type==801010501 || item.Payment_Type==9022001)){
                this.$confirm('<div style="position:absolute;line-height:80px;"><i class="iconfont icon-jinggao" style="color:#faad14;font-size:30px;"></i></div><span style="color:#000;font-size:23px;padding-left:50px;display:inline-block;">您确定<span style="color:red;">￥</span><span style="color:red;font-size:30px;">'+item.Payment_Money+'</span>&nbsp;['+item.Payment_Name+']&nbsp;&nbsp;退款吗?</span><br/><span style="color: rgb(153, 153, 153);font-size: 19px;display:inline-block;padding-left:50px;">该操作涉及财务退款,请谨慎操作!</span>', 
                '谨慎操作', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',cancelButtonText: '取消'
                }).then(() => {
                    let _Money=0
                    if(item.Is_Refund_YN==true){
                        _Money = item.Payment_Money-item.Refund_Money;
                    }else{
                        _Money = item.Payment_Money;
                    }
                    let param={
                        Body_ID:newGuid(),
                        User_ID:this.userInfo?.User_ID, //登陆用户ID
                        Operator_Name:this.userInfo?.Login_Name,//操作员
                        Eat_AutoID:this.EatAutoID,//结账单ID
                        Eat_CheckIndex:this.eatCheckIndex,//结账单号
                        Eat_PayDetailID:item.Eat_PayDetailID,//支付明细记录ID
                        Is_PartialRefund:false,//是否部分退款,不传默认false,代表支付金额全部退款
                        //Refund_Money:item.Payment_Money,//退款金额Is_PartialRefund为true时,传入退款金额
                        Refund_Reason:'',//退款原因
                        Timestamps:this.Timestamps.toString(),//时间戳
                    }
                    const loading = this.$loading({
                        text: "退款冲销中...",
                        spinner: "el-icon-loading",
                        background: "rgba(0, 0, 0, 0.7)",
                    });
                    this.$httpAES.post("Bestech.CloudPos.RefundPayment",param).then((data)=>{
                        loading.close();
                        if(data.ResponseHeader.ResultCode!=0){
                            this.$message.error(data.ResponseHeader.ResultDesc);
                        }else{
                            if(data.ResponseBody.Payments.length>0){
                                this.paymentHistory=this.paymentHistory.filter(it=>it.Eat_PayDetailID);//排除没有提交的支付方式
                                data.ResponseBody.Payments.forEach(pay=>{
                                    if(!this.paymentHistory.some(it=>it.Eat_PayDetailID==pay.Eat_PayDetailID)){//判断不能有重复支付记录
                                        let item={
                                            Payment_ID:pay.Payment_ID, //支付方式ID
                                            Payment_Code:pay.Payment_Code,  //支付方式编号
                                            Payment_Name:pay.Payment_Name,  //支付方式名称
                                            Payment_Type:pay.Payment_Type,  //支付方式类型
                                            Payment_Money:Number(pay.Payment_Money), //支付方式金额
                                            Payment_FactMoney:Number(pay.Payment_Money),  //支付实收金额
                                            Qr_Code:"", //扫码付款码值
                                            Card_No:"", //卡号
                                            CouponInfo:null, //该支付金额核销的券信息
                                            Time:this.Times(),
                                            is_pay:true, /**付款记录是否写入POS */
                                            Eat_PayDetailID:pay.Eat_PayDetailID, //支付明细的ID
                                            Operator_Name:this.userInfo?.Login_Name /**操作员 */
                                        }
                                        this.paymentHistory.push(item);
                                    }
                                })
                            }
                            this.money = item.Payment_Money
                            this.EatAutoID=data.ResponseBody.Eat_AutoID//结账单ID
                            this.Timestamps = data.ResponseBody.Timestamps.toString();
                            //如果冲销的是商品券则恢复菜品可使用的次数

                            this.merCouponFood.forEach((mer,i)=>{
                                if(mer.EatPayDetailID==item.Eat_PayDetailID){
                                    this.orderMenuList.forEach(order=>{
                                        if(mer.ConsumeID==order.Eat_ConsumeID){
                                            order.Exchanged_Number = this.accSub(1,order.Exchanged_Number)
                                        }
                                    })
                                    this.merCouponFood.splice(i,1)
                                    i--
                                }
                            })
                            this.$message.success("退款冲销成功");
                        }
                    })
                }).catch(() =>{});
            }else{
                this.paymentHistory.splice(index,1);
            }
        },
        cashConfirm(money,payParam){
            this.paymentShow = false;
            this.freeShippingShow=false;
            this.money = money;
            if(Number(this.money)> Number(this.unPaidMoney).toFixed(2)){
                this.onPayPreview(payParam)
            }else if(Number(this.money)== Number(this.unPaidMoney).toFixed(2)){
                this.paymetClick(payParam);//添加支付记录
                this.onPayPreview();
            }else{
                this.paymetClick(payParam)
            }
            this.money=0
        },
        Times(){
            let date = new Date();
            let year = date.getFullYear();
            let month = (date.getMonth() + 1).toString().padStart(2, '0');  // 月要+1
            let day = date.getDate().toString().padStart(2, '0');  // 获取天是getDate，而不是 getDay
            let hour = date.getHours().toString().padStart(2, '0');
            let minute = date.getMinutes().toString().padStart(2, '0');
            let second = date.getSeconds().toString().padStart(2, '0');
            let createTime = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
            return createTime;
        },
        getCurrentDateTime(time){
            let date = new Date(time);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? ('0' + MM) : MM;
            let d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            let h = date.getHours();
            h = h < 10 ? ('0' + h) : h;
            let m = date.getMinutes();
            m = m < 10 ? ('0' + m) : m;
            let s = date.getSeconds();
            s = s < 10 ? ('0' + s) : s;
            return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
        },
        /**选择桌号 */
        deskclose(desk){
            this.DeskName = desk.Desk_Name;
            this.RoomAutoID = desk.Room_AutoID;
            this.choiceDeskShow=false;
            this.$nextTick(()=>{
                if(this.DeskName ==desk.Desk_Name && this.$global.isFastDefaultDesk){//快餐模式下，默认桌台
                    this.$global.fastDefaultDesk={
                        Desk_AutoID:desk.Desk_AutoID,
                        Desk_Name:desk.Desk_Name,
                        Room_AutoID:desk.Room_AutoID
                    };
                }
            })
        },
        /**快餐支付预览 */
        onPayPreview:submitting(function(event,payParam){
            let proKey=this.checkoutPermission()
            if(proKey==false){
                this.money=''
                this.$alert('您没有结账权限，请联系后台开通结账权限！', '提示', {confirmButtonText: '确定',});
                return
            }
            if(this.choicePayType.PAY_ID==null && this.$route.params.data==''){
                this.$alert('请先选择支付类型', '提示', {confirmButtonText: '确定',});
                return
            }
            if(this.RoomAutoID==''){
                this.$alert('当前操作员可管理的餐厅区域为空', '提示', {confirmButtonText: '确定',});
                return
            }
            let FactMoney=[];
            if(this.paymentHistory.length>0){
                this.paymentHistory.forEach(pay=>{
                    if(pay.is_pay==false){
                        if(pay.Payment_Type==7 || pay.Payment_Type==8 ){
                            FactMoney.push({
                                Payment_ID:pay.Payment_ID, //支付方式ID
                                Payment_Code:pay.Payment_Code,  //支付方式编号
                                Payment_Name:pay.Payment_Name,  //支付方式名称
                                Payment_Type:pay.Payment_Type,  //支付方式类型
                                Payment_Money:pay.Payment_Money, //支付方式金额
                                OverCharge_Money:pay.OverCharge_Money,  //支付实收金额
                                Qr_Code:"", //扫码付款码值
                                Card_No:"", //卡号
                                CouponInfo:pay.CouponInfo, //该支付金额核销的券信息
                            });
                        }else{
                            FactMoney.push({
                                Payment_ID:pay.Payment_ID, //支付方式ID
                                Payment_Code:pay.Payment_Code,  //支付方式编号
                                Payment_Name:pay.Payment_Name,  //支付方式名称
                                Payment_Type:pay.Payment_Type,  //支付方式类型
                                Payment_Money:pay.Payment_Money, //支付方式金额
                                Payment_FactMoney:pay.Payment_FactMoney,  //支付实收金额
                                Qr_Code:"", //扫码付款码值
                                Card_No:"", //卡号
                                CouponInfo:pay.CouponInfo, //该支付金额核销的券信息
                                GiveFreeExtendInfo:pay.GiveFreeExtendInfo,//免单信息
                            });
                        }
                    }
                })
            }
            //当实付金额大于剩余结账金额时
            if(this.unPaidMoney>0 && Number(this.money)>this.unPaidMoney){
                let payJson={
                    Payment_ID:this.choicePayType.PAY_ID, //支付方式ID
                    Payment_Code:this.choicePayType.PAY_CODE,  //支付方式编号
                    Payment_Name:this.choicePayType.PAY_NAME,  //支付方式名称
                    Payment_Type:this.choicePayType.INTERFACE_TYPE,  //支付方式类型
                    Payment_Money:Number(this.money), //支付方式金额
                    Payment_FactMoney:Number(this.money),  //支付实收金额
                    Qr_Code:"", //扫码付款码值
                    Card_No:"", //卡号
                    CouponInfo:null, //该支付金额核销的券信息
                };
                if(payParam){
                    Object.assign(payJson,payParam);
                }
                FactMoney.push(payJson);
                FactMoney.push({
                    Payment_ID:this.choicePayType.PAY_ID, //支付方式ID
                    Payment_Code:this.choicePayType.PAY_CODE,  //支付方式编号
                    Payment_Name:this.choicePayType.PAY_NAME,  //支付方式名称
                    Payment_Type:this.choicePayType.INTERFACE_TYPE,  //支付方式类型
                    Payment_Money:Number(this.unPaidMoney)-Number(this.money), //支付方式金额
                    Payment_FactMoney:Number(this.unPaidMoney)-Number(this.money),  //支付实收金额
                    Qr_Code:"", //扫码付款码值
                    Card_No:"", //卡号
                    CouponInfo:null, //该支付金额核销的券信息
                });
            }
            this.userInfo=this.$auth.getUserInfo(); //获取用户id
            let _orderConsumes=this.$global.getFastOrderConsumes(this.orderMenuList);
            
            
            //支付预览
            let param={
                Body_ID:newGuid(),
                User_ID:this.userInfo?.User_ID,  //用户id
                Eat_AutoID:this.EatAutoID, //订单ID，当异常单重新处理时需要传入
                Timestamps:this.Timestamps.toString(),//订单单时间戳，当异常单重新处理时需要传入
                Operator_Name:this.userInfo?.Login_Name, //操作员
                Eat_PersonNum:this.headingInfo.DinersNum,//人数
                Channel_ID:this.Channellike,//订单渠道ID
                Room_ID:this.RoomAutoID,//餐厅ID
                Eat_DeskID:this.headingInfo?.DeskAutoID, //桌台ID
                Eat_DeskName:this.DeskName, //桌台名称
                Eat_TakeNo:this.headingInfo.brandNumber,//牌号
                Eat_AllRemark:'', //订单全单备注
                Order_Remark:this.headingInfo.orderRemark,//订单备注
                Order_BatchNo:newGuid(),//下单批次号，每次提交下单，调用方生成一个唯一批次号，接口判断防止重复下单
                NotSendToKitPrint:false,
                ElectronicInvoice_PrintForbidden:this.$global.isNoPrintInvoice,//是否选择禁止打印发票二维码 false: 默认打印发票二维码,true: 不打印发票二维码
                MantissaAdjustment_Money: Number(Number(this.MantissaMoney).toFixed(2)),//尾数调整金额
                Member:this.member,//会员信息
                OrderConsumes:_orderConsumes, //订单消费详细
                Payments:FactMoney,//支付方式
            }
            console.log("快餐支付预览 SnackPayPreview:",param);
            /**支付预览提交 */
            const loading = event.loading({
                text: "支付提交中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$httpAES.post("Bestech.CloudPos.SnackPayPreview",param).then((data)=>{
                loading.close();
                if(data.ResponseHeader.ResultCode!=0){
                    if(data.ResponseHeader.ResultCode==3008){//已结账完成的订单，快餐异常单查询支付结果时，如果返回该状态码，说明账单已结账
                        if(data.ResponseBody?.VoiceNotify){//语音提醒内容，如果返回不为空，前端可以发起一个语音播报
                            this.$webBrowser.tts(data.ResponseBody.VoiceNotify);
                        }
                        if(data.ResponseBody?.PrintsInfo){
                            setTimeout(()=>{
                                this.$webBrowser.posPrint(data.ResponseBody.PrintsInfo);
                            },500);
                        }
                        if(data.ResponseBody?.OpenCashBox==true){
                            this.$webBrowser.openCashBoxBnt().then(d=>{
                                if(d?.state!=0){
                                    this.$message.error('钱箱打开失败:'+(d?.message||""));
                                }
                            });
                        }
                        this.$message.success({ message: "支付完成"});
                        //支付成功
                        this.$webBrowser.openAuxiliaryScreen({
                            PayStatus:true
                        })
                        this.emptydata();
                        return;
                    }
                    this.$message.error(data.ResponseHeader.ResultDesc)
                    if(data.ResponseBody?.Timestamps){
                        this.orderInfo.Timestamps = data.ResponseBody?.Timestamps.toString()
                        this.Timestamps=data.ResponseBody?.Timestamps.toString()
                    }
                }else{
                    
                    /**需要短信验证 */
                    if(data.ResponseBody.Is_NeedSMSCode==1){
                        console.log('短信验证')
                        return
                    }
                    /**是否需要密码验证 */
                    if(data.ResponseBody.Is_NeedPassWord==1){
                        console.log('密码验证')
                        return
                    }
                    if(data.ResponseBody?.VoiceNotify){//语音提醒内容，如果返回不为空，前端可以发起一个语音播报
                        this.$webBrowser.tts(data.ResponseBody.VoiceNotify);
                    }
                    /**是否需要支付提交 0：不需要（说明快餐下单结账成功）， 1：需要（对接类支付方式预览后调用提交接口） */
                    if(data.ResponseBody.Is_NeedSubmit==0){
                        if(data.ResponseBody?.OpenCashBox==true){
                            this.$webBrowser.openCashBoxBnt().then(d=>{
                                if(d?.state!=0){
                                    this.$message.error('钱箱打开失败:'+(d?.message||""));
                                }
                            });
                        }
                        if(data.ResponseBody?.PrintsInfo){
                            setTimeout(()=>{
                                this.$webBrowser.posPrint(data.ResponseBody.PrintsInfo);
                            },500);
                        }
                        this.$message.success({ message: "支付完成"});
                        //支付成功
                        this.$webBrowser.openAuxiliaryScreen({
                            PayStatus:true
                        })
                        this.emptydata()
                    }else{
                        /**支付提交 */
                        this.PaySubmit(data)
                    }
                    
                }
            }).catch((e)=>{
                loading.close();
                this.$alert(e.message, "提示", {confirmButtonText: "确定"});
            })
        }),
        /**支付提交方法 */
        PaySubmit:submitting(function(event,data){
            let param={
                Body_ID:newGuid(),
                User_ID:this.userInfo?.User_ID, //登陆用户ID
                Eat_AutoID: data.ResponseBody.Eat_AutoID,//订单ID
                Member_Type:data.ResponseBody.Member_Type, //会员类型
                Biz_ID:data.ResponseBody.Biz_ID,//业务交易流ID
                MantissaAdjustMoney:Number(Number(this.MantissaMoney).toFixed(2)),//尾数调整金额
                Verify_Code:'',//验证码或密码
                Operator_Name:this.userInfo?.Login_Name, //操作员
                ElectronicInvoice_PrintForbidden:this.$global.isNoPrintInvoice,//是否选择禁止打印发票二维码 false: 默认打印发票二维码,true: 不打印发票二维码
                Timestamps:data.ResponseBody.Timestamps.toString(),
                Payments:data.ResponseBody.Payments //支付预览
            }
            /**支付提交 */
            const loading = event.loading({
                text: "支付提交中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$httpAES.post("Bestech.CloudPos.SnackPaySubmit",param).then((data)=>{
                loading.close();
                if(data.ResponseHeader.ResultCode!=0){
                    this.UnPaidMoney=0
                    if(data.ResponseBody?.Timestamps){
                        this.orderInfo.Timestamps = data.ResponseBody.Timestamps.toString()
                        this.Timestamps=data.ResponseBody?.Timestamps.toString()
                    }
                    this.$message.error(data.ResponseHeader.ResultDesc);
                }else{
                    
                    if(data.ResponseBody?.OpenCashBox==true){
                        this.$webBrowser.openCashBoxBnt().then(d=>{
                            if(d?.state!=0){
                                this.$message.error('钱箱打开失败:'+(d?.message||""));
                            }
                        });
                    }
                    if(data.ResponseBody?.PrintsInfo){
                        setTimeout(()=>{
                            this.$webBrowser.posPrint(data.ResponseBody.PrintsInfo);
                        },500);
                    }
                    this.$message.success({ message: "支付完成"});
                    this.$webBrowser.openAuxiliaryScreen({
                        PayStatus:true
                    })
                    this.emptydata()
                }
            }).catch((e)=>{
                loading.close();
                this.$alert(e.message, "提示", {confirmButtonText: "确定"});
            })
        }),
        /**其他功能页面返回 */
        subItemReturn(item){
             this.MiddleMenuClick({
                Is_Show:item.Is_Show,
                Permission:item.Permission,
                ProjectItem_Key:item.ProjectSubItem_Key,
                ProjectItem_Name:item.ProjectSubItem_Name,
                ProjectItem_Type:item.ProjectSubItem_Type,
            });
            this.subShow = false;
        },
        /**数字转换 */
        Conversion(num){
            return NumberConversion(num)
        },
        showKeyBoard(input,type){
            if(this.$refs.keyBoard.isOpen){
                this.$refs.keyBoard.close();
            }else{
                this.$refs.keyBoard.show(input,{type:type,isKeyDown:true});
                input.focus();
            }
        
        },
        /**判断是否有结账的权限 */
        checkoutPermission(){
            let proKey=false
            this.userCheckOutMenu.map(it=>{
                if(it.ProjectItem_Key=='CheckOut' && it.Permission==true){
                    proKey=true
                }
            })
            return proKey
        },
        searchInputBlur(){
            this.$refs.keyBoard.close();
        },
        /**查询支付结果返回 */
        ThePaymentResultClic(data,payCode){
            if(data.ResponseBody?.Payments){

                let _repay = false;
                data.ResponseBody.Payments.forEach(item=>{
                    if(!this.paymentHistory.some(pay=>pay.Eat_PayDetailID==item.Eat_PayDetailID)){
                        let param={
                            Payment_ID:item.Payment_ID, //支付方式ID
                            Payment_Code:item.Payment_Code,  //支付方式编号
                            Payment_Name:item.Payment_Name,  //支付方式名称
                            Payment_Type:item.Payment_Type,  //支付方式类型
                            Payment_Money:item.Payment_Money, //支付方式金额
                            Payment_FactMoney:item.Payment_FactMoney,  //支付实收金额
                            Qr_Code:payCode, //扫码付款码值
                            Card_No:"", //卡号
                            CouponInfo:null, //该支付金额核销的券信息
                            Time:this.Times(),
                            is_pay:true, /**付款记录是否写入POS */
                            Eat_PayDetailID:item.Eat_PayDetailID,
                            Operator_Name:item.Eat_Czy /**操作员 */
                        }
                        this.paymentHistory.push(param);
                        _repay=true;
                    }
                })
                
                if(_repay){
                    this.money=this.unPaidMoney;//剩余需要支付的金额
                    this.EatAutoID = data.ResponseBody.Eat_AutoID;
                    this.Timestamps = data.ResponseBody.Timestamps;
                    this.scanCodePay=false,this.memberPayShow=false,this.wlivePayShow=false,this.newEnjoyShow=false,this.hdShow=false;
                    this.yinShiPayShow=false;
                    this.yinShiYFPayShow=false;
                    this.daNianPayShow=false;
                    this.gNinePayShow=false;
                    this.kunlunPayShow=false;
                    this.westStoredShow=false;
                    this.keMaPayShow=false;
                    this.defaultPayShow=false;
                    if(this.unPaidMoney==0){//没有需要支付的才调用
                        this.onPayPreview();
                    }
                   
                }
            }
        },
        /**清除未记录到POS的支付方式 */
        paymentHistoryDelete(Payments){
            this.paymentHistory=this.paymentHistory.filter(it=>it.Eat_PayDetailID);//排除没有提交的支付方式
            Payments.forEach(item=>{
                if(!this.paymentHistory.some(pay=>pay.Eat_PayDetailID==item.Eat_PayDetailID)){
                    let param={
                        Payment_ID:item.Payment_ID, //支付方式ID
                        Payment_Code:item.Payment_Code,  //支付方式编号
                        Payment_Name:item.Payment_Name,  //支付方式名称
                        Payment_Type:item.Payment_Type,  //支付方式类型
                        Payment_Money:item.Payment_Money, //支付方式金额
                        Payment_FactMoney:item.Payment_FactMoney,  //支付实收金额
                        Qr_Code:'', //扫码付款码值
                        Card_No:"", //卡号
                        CouponInfo:null, //该支付金额核销的券信息
                        Time:this.Times(),
                        is_pay:true, /**付款记录是否写入POS */
                        Eat_PayDetailID:item.Eat_PayDetailID,
                        Operator_Name:item.Eat_Czy /**操作员 */
                    }
                    this.paymentHistory.push(param);
                }
            })
            
        },
        /**聚合支付保存历史时间戳 */
        ThePaymentResultTime(time){
            this.Timestamps = time
        },
        /**用餐渠道更新 */
        OrderChannelUpdate(){
            if(!this.Channellike){
                this.ChanneList.some((item)=>{
                    if(item.OrderChannel_AutoID==this.DefaultChannelID){
                        this.headingInfo.orderChannelName = item.OrderChannel_Name;
                        this.Channellike=item.OrderChannel_AutoID;
                    } 
                })
            }
            if(!this.orderChannel.some(it=>it.OrderChannel_AutoID==this.Channellike)){
                let orderChannel=[];
                if(this.ChanneList?.length>0){
                    let index=this.ChanneList.findIndex(it=>it.OrderChannel_AutoID==this.Channellike);
                    if(index>=0){
                        if(index==0 && index+1==this.ChanneList.length){
                            orderChannel.push(this.ChanneList[index]);
                        }else if(index+1!=this.ChanneList.length){
                            orderChannel.push(this.ChanneList[index]);
                            orderChannel.push(this.ChanneList[index+1]);
                        }else{
                            orderChannel.push(this.ChanneList[index-1]);
                            orderChannel.push(this.ChanneList[index]);
                        }
                    }
                }
                this.orderChannel=orderChannel;
            }
        },
        addNum(arg1, arg2) {//保留4个小数位 计算
            return Number((Number(arg1||0) +Number(arg2||0)).toFixed(4));
        },
        /**默认获取第一个餐厅ID */
        thefirstcanteenID(){
            if(this.PosRooms?.length>0){
                this.RoomAutoID = this.PosRooms[0].Room_AutoID;
            }
            //默认一个桌台
            if(this.$global.isFastDefaultDesk && this.$global.fastDefaultDesk){
                let defaultDesk=this.$global.fastDefaultDesk;
                this.PosRooms.some(pos=>{
                    return pos.PosDesks.some(item=>{
                        if(item.Desk_AutoID==defaultDesk.Desk_AutoID){
                            item.Room_AutoID=pos.Room_AutoID
                            this.deskclose(item);
                            return true;
                        }
                    })
                })
            }
        },
        /**昆仑卡券 或 正品卡券 核销返回 */
        couponsReturn(data){
            this.$message.success("卡券核销完成");
            this.$webBrowser.openAuxiliaryScreen({
                PayStatus:true
            })
            this.klCouponShow = false;
            this.couponVerifyShow = false;
            if(data?.ResponseBody){//接口返回成功后，相当于正常的结账流程，会返回单据打印信息，前端注意发起结账打印。
                if(data.ResponseBody.PrintsInfo){
                    this.$webBrowser.posPrint(data.ResponseBody.PrintsInfo);
                }
                if(data.ResponseBody.OpenCashBox){
                    this.$webBrowser.openCashBoxBnt().then(d=>{
                        if(d?.state!=0){
                            this.$message.error('钱箱打开失败:'+(d?.message||""));
                        }
                    });
                }
                if(data.ResponseBody.VoiceNotify){//语音提醒内容，如果返回不为空，前端可以发起一个语音播报
                    this.$webBrowser.tts(data.ResponseBody.VoiceNotify);
                }
            }
            this.emptydata()
        },
        submiConfirm(){
            this.arShow=false;
            this.zpCouponShow=false;
            this.ymCouponShow=false;
            this.westStoredCouponShow=false;
            this.hqCouponShow=false;
            this.$webBrowser.openAuxiliaryScreen({
                PayStatus:true
            })
            this.emptydata()
        },
        /**ar账/正品卡券核销支付记录返回保存*/
        subMultipleConfirm(data,selectCoupon){
            if(data.IsMultipleCardPay){//多支付
                if(data.Payments.length>0){
                    //ar挂账级 券核销 只能单支付, 不清除没有提交的支付方式
                    //this.paymentHistory=this.paymentHistory.filter(it=>it.Eat_PayDetailID);//排除没有提交的支付方式
                    data.Payments.forEach(pay=>{
                        if(!this.paymentHistory.some(it=>it.Eat_PayDetailID==pay.Eat_PayDetailID)){//判断不能有重复支付记录
                            let item={
                                Payment_ID:pay.Payment_ID, //支付方式ID
                                Payment_Code:pay.Payment_Code,  //支付方式编号
                                Payment_Name:pay.Payment_Name,  //支付方式名称
                                Payment_Type:pay.Payment_Type,  //支付方式类型
                                Payment_Money:Number(pay.Payment_Money), //支付方式金额
                                Payment_FactMoney:Number(pay.Payment_Money),  //支付实收金额
                                Qr_Code:"", //扫码付款码值
                                Card_No:"", //卡号
                                CouponInfo:null, //该支付金额核销的券信息
                                Time:this.Times(),
                                is_pay:true, /**付款记录是否写入POS */
                                Eat_PayDetailID:pay.Eat_PayDetailID, //支付明细的ID
                                Operator_Name:this.userInfo?.Login_Name /**操作员 */
                            }
                            this.paymentHistory.push(item);
                        }
                    });
                }
                this.arShow=false;
                this.zpCouponShow=false;
                this.ymCouponShow=false;
                this.hqCouponShow=false;
                this.westStoredCouponShow=false;
                this.EatAutoID = data.Eat_AutoID
                this.Timestamps = data.Timestamps
                this.IsMultipleCardPay = data.IsMultipleCardPay
                if(selectCoupon){
                    selectCoupon.forEach(se=>{
                        this.orderMenuList.forEach(order=>{
                            if(se.ConsumeID==order.Eat_ConsumeID){
                                order.Exchanged_Number = this.addNum(1,order.Exchanged_Number)
                                //记录菜品和消费过的券对应关系,退款冲销清掉
                                data.Payments.forEach(pay=>{
                                    let coufood={
                                        ConsumeID:se.ConsumeID,
                                        EatPayDetailID:pay.Eat_PayDetailID
                                    }
                                    this.merCouponFood.push(coufood)
                                }) 
                            }
                        })
                    })
                }
            }else{//支付完成
                this.submiConfirm();
            }
        },
        /**计算会员价 */
        FoodVipMoney(item){
            if(this.carPriceType==false){
                let _vipType=0
                this.orderMenuList.forEach(order=>{
                    if(order.Eat_VipPrice && order.ConsumeOperations.length==0){
                        if(order?.ConsumeOperations.length==0){
                            if(order.Eat_CheckPrice==order.Eat_SalePrice){
                                this.discountMoneuy += (order.Eat_CheckPrice - order.Eat_VipPrice) * order.Eat_Number
                                order.Eat_CheckPrice = order.Eat_VipPrice
                                order.ConsumeOperations=[]
                                let _Operations={
                                    OperateType:4,
                                    OperateReason:'',
                                    Operator:this.userInfo?.Login_Name,
                                    Project_AutoID:'',Project_Name:'',Project_Kind:0,Project_Rate:0,Old_Price:order.Eat_SalePrice
                                }
                                if(!Object.keys(this.checkUser).length==0){
                                    _Operations.Operator=this.checkUser.Login_Name; //获取用户id
                                }
                                order.ConsumeOperations.push(_Operations)
                                _vipType=1
                            }
                        }
                    }
                })
                if(_vipType==1){
                    this.$message.success('会员价调整完成')
                    this.carPriceType=true
                    item.ProjectItem_Name='取消会员价'
                }else{
                    this.$message.warning('没有需要计算会员价的菜品')
                }
            }else if(this.carPriceType==true){
                item.ProjectItem_Name='会员价'
                this.carPriceType=false 
                this.orderMenuList.forEach(order=>{
                    if(order.Eat_SalePrice){
                        if(order?.ConsumeOperations[0].OperateType==4){
                            order.Eat_CheckPrice = order.Eat_SalePrice
                            this.discountMoneuy -= (order.Eat_CheckPrice - order.Eat_VipPrice) * order.Eat_Number
                            order.ConsumeOperations=[]
                        }
                    }

                }) 
            }
            this.checkUser={}
        },
        paySuccessConfirm(){
            this.memberPayShow=false;
            this.wlivePayShow=false;
            this.newEnjoyShow=false;
            this.kunlunPayShow=false;
            this.keMaPayShow=false;
            this.daNianPayShow=false;
            this.gNinePayShow=false;
            this.hdShow=false;
            this.westStoredShow=false;
            this.defaultPayShow=false;
            this.$webBrowser.openAuxiliaryScreen({
                PayStatus:true
            })
            this.emptydata()
        },
        /**清空页面数据 */
        emptydata(){
            this.isAbnormal=false;
            this.Rpt_Date=false;
            this.orderMenuList=[],this.TemporderMenuList=[],this.masKinds=[],this.Temporaryorder=[],
            this.mallMethod=[], //全单口味做法
            this.aloneMethod=[], //单独口味做法
            this.choicePayType=[],this.prepaidshow=false,
            this.orderChannel=[],this.Channellike='',this.paymentHistory=[],this.assistSizeInfo={},
            this.Mantissa_Money=0;
            this.carPriceType=false,this.disRadioOrder={},
            this.disRadioclass=-1,this.foodSetmealsclass=-1,this.foodtype=0,this.paymentShow=false,
            this.DeskName='',this.meberInfo=null,this.EatAutoID='',this.Timestamps='',this.payCouponsData={},
            this.foodOperationRecord=[],this.$route.params.data='',this.IsMultipleCardPay=false,
            this.checkBtnlist='',this.checkUser={}
            this.DefaultChannelID = this.userInfo?.Default_ChannelID
            this.eatCheckIndex=''
            this.merCouponFood=[]
            this.headingInfo={
                DeskName:'',
                DeskAutoID:'',
                RoomAutoID:'',
                DinersNum:1,
                orderChannelName:'',
                OrderChannel_AutoID:'',
                brandNumber:'',
                orderRemark:''
            }
            this.OrderChannelUpdate()
            this.thefirstcanteenID()
            if(_data.RunFastFoodMustChooseDeskNo==true){
                this.choiceDeskShow=true
            }
            this.QKOrderMain.map(QK=>{
                if(QK.ProjectItem_Key=='MemberPrice'){
                    QK.ProjectItem_Name='会员价'
                }
            })
            setTimeout(() => {
                this.$refs.foodMenu.searchBoxFocus();
            },100);
            
        },
        //点击结账按钮
        invoicingConfirm(){
            this.onPayPreview()
        },
        //刷新菜品数据
        RefreshData(){
            const loading = this.$loading({
                text: "信息加载中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$cacheData.RefreshSoldInfo().then(()=>{
                loading.close();
            }).catch((e)=>{ 
                loading.close();
                this.$message.error("刷新失败:"+e.message);
            });
        },
        /**权限控制 */
        checkbtnReturn(date){
            this.checkShow = false;
            this.checkBtnlist.Permission = true;
            this.checkUser = date
            this.MiddleMenuClick(this.checkBtnlist)
        },
        /**重印上一单 */
        printPreViewBill(){
            let param={
                Body_ID:newGuid(),
                User_ID:this.userInfo?.User_ID,//用户id
                Operator_Name:this.userInfo?.Login_Name /**操作员 */
            }
            const loading = this.$loading({
                text: "重印上一单中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$httpAES.post("Bestech.CloudPos.ReprintPreviousOrder",param).then((data)=>{
                loading.close();
                if(data.ResponseHeader.ResultCode!=0){
                    this.$message.error(data.ResponseHeader.ResultDesc)
                    if(data.ResponseBody?.Timestamps){
                        this.orderInfo.Timestamps = data.ResponseBody?.Timestamps.toString()
                    }
                }else{
                    setTimeout(()=>{
                        this.$webBrowser.posPrint(data.ResponseBody);
                    },100);
                    this.$message.success("已发送打印指令");
                }
            }).catch((e)=>{
                loading.close();
                this.$alert(e.message, "提示", {confirmButtonText: "确定"});
            })
        },
        /**同步库存 */
        syncPosFood(){
            let param={
                Body_ID:newGuid(),
                User_ID:this.userInfo?.User_ID,//用户id
                Operator_Name:this.userInfo?.Login_Name /**操作员 */
            }
            const loading = this.$loading({
                text: "同步库存中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$httpAES.post("Bestech.CloudPos.SyncStkItemStockToPosFood",param).then((data)=>{
                loading.close();
                if(data.ResponseHeader.ResultCode!=0){
                    this.$message.error(data.ResponseHeader.ResultDesc);
                }else{
                    this.$message.success(data.ResponseHeader.ResultDesc||"同步成功");
                }
            }).catch((e)=>{
                loading.close();
                this.$alert(e.message, "提示", {confirmButtonText: "确定"});
            })
        },
        /**隐藏支付页面 */
        payHide(payType){
            if(this[payType]!=undefined){
                this[payType]=false;
                this.choicePayType=[];
            }
        },
        /**读卡识别菜品 
         * @param callback Function  返回 菜品id 数组
        */
        readCardFood(callback){
            if(!_data.Running_DtFoodCard_YN){
                this.$message.warning("该门店未注册读卡点菜功能!");
                return ;
            }
            const loading = this.$loading({
                text: "读卡中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.readCardOrder().then(ids=>{
                loading.setText("查找对应菜品中");
                console.log("卡数据：",ids)
                this.$httpAES.post("Bestech.CloudPos.GetDtCardsMappingFoods", {Card_NOList:ids}).then((d)=>{
                    loading.close();
                    if(d.ResponseHeader.ResultCode!=0){
                        this.$message.error(d.ResponseHeader.ResultDesc)
                        return;
                    }else{
                        typeof(callback)=="function" && callback(d.ResponseBody);
                    }
                }).catch((e)=>{
                    loading.close();
                    this.$alert("卡号绑定的菜品数据加载失败"+e.message, "提示", {confirmButtonText: "确定"});
                });
            }).catch(d=>{
                loading.close();
                this.$message.warning(d.message);
            })
        },
        /**读卡 返回多个卡数据 */
        readCardOrder(){
            return new Promise((resolve,reject) => {
                this.$webBrowser.getReadCardOrder().then(d=>{
                    if(d){
                        if(d.isEnableReadCard){
                            this.$webBrowser.readCardOrder(d.brand,d.port,d.baud).then(d=>{//读卡器开启成功
                                if(d && d.state==0){
                                    if(d.data?.length>0){
                                        resolve(d.data);
                                    }else{
                                        reject({message:'未读到卡数据!'})
                                    }
                                }else{
                                    console.log("读卡失败",d);
                                    reject({message:'未读到卡片'})
                                }
                            });
                        }else{
                            reject({message:'未启用读卡点菜功能!'})
                        }
                    }else{
                        reject({message:'读卡点菜未配置!'})
                    }
                });
            });
        },
        /**读卡点菜添加到数组中 */
        readCardAddFood(food){
            let SoloOutfood='',limitedProject='',cardNO=''
            food=food.filter(it=>{
                if(!it.EAT_XFBMID){
                    cardNO+=it.Card_NO+','
                    return false;
                }
                return true;
            })
            food.forEach(food=>{
                let pos=this.foodAll.find(pos=>food.EAT_XFBMID==pos.Food_ID)
                if(pos){
                    //已被沽清的菜品
                    if(pos.Is_SoldOut){
                        SoloOutfood+=pos.Food_Name+','
                        return true
                    }
                    //是否限量销售
                    if(pos.Is_Limited){
                        if(pos.RemainNum==0){
                            //是否有限量销售方案
                            if(pos.Is_LimitedProject){
                                limitedProject+=pos.Food_Name+','
                                return true
                            }
                        }
                    }
                    //点单时,相同菜品自动合并一行
                    if(_data.MergeSameFoodInOrder){
                        let order = this.orderMenuList.find(order=>!order.Is_Combo && order.EAT_XFBMID==pos.Food_ID && order.Food_Status==-1 && order.Eat_MasName=='' )
                        if(order){
                            order.Eat_Number++
                            if(pos.Food_AssSize){
                                order.AssSizeNumber ++
                            }
                        }else{
                            this.addFood(pos)
                        }
                    }else{
                        this.addFood(pos)
                    }
                }
            })
            if(cardNO){
                cardNO = cardNO.substring(0,cardNO.lastIndexOf(','))
                this.$message({
                    dangerouslyUseHTMLString:true,
                    message:'<div style="word-wrap:break-word;max-width:600px;win-width:100px;">'+cardNO+'</div>卡号下没有菜品信息',
                    type:'warning'
                })
            }
            if(SoloOutfood){
                SoloOutfood = SoloOutfood.substring(0,SoloOutfood.lastIndexOf(','))
                this.$message.warning(SoloOutfood+'是沽清的菜品,无法添加到订单中');
            }
            if(limitedProject){
                limitedProject = limitedProject.substring(0,limitedProject.lastIndexOf(','))
                this.$message.warning(SoloOutfood+'菜品已售完,无法添加到订单中');
            }
        },
        /**食方ai点菜添加到数组中 */
        SFAIAddFood(food){
            let SoloOutfood=[],limitedProject=[],foodName=[]
            
            food.forEach(food=>{
                let pos;
                this.foodAll.some(it=>{
                    if(!it.Is_SetMeal){//单菜
                        if(food.code==it.Food_Code){
                            pos=it;
                            return true;
                        }
                        return it.MultipleSizeFoods?.some(multip=>{
                            if(multip.Food_Code==food.code){
                                pos=multip;
                                return true;
                            }
                        });
                    }
                    return false;
                })
                if(pos){
                    //已被沽清的菜品
                    if(pos.Is_SoldOut){
                        SoloOutfood.push(pos.Food_Name);
                        return true
                    }
                    //是否限量销售
                    if(pos.Is_Limited){
                        if(pos.RemainNum==0){
                            //是否有限量销售方案
                            if(pos.Is_LimitedProject){
                                limitedProject.push(pos.Food_Name);
                                return true;
                            }
                        }
                    }
                    //点单时,相同菜品自动合并一行
                    if(_data.MergeSameFoodInOrder){
                        let order = this.orderMenuList.find(order=>!order.Is_Combo && order.EAT_XFBMID==pos.Food_ID && order.Food_Status==-1 && order.Eat_MasName=='' )
                        if(order){
                            order.Eat_Number++
                            if(pos.Food_AssSize){
                                order.AssSizeNumber ++
                            }
                        }else{
                            this.addFood(pos)
                        }
                    }else{
                        this.addFood(pos)
                    }
                }else{
                    foodName.push(food.name);
                }
            })
            let error="";
            if(foodName.length>0){
                error+= foodName.join(",") +'未查询到对应菜品信息,无法添加到订单中<br/>';
            }
            if(SoloOutfood.length>0){//沽清的菜品
                error+= SoloOutfood.join(",") +'是沽清的菜品,无法添加到订单中<br/>';
            }

            if(limitedProject.length>0){//菜品已售完
                error+= limitedProject.join(",") +'菜品已售完,无法添加到订单中<br/>';
            }
            if(error){
                this.$alert(error,  "提示", {
                    type:'warning',
                    dangerouslyUseHTMLString:true,
                    confirmButtonText: "确定"
                })
            }
        },
        addFood(pos){
            //添加到订单
            let _item ={
                Eat_ConsumeID:newGuid(),
                Food_Type:1,
                SubCategory_ID:pos.SubCategory_ID,
                EAT_XFBMID:pos.Food_ID,
                EAT_XFCode:pos.Food_Code,
                EAT_XFName:pos.Food_Name,
                Eat_Number:1,
                Eat_CheckPrice:pos.Food_Price,
                ModiPrice:0,
                Eat_SalePrice:pos.Food_Price,
                Eat_VipPrice:pos.Food_VipPrice,
                Food_CostPrice:pos.Food_CostPrice,//成本金额
                Eat_MasName:'',
                Food_Status:-1,
                Food_AssSize:pos.Food_AssSize,
                AssSizeNumber:'',
                Eat_XFSize:pos.Food_Size,
                FoodModifys:null,
                FoodSetmeals:null,
                Is_Special:pos.Is_Special,//是否是特色菜
                Is_Discounted:pos.Is_Discounted,
                Is_Seasonal:pos.Is_Seasonal,
                RemainNum:pos.RemainNum,
                Is_Limited:pos.Is_Limited,
                Is_ChangedNum:pos.Is_ChangedNum,
                Is_ChargeForService:pos.Is_ChargeForService,
                OnlySupportIntNum:pos.OnlySupportIntNum,//是否数量取整
                Is_SetMeal:pos.Is_SetMeal,
                Promotion_Price:0,
                Exchanged_Number:0,
                ConsumeOperations:[]
            };
            //促销价
            if(pos?.Is_Promotion && pos?.Promotion_Price>=0){
                _item.Eat_CheckPrice = pos?.Promotion_Price
                _item.Promotion_Price = pos?.Promotion_Price
                _item.ConsumeOperations=[{OperateType:5}]
            }
            //有辅助单位
            if(pos.Food_AssSize){
                _item.AssSizeNumber=1
            }
            this.orderMenuList.push(_item);
            this.radioClick(this.orderMenuList.length-1,_item);
        },
        /**当有弹层显示出来时 */
        modalShow(){
            this.$refs.foodMenu?.closeKeyBoard();//关闭键盘并标记
        },
        /**当所有弹层关闭时 */
        modalClose(){
            //获取焦点 并 显示键盘
            this.$refs.foodMenu?.showKeyBoard();
            setTimeout(()=>{
                this.isAiAddItem=false;
            },1000)
        },
        /**是否标准称重单位 */
        isUnitWeight(unit){
            if(unit=="斤" || unit=="公斤" || unit=="克" || unit=="市斤" || (unit||"").toUpperCase() =="KG" || (unit||"").toUpperCase()=="G" ){
                return true;
            }
            return false;
        },
        
        //AI点菜确认信息 弹层
        tipAddItemShow(item,countdown){
            if(!this.isAiAddItem && !this.isModalShow){
                this.isAiAddItem=true;
                console.log(this.aiAddItemShow)
                this.aiAddItemData={
                    food:item,
                    countdown:countdown
                }
                this.aiAddItemShow=true;
            }
        },
        /**AI点菜确认信息 弹层 返回 */
        aiAddItemConfirm(item){
            console.log(item)
            this.aiAddItemShow=false;
            this.orderNumber="";
            this.wgNum=0;
            this.onPlaceFoods(item);
            
        },
        /**扫码付款 */
        payCode(code){
            if(!this.isModalShow && this.$global.isFastScanCodePay){//没有弹层时
                if(this.payTypeSSPay!=[] && this.payTypeSSPay){//有聚合支付权限
                    this.payClick(this.payTypeSSPay);
                    if(this.scanCodePay){
                        this.$nextTick(()=>{
                            console.log("付款码",code);
                            if(this.$refs.scanPayModel){//弹出了聚合支付界面
                                setTimeout(()=>{
                                    if(this.$refs.scanPayModel && this.scanCodePay){//弹层有显示并且有对应节点
                                        this.$refs.scanPayModel.payCode=code;
                                        this.$refs.scanPayModel.confirm();//去支付
                                    }
                                },500);
                            }
                        })
                    }
                }
            }
        },
        /**应付金额返回 */
        popupReturn(number){
            this.popShow=false;
            if(this.totalOrderMoney.unPaidMoney!=Number(number)){
                this.Mantissa_Money= Number(this.totalOrderMoney.MantissaMoney).compute(this.totalOrderMoney.unPaidMoney,-number);

                if(this.Mantissa_Money<0){
                    this.Mantissa_Money=0;
                }
            }
            
        },
    },
    //被卸载时
    unmounted(){
        this.$webBrowser.off("openYoyoAi");
        this.$webBrowser.off("openSFAi");
        this.$shortcutKey.setFun();
        this.$webBrowser.openAuxiliaryScreen({bill:[],showType:0});//显示副屏 关闭账单显示
    }
}
</script>
<style lang="scss">
@import "./fastFoodDetail.scss";
</style>